/**
 * Generated by the protoc-gen-ts.  DO NOT EDIT!
 * compiler version: 7.34.1
 * source: auth/auth.proto
 * git: https://github.com/thesayyn/protoc-gen-ts */
import * as dependency_1 from "./../google/api/annotations";
import * as dependency_2 from "./status";
import * as dependency_3 from "./../google/protobuf/timestamp";
import * as dependency_4 from "./../common/pagination";
import * as pb_1 from "google-protobuf";
import * as grpc_1 from "@grpc/grpc-js";
import * as grpc_web_1 from "grpc-web";
export namespace auth.v1 {
    export enum UserType {
        USER_TYPE_UNSPECIFIED = 0,
        USER_TYPE_CONSUMER = 1,
        USER_TYPE_ADMINISTRATOR = 2
    }
    export enum MethodValidationCode {
        METHOD_VALIDATION_CODE_UNSPECIFIED = 0,
        METHOD_VALIDATION_CODE_EMAIL = 1,
        METHOD_VALIDATION_CODE_SMS = 2,
        METHOD_VALIDATION_CODE_PASSWORD_LESS_VERIFICATION = 3,
        METHOD_VALIDATION_CODE_PASSWORD_RESET_BY_EMAIL = 4,
        METHOD_VALIDATION_CODE_PASSWORD_RESET_BY_PHONE = 5
    }
    export enum CodeChallengeMethod {
        CODE_CHALLENGE_METHOD_UNSPECIFIED = 0,
        CODE_CHALLENGE_METHOD_S256 = 1
    }
    export class ConfirmPasswordChangeRequest extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            session?: string;
            newPassword?: string;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("session" in data && data.session != undefined) {
                    this.session = data.session;
                }
                if ("newPassword" in data && data.newPassword != undefined) {
                    this.newPassword = data.newPassword;
                }
            }
        }
        get session() {
            return pb_1.Message.getFieldWithDefault(this, 1, "") as string;
        }
        set session(value: string) {
            pb_1.Message.setField(this, 1, value);
        }
        get newPassword() {
            return pb_1.Message.getFieldWithDefault(this, 2, "") as string;
        }
        set newPassword(value: string) {
            pb_1.Message.setField(this, 2, value);
        }
        static fromObject(data: {
            session?: string;
            newPassword?: string;
        }): ConfirmPasswordChangeRequest {
            const message = new ConfirmPasswordChangeRequest({});
            if (data.session != null) {
                message.session = data.session;
            }
            if (data.newPassword != null) {
                message.newPassword = data.newPassword;
            }
            return message;
        }
        toObject() {
            const data: {
                session?: string;
                newPassword?: string;
            } = {};
            if (this.session != null) {
                data.session = this.session;
            }
            if (this.newPassword != null) {
                data.newPassword = this.newPassword;
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.session.length)
                writer.writeString(1, this.session);
            if (this.newPassword.length)
                writer.writeString(2, this.newPassword);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): ConfirmPasswordChangeRequest {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new ConfirmPasswordChangeRequest();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.session = reader.readString();
                        break;
                    case 2:
                        message.newPassword = reader.readString();
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): ConfirmPasswordChangeRequest {
            return ConfirmPasswordChangeRequest.deserialize(bytes);
        }
    }
    export class ConfirmPasswordChangeResponse extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {}) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") { }
        }
        static fromObject(data: {}): ConfirmPasswordChangeResponse {
            const message = new ConfirmPasswordChangeResponse({});
            return message;
        }
        toObject() {
            const data: {} = {};
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): ConfirmPasswordChangeResponse {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new ConfirmPasswordChangeResponse();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): ConfirmPasswordChangeResponse {
            return ConfirmPasswordChangeResponse.deserialize(bytes);
        }
    }
    export class GetRolesRequest extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {}) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") { }
        }
        static fromObject(data: {}): GetRolesRequest {
            const message = new GetRolesRequest({});
            return message;
        }
        toObject() {
            const data: {} = {};
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): GetRolesRequest {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new GetRolesRequest();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): GetRolesRequest {
            return GetRolesRequest.deserialize(bytes);
        }
    }
    export class GetRolesResponse extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            roles?: Role[];
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [1], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("roles" in data && data.roles != undefined) {
                    this.roles = data.roles;
                }
            }
        }
        get roles() {
            return pb_1.Message.getRepeatedWrapperField(this, Role, 1) as Role[];
        }
        set roles(value: Role[]) {
            pb_1.Message.setRepeatedWrapperField(this, 1, value);
        }
        static fromObject(data: {
            roles?: ReturnType<typeof Role.prototype.toObject>[];
        }): GetRolesResponse {
            const message = new GetRolesResponse({});
            if (data.roles != null) {
                message.roles = data.roles.map(item => Role.fromObject(item));
            }
            return message;
        }
        toObject() {
            const data: {
                roles?: ReturnType<typeof Role.prototype.toObject>[];
            } = {};
            if (this.roles != null) {
                data.roles = this.roles.map((item: Role) => item.toObject());
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.roles.length)
                writer.writeRepeatedMessage(1, this.roles, (item: Role) => item.serialize(writer));
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): GetRolesResponse {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new GetRolesResponse();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        reader.readMessage(message.roles, () => pb_1.Message.addToRepeatedWrapperField(message, 1, Role.deserialize(reader), Role));
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): GetRolesResponse {
            return GetRolesResponse.deserialize(bytes);
        }
    }
    export class Role extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            id?: string;
            label?: string;
            features?: Map<string, boolean>;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("id" in data && data.id != undefined) {
                    this.id = data.id;
                }
                if ("label" in data && data.label != undefined) {
                    this.label = data.label;
                }
                if ("features" in data && data.features != undefined) {
                    this.features = data.features;
                }
            }
            if (!this.features)
                this.features = new Map();
        }
        get id() {
            return pb_1.Message.getFieldWithDefault(this, 1, "") as string;
        }
        set id(value: string) {
            pb_1.Message.setField(this, 1, value);
        }
        get label() {
            return pb_1.Message.getFieldWithDefault(this, 2, "") as string;
        }
        set label(value: string) {
            pb_1.Message.setField(this, 2, value);
        }
        get features() {
            return pb_1.Message.getField(this, 3) as any as Map<string, boolean>;
        }
        set features(value: Map<string, boolean>) {
            pb_1.Message.setField(this, 3, value as any);
        }
        static fromObject(data: {
            id?: string;
            label?: string;
            features?: {
                [key: string]: boolean;
            };
        }): Role {
            const message = new Role({});
            if (data.id != null) {
                message.id = data.id;
            }
            if (data.label != null) {
                message.label = data.label;
            }
            if (typeof data.features == "object") {
                message.features = new Map(Object.entries(data.features));
            }
            return message;
        }
        toObject() {
            const data: {
                id?: string;
                label?: string;
                features?: {
                    [key: string]: boolean;
                };
            } = {};
            if (this.id != null) {
                data.id = this.id;
            }
            if (this.label != null) {
                data.label = this.label;
            }
            if (this.features != null) {
                data.features = (Object.fromEntries)(this.features);
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.id.length)
                writer.writeString(1, this.id);
            if (this.label.length)
                writer.writeString(2, this.label);
            for (const [key, value] of this.features) {
                writer.writeMessage(3, this.features, () => {
                    writer.writeString(1, key);
                    writer.writeBool(2, value);
                });
            }
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): Role {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new Role();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.id = reader.readString();
                        break;
                    case 2:
                        message.label = reader.readString();
                        break;
                    case 3:
                        reader.readMessage(message, () => pb_1.Map.deserializeBinary(message.features as any, reader, reader.readString, reader.readBool));
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): Role {
            return Role.deserialize(bytes);
        }
    }
    export class UpdateRolesRequest extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            roles?: Role[];
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [1], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("roles" in data && data.roles != undefined) {
                    this.roles = data.roles;
                }
            }
        }
        get roles() {
            return pb_1.Message.getRepeatedWrapperField(this, Role, 1) as Role[];
        }
        set roles(value: Role[]) {
            pb_1.Message.setRepeatedWrapperField(this, 1, value);
        }
        static fromObject(data: {
            roles?: ReturnType<typeof Role.prototype.toObject>[];
        }): UpdateRolesRequest {
            const message = new UpdateRolesRequest({});
            if (data.roles != null) {
                message.roles = data.roles.map(item => Role.fromObject(item));
            }
            return message;
        }
        toObject() {
            const data: {
                roles?: ReturnType<typeof Role.prototype.toObject>[];
            } = {};
            if (this.roles != null) {
                data.roles = this.roles.map((item: Role) => item.toObject());
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.roles.length)
                writer.writeRepeatedMessage(1, this.roles, (item: Role) => item.serialize(writer));
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): UpdateRolesRequest {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new UpdateRolesRequest();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        reader.readMessage(message.roles, () => pb_1.Message.addToRepeatedWrapperField(message, 1, Role.deserialize(reader), Role));
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): UpdateRolesRequest {
            return UpdateRolesRequest.deserialize(bytes);
        }
    }
    export class UpdateRolesResponse extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {}) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") { }
        }
        static fromObject(data: {}): UpdateRolesResponse {
            const message = new UpdateRolesResponse({});
            return message;
        }
        toObject() {
            const data: {} = {};
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): UpdateRolesResponse {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new UpdateRolesResponse();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): UpdateRolesResponse {
            return UpdateRolesResponse.deserialize(bytes);
        }
    }
    export class GetUserMenuRequest extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {}) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") { }
        }
        static fromObject(data: {}): GetUserMenuRequest {
            const message = new GetUserMenuRequest({});
            return message;
        }
        toObject() {
            const data: {} = {};
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): GetUserMenuRequest {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new GetUserMenuRequest();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): GetUserMenuRequest {
            return GetUserMenuRequest.deserialize(bytes);
        }
    }
    export class GetUserMenuResponse extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            menu?: string[];
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [1], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("menu" in data && data.menu != undefined) {
                    this.menu = data.menu;
                }
            }
        }
        get menu() {
            return pb_1.Message.getFieldWithDefault(this, 1, []) as string[];
        }
        set menu(value: string[]) {
            pb_1.Message.setField(this, 1, value);
        }
        static fromObject(data: {
            menu?: string[];
        }): GetUserMenuResponse {
            const message = new GetUserMenuResponse({});
            if (data.menu != null) {
                message.menu = data.menu;
            }
            return message;
        }
        toObject() {
            const data: {
                menu?: string[];
            } = {};
            if (this.menu != null) {
                data.menu = this.menu;
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.menu.length)
                writer.writeRepeatedString(1, this.menu);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): GetUserMenuResponse {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new GetUserMenuResponse();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        pb_1.Message.addToRepeatedField(message, 1, reader.readString());
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): GetUserMenuResponse {
            return GetUserMenuResponse.deserialize(bytes);
        }
    }
    export class GetUserPermissionsRequest extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {}) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") { }
        }
        static fromObject(data: {}): GetUserPermissionsRequest {
            const message = new GetUserPermissionsRequest({});
            return message;
        }
        toObject() {
            const data: {} = {};
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): GetUserPermissionsRequest {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new GetUserPermissionsRequest();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): GetUserPermissionsRequest {
            return GetUserPermissionsRequest.deserialize(bytes);
        }
    }
    export class GetUserPermissionsResponse extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            permissions?: string[];
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [1], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("permissions" in data && data.permissions != undefined) {
                    this.permissions = data.permissions;
                }
            }
        }
        get permissions() {
            return pb_1.Message.getFieldWithDefault(this, 1, []) as string[];
        }
        set permissions(value: string[]) {
            pb_1.Message.setField(this, 1, value);
        }
        static fromObject(data: {
            permissions?: string[];
        }): GetUserPermissionsResponse {
            const message = new GetUserPermissionsResponse({});
            if (data.permissions != null) {
                message.permissions = data.permissions;
            }
            return message;
        }
        toObject() {
            const data: {
                permissions?: string[];
            } = {};
            if (this.permissions != null) {
                data.permissions = this.permissions;
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.permissions.length)
                writer.writeRepeatedString(1, this.permissions);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): GetUserPermissionsResponse {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new GetUserPermissionsResponse();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        pb_1.Message.addToRepeatedField(message, 1, reader.readString());
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): GetUserPermissionsResponse {
            return GetUserPermissionsResponse.deserialize(bytes);
        }
    }
    export class MigrateUserRequest extends pb_1.Message {
        #one_of_decls: number[][] = [[12], [13]];
        constructor(data?: any[] | ({
            username?: string;
            email?: string;
            phone?: string;
            tenantId?: string;
            firstName?: string;
            lastName?: string;
            organizationId?: string;
            workspaceId?: string;
            externalId?: string;
            address?: Address;
            document?: string;
        } & (({
            companyName?: string;
        }) | ({
            birthDate?: dependency_3.google.protobuf.Timestamp;
        })))) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("username" in data && data.username != undefined) {
                    this.username = data.username;
                }
                if ("email" in data && data.email != undefined) {
                    this.email = data.email;
                }
                if ("phone" in data && data.phone != undefined) {
                    this.phone = data.phone;
                }
                if ("tenantId" in data && data.tenantId != undefined) {
                    this.tenantId = data.tenantId;
                }
                if ("firstName" in data && data.firstName != undefined) {
                    this.firstName = data.firstName;
                }
                if ("lastName" in data && data.lastName != undefined) {
                    this.lastName = data.lastName;
                }
                if ("organizationId" in data && data.organizationId != undefined) {
                    this.organizationId = data.organizationId;
                }
                if ("workspaceId" in data && data.workspaceId != undefined) {
                    this.workspaceId = data.workspaceId;
                }
                if ("externalId" in data && data.externalId != undefined) {
                    this.externalId = data.externalId;
                }
                if ("address" in data && data.address != undefined) {
                    this.address = data.address;
                }
                if ("document" in data && data.document != undefined) {
                    this.document = data.document;
                }
                if ("companyName" in data && data.companyName != undefined) {
                    this.companyName = data.companyName;
                }
                if ("birthDate" in data && data.birthDate != undefined) {
                    this.birthDate = data.birthDate;
                }
            }
        }
        get username() {
            return pb_1.Message.getFieldWithDefault(this, 1, "") as string;
        }
        set username(value: string) {
            pb_1.Message.setField(this, 1, value);
        }
        get email() {
            return pb_1.Message.getFieldWithDefault(this, 2, "") as string;
        }
        set email(value: string) {
            pb_1.Message.setField(this, 2, value);
        }
        get phone() {
            return pb_1.Message.getFieldWithDefault(this, 3, "") as string;
        }
        set phone(value: string) {
            pb_1.Message.setField(this, 3, value);
        }
        get tenantId() {
            return pb_1.Message.getFieldWithDefault(this, 4, "") as string;
        }
        set tenantId(value: string) {
            pb_1.Message.setField(this, 4, value);
        }
        get firstName() {
            return pb_1.Message.getFieldWithDefault(this, 5, "") as string;
        }
        set firstName(value: string) {
            pb_1.Message.setField(this, 5, value);
        }
        get lastName() {
            return pb_1.Message.getFieldWithDefault(this, 6, "") as string;
        }
        set lastName(value: string) {
            pb_1.Message.setField(this, 6, value);
        }
        get organizationId() {
            return pb_1.Message.getFieldWithDefault(this, 7, "") as string;
        }
        set organizationId(value: string) {
            pb_1.Message.setField(this, 7, value);
        }
        get workspaceId() {
            return pb_1.Message.getFieldWithDefault(this, 8, "") as string;
        }
        set workspaceId(value: string) {
            pb_1.Message.setField(this, 8, value);
        }
        get externalId() {
            return pb_1.Message.getFieldWithDefault(this, 9, "") as string;
        }
        set externalId(value: string) {
            pb_1.Message.setField(this, 9, value);
        }
        get address() {
            return pb_1.Message.getWrapperField(this, Address, 10) as Address;
        }
        set address(value: Address) {
            pb_1.Message.setWrapperField(this, 10, value);
        }
        get hasAddress() {
            return pb_1.Message.getField(this, 10) != null;
        }
        get document() {
            return pb_1.Message.getFieldWithDefault(this, 11, "") as string;
        }
        set document(value: string) {
            pb_1.Message.setField(this, 11, value);
        }
        get companyName() {
            return pb_1.Message.getFieldWithDefault(this, 12, "") as string;
        }
        set companyName(value: string) {
            pb_1.Message.setOneofField(this, 12, this.#one_of_decls[0], value);
        }
        get hasCompanyName() {
            return pb_1.Message.getField(this, 12) != null;
        }
        get birthDate() {
            return pb_1.Message.getWrapperField(this, dependency_3.google.protobuf.Timestamp, 13) as dependency_3.google.protobuf.Timestamp;
        }
        set birthDate(value: dependency_3.google.protobuf.Timestamp) {
            pb_1.Message.setOneofWrapperField(this, 13, this.#one_of_decls[1], value);
        }
        get hasBirthDate() {
            return pb_1.Message.getField(this, 13) != null;
        }
        get _company_name() {
            const cases: {
                [index: number]: "none" | "companyName";
            } = {
                0: "none",
                12: "companyName"
            };
            return cases[pb_1.Message.computeOneofCase(this, [12])];
        }
        get _birth_date() {
            const cases: {
                [index: number]: "none" | "birthDate";
            } = {
                0: "none",
                13: "birthDate"
            };
            return cases[pb_1.Message.computeOneofCase(this, [13])];
        }
        static fromObject(data: {
            username?: string;
            email?: string;
            phone?: string;
            tenantId?: string;
            firstName?: string;
            lastName?: string;
            organizationId?: string;
            workspaceId?: string;
            externalId?: string;
            address?: ReturnType<typeof Address.prototype.toObject>;
            document?: string;
            companyName?: string;
            birthDate?: ReturnType<typeof dependency_3.google.protobuf.Timestamp.prototype.toObject>;
        }): MigrateUserRequest {
            const message = new MigrateUserRequest({});
            if (data.username != null) {
                message.username = data.username;
            }
            if (data.email != null) {
                message.email = data.email;
            }
            if (data.phone != null) {
                message.phone = data.phone;
            }
            if (data.tenantId != null) {
                message.tenantId = data.tenantId;
            }
            if (data.firstName != null) {
                message.firstName = data.firstName;
            }
            if (data.lastName != null) {
                message.lastName = data.lastName;
            }
            if (data.organizationId != null) {
                message.organizationId = data.organizationId;
            }
            if (data.workspaceId != null) {
                message.workspaceId = data.workspaceId;
            }
            if (data.externalId != null) {
                message.externalId = data.externalId;
            }
            if (data.address != null) {
                message.address = Address.fromObject(data.address);
            }
            if (data.document != null) {
                message.document = data.document;
            }
            if (data.companyName != null) {
                message.companyName = data.companyName;
            }
            if (data.birthDate != null) {
                message.birthDate = dependency_3.google.protobuf.Timestamp.fromObject(data.birthDate);
            }
            return message;
        }
        toObject() {
            const data: {
                username?: string;
                email?: string;
                phone?: string;
                tenantId?: string;
                firstName?: string;
                lastName?: string;
                organizationId?: string;
                workspaceId?: string;
                externalId?: string;
                address?: ReturnType<typeof Address.prototype.toObject>;
                document?: string;
                companyName?: string;
                birthDate?: ReturnType<typeof dependency_3.google.protobuf.Timestamp.prototype.toObject>;
            } = {};
            if (this.username != null) {
                data.username = this.username;
            }
            if (this.email != null) {
                data.email = this.email;
            }
            if (this.phone != null) {
                data.phone = this.phone;
            }
            if (this.tenantId != null) {
                data.tenantId = this.tenantId;
            }
            if (this.firstName != null) {
                data.firstName = this.firstName;
            }
            if (this.lastName != null) {
                data.lastName = this.lastName;
            }
            if (this.organizationId != null) {
                data.organizationId = this.organizationId;
            }
            if (this.workspaceId != null) {
                data.workspaceId = this.workspaceId;
            }
            if (this.externalId != null) {
                data.externalId = this.externalId;
            }
            if (this.address != null) {
                data.address = this.address.toObject();
            }
            if (this.document != null) {
                data.document = this.document;
            }
            if (this.companyName != null) {
                data.companyName = this.companyName;
            }
            if (this.birthDate != null) {
                data.birthDate = this.birthDate.toObject();
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.username.length)
                writer.writeString(1, this.username);
            if (this.email.length)
                writer.writeString(2, this.email);
            if (this.phone.length)
                writer.writeString(3, this.phone);
            if (this.tenantId.length)
                writer.writeString(4, this.tenantId);
            if (this.firstName.length)
                writer.writeString(5, this.firstName);
            if (this.lastName.length)
                writer.writeString(6, this.lastName);
            if (this.organizationId.length)
                writer.writeString(7, this.organizationId);
            if (this.workspaceId.length)
                writer.writeString(8, this.workspaceId);
            if (this.externalId.length)
                writer.writeString(9, this.externalId);
            if (this.hasAddress)
                writer.writeMessage(10, this.address, () => this.address.serialize(writer));
            if (this.document.length)
                writer.writeString(11, this.document);
            if (this.hasCompanyName)
                writer.writeString(12, this.companyName);
            if (this.hasBirthDate)
                writer.writeMessage(13, this.birthDate, () => this.birthDate.serialize(writer));
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): MigrateUserRequest {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new MigrateUserRequest();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.username = reader.readString();
                        break;
                    case 2:
                        message.email = reader.readString();
                        break;
                    case 3:
                        message.phone = reader.readString();
                        break;
                    case 4:
                        message.tenantId = reader.readString();
                        break;
                    case 5:
                        message.firstName = reader.readString();
                        break;
                    case 6:
                        message.lastName = reader.readString();
                        break;
                    case 7:
                        message.organizationId = reader.readString();
                        break;
                    case 8:
                        message.workspaceId = reader.readString();
                        break;
                    case 9:
                        message.externalId = reader.readString();
                        break;
                    case 10:
                        reader.readMessage(message.address, () => message.address = Address.deserialize(reader));
                        break;
                    case 11:
                        message.document = reader.readString();
                        break;
                    case 12:
                        message.companyName = reader.readString();
                        break;
                    case 13:
                        reader.readMessage(message.birthDate, () => message.birthDate = dependency_3.google.protobuf.Timestamp.deserialize(reader));
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): MigrateUserRequest {
            return MigrateUserRequest.deserialize(bytes);
        }
    }
    export class MigrateUserResponse extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            userId?: string;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("userId" in data && data.userId != undefined) {
                    this.userId = data.userId;
                }
            }
        }
        get userId() {
            return pb_1.Message.getFieldWithDefault(this, 1, "") as string;
        }
        set userId(value: string) {
            pb_1.Message.setField(this, 1, value);
        }
        static fromObject(data: {
            userId?: string;
        }): MigrateUserResponse {
            const message = new MigrateUserResponse({});
            if (data.userId != null) {
                message.userId = data.userId;
            }
            return message;
        }
        toObject() {
            const data: {
                userId?: string;
            } = {};
            if (this.userId != null) {
                data.userId = this.userId;
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.userId.length)
                writer.writeString(1, this.userId);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): MigrateUserResponse {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new MigrateUserResponse();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.userId = reader.readString();
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): MigrateUserResponse {
            return MigrateUserResponse.deserialize(bytes);
        }
    }
    export class Address extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            id?: string;
            zipCode?: string;
            street?: string;
            number?: string;
            complement?: string;
            neighborhood?: string;
            city?: string;
            state?: string;
            country?: string;
            isDefault?: boolean;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("id" in data && data.id != undefined) {
                    this.id = data.id;
                }
                if ("zipCode" in data && data.zipCode != undefined) {
                    this.zipCode = data.zipCode;
                }
                if ("street" in data && data.street != undefined) {
                    this.street = data.street;
                }
                if ("number" in data && data.number != undefined) {
                    this.number = data.number;
                }
                if ("complement" in data && data.complement != undefined) {
                    this.complement = data.complement;
                }
                if ("neighborhood" in data && data.neighborhood != undefined) {
                    this.neighborhood = data.neighborhood;
                }
                if ("city" in data && data.city != undefined) {
                    this.city = data.city;
                }
                if ("state" in data && data.state != undefined) {
                    this.state = data.state;
                }
                if ("country" in data && data.country != undefined) {
                    this.country = data.country;
                }
                if ("isDefault" in data && data.isDefault != undefined) {
                    this.isDefault = data.isDefault;
                }
            }
        }
        get id() {
            return pb_1.Message.getFieldWithDefault(this, 1, "") as string;
        }
        set id(value: string) {
            pb_1.Message.setField(this, 1, value);
        }
        get zipCode() {
            return pb_1.Message.getFieldWithDefault(this, 2, "") as string;
        }
        set zipCode(value: string) {
            pb_1.Message.setField(this, 2, value);
        }
        get street() {
            return pb_1.Message.getFieldWithDefault(this, 3, "") as string;
        }
        set street(value: string) {
            pb_1.Message.setField(this, 3, value);
        }
        get number() {
            return pb_1.Message.getFieldWithDefault(this, 4, "") as string;
        }
        set number(value: string) {
            pb_1.Message.setField(this, 4, value);
        }
        get complement() {
            return pb_1.Message.getFieldWithDefault(this, 5, "") as string;
        }
        set complement(value: string) {
            pb_1.Message.setField(this, 5, value);
        }
        get neighborhood() {
            return pb_1.Message.getFieldWithDefault(this, 6, "") as string;
        }
        set neighborhood(value: string) {
            pb_1.Message.setField(this, 6, value);
        }
        get city() {
            return pb_1.Message.getFieldWithDefault(this, 7, "") as string;
        }
        set city(value: string) {
            pb_1.Message.setField(this, 7, value);
        }
        get state() {
            return pb_1.Message.getFieldWithDefault(this, 8, "") as string;
        }
        set state(value: string) {
            pb_1.Message.setField(this, 8, value);
        }
        get country() {
            return pb_1.Message.getFieldWithDefault(this, 9, "") as string;
        }
        set country(value: string) {
            pb_1.Message.setField(this, 9, value);
        }
        get isDefault() {
            return pb_1.Message.getFieldWithDefault(this, 10, false) as boolean;
        }
        set isDefault(value: boolean) {
            pb_1.Message.setField(this, 10, value);
        }
        static fromObject(data: {
            id?: string;
            zipCode?: string;
            street?: string;
            number?: string;
            complement?: string;
            neighborhood?: string;
            city?: string;
            state?: string;
            country?: string;
            isDefault?: boolean;
        }): Address {
            const message = new Address({});
            if (data.id != null) {
                message.id = data.id;
            }
            if (data.zipCode != null) {
                message.zipCode = data.zipCode;
            }
            if (data.street != null) {
                message.street = data.street;
            }
            if (data.number != null) {
                message.number = data.number;
            }
            if (data.complement != null) {
                message.complement = data.complement;
            }
            if (data.neighborhood != null) {
                message.neighborhood = data.neighborhood;
            }
            if (data.city != null) {
                message.city = data.city;
            }
            if (data.state != null) {
                message.state = data.state;
            }
            if (data.country != null) {
                message.country = data.country;
            }
            if (data.isDefault != null) {
                message.isDefault = data.isDefault;
            }
            return message;
        }
        toObject() {
            const data: {
                id?: string;
                zipCode?: string;
                street?: string;
                number?: string;
                complement?: string;
                neighborhood?: string;
                city?: string;
                state?: string;
                country?: string;
                isDefault?: boolean;
            } = {};
            if (this.id != null) {
                data.id = this.id;
            }
            if (this.zipCode != null) {
                data.zipCode = this.zipCode;
            }
            if (this.street != null) {
                data.street = this.street;
            }
            if (this.number != null) {
                data.number = this.number;
            }
            if (this.complement != null) {
                data.complement = this.complement;
            }
            if (this.neighborhood != null) {
                data.neighborhood = this.neighborhood;
            }
            if (this.city != null) {
                data.city = this.city;
            }
            if (this.state != null) {
                data.state = this.state;
            }
            if (this.country != null) {
                data.country = this.country;
            }
            if (this.isDefault != null) {
                data.isDefault = this.isDefault;
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.id.length)
                writer.writeString(1, this.id);
            if (this.zipCode.length)
                writer.writeString(2, this.zipCode);
            if (this.street.length)
                writer.writeString(3, this.street);
            if (this.number.length)
                writer.writeString(4, this.number);
            if (this.complement.length)
                writer.writeString(5, this.complement);
            if (this.neighborhood.length)
                writer.writeString(6, this.neighborhood);
            if (this.city.length)
                writer.writeString(7, this.city);
            if (this.state.length)
                writer.writeString(8, this.state);
            if (this.country.length)
                writer.writeString(9, this.country);
            if (this.isDefault != false)
                writer.writeBool(10, this.isDefault);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): Address {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new Address();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.id = reader.readString();
                        break;
                    case 2:
                        message.zipCode = reader.readString();
                        break;
                    case 3:
                        message.street = reader.readString();
                        break;
                    case 4:
                        message.number = reader.readString();
                        break;
                    case 5:
                        message.complement = reader.readString();
                        break;
                    case 6:
                        message.neighborhood = reader.readString();
                        break;
                    case 7:
                        message.city = reader.readString();
                        break;
                    case 8:
                        message.state = reader.readString();
                        break;
                    case 9:
                        message.country = reader.readString();
                        break;
                    case 10:
                        message.isDefault = reader.readBool();
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): Address {
            return Address.deserialize(bytes);
        }
    }
    export class UpsertAddressRequest extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            address?: Address;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("address" in data && data.address != undefined) {
                    this.address = data.address;
                }
            }
        }
        get address() {
            return pb_1.Message.getWrapperField(this, Address, 1) as Address;
        }
        set address(value: Address) {
            pb_1.Message.setWrapperField(this, 1, value);
        }
        get hasAddress() {
            return pb_1.Message.getField(this, 1) != null;
        }
        static fromObject(data: {
            address?: ReturnType<typeof Address.prototype.toObject>;
        }): UpsertAddressRequest {
            const message = new UpsertAddressRequest({});
            if (data.address != null) {
                message.address = Address.fromObject(data.address);
            }
            return message;
        }
        toObject() {
            const data: {
                address?: ReturnType<typeof Address.prototype.toObject>;
            } = {};
            if (this.address != null) {
                data.address = this.address.toObject();
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.hasAddress)
                writer.writeMessage(1, this.address, () => this.address.serialize(writer));
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): UpsertAddressRequest {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new UpsertAddressRequest();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        reader.readMessage(message.address, () => message.address = Address.deserialize(reader));
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): UpsertAddressRequest {
            return UpsertAddressRequest.deserialize(bytes);
        }
    }
    export class UpsertAddressResponse extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            address?: Address;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("address" in data && data.address != undefined) {
                    this.address = data.address;
                }
            }
        }
        get address() {
            return pb_1.Message.getWrapperField(this, Address, 1) as Address;
        }
        set address(value: Address) {
            pb_1.Message.setWrapperField(this, 1, value);
        }
        get hasAddress() {
            return pb_1.Message.getField(this, 1) != null;
        }
        static fromObject(data: {
            address?: ReturnType<typeof Address.prototype.toObject>;
        }): UpsertAddressResponse {
            const message = new UpsertAddressResponse({});
            if (data.address != null) {
                message.address = Address.fromObject(data.address);
            }
            return message;
        }
        toObject() {
            const data: {
                address?: ReturnType<typeof Address.prototype.toObject>;
            } = {};
            if (this.address != null) {
                data.address = this.address.toObject();
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.hasAddress)
                writer.writeMessage(1, this.address, () => this.address.serialize(writer));
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): UpsertAddressResponse {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new UpsertAddressResponse();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        reader.readMessage(message.address, () => message.address = Address.deserialize(reader));
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): UpsertAddressResponse {
            return UpsertAddressResponse.deserialize(bytes);
        }
    }
    export class DeleteAddressRequest extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            userId?: string;
            addressId?: string;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("userId" in data && data.userId != undefined) {
                    this.userId = data.userId;
                }
                if ("addressId" in data && data.addressId != undefined) {
                    this.addressId = data.addressId;
                }
            }
        }
        get userId() {
            return pb_1.Message.getFieldWithDefault(this, 1, "") as string;
        }
        set userId(value: string) {
            pb_1.Message.setField(this, 1, value);
        }
        get addressId() {
            return pb_1.Message.getFieldWithDefault(this, 2, "") as string;
        }
        set addressId(value: string) {
            pb_1.Message.setField(this, 2, value);
        }
        static fromObject(data: {
            userId?: string;
            addressId?: string;
        }): DeleteAddressRequest {
            const message = new DeleteAddressRequest({});
            if (data.userId != null) {
                message.userId = data.userId;
            }
            if (data.addressId != null) {
                message.addressId = data.addressId;
            }
            return message;
        }
        toObject() {
            const data: {
                userId?: string;
                addressId?: string;
            } = {};
            if (this.userId != null) {
                data.userId = this.userId;
            }
            if (this.addressId != null) {
                data.addressId = this.addressId;
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.userId.length)
                writer.writeString(1, this.userId);
            if (this.addressId.length)
                writer.writeString(2, this.addressId);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): DeleteAddressRequest {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new DeleteAddressRequest();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.userId = reader.readString();
                        break;
                    case 2:
                        message.addressId = reader.readString();
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): DeleteAddressRequest {
            return DeleteAddressRequest.deserialize(bytes);
        }
    }
    export class DeleteAddressResponse extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {}) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") { }
        }
        static fromObject(data: {}): DeleteAddressResponse {
            const message = new DeleteAddressResponse({});
            return message;
        }
        toObject() {
            const data: {} = {};
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): DeleteAddressResponse {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new DeleteAddressResponse();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): DeleteAddressResponse {
            return DeleteAddressResponse.deserialize(bytes);
        }
    }
    export class GetAddressesRequest extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            userId?: string;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("userId" in data && data.userId != undefined) {
                    this.userId = data.userId;
                }
            }
        }
        get userId() {
            return pb_1.Message.getFieldWithDefault(this, 1, "") as string;
        }
        set userId(value: string) {
            pb_1.Message.setField(this, 1, value);
        }
        static fromObject(data: {
            userId?: string;
        }): GetAddressesRequest {
            const message = new GetAddressesRequest({});
            if (data.userId != null) {
                message.userId = data.userId;
            }
            return message;
        }
        toObject() {
            const data: {
                userId?: string;
            } = {};
            if (this.userId != null) {
                data.userId = this.userId;
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.userId.length)
                writer.writeString(1, this.userId);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): GetAddressesRequest {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new GetAddressesRequest();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.userId = reader.readString();
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): GetAddressesRequest {
            return GetAddressesRequest.deserialize(bytes);
        }
    }
    export class GetAddressesResponse extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            userId?: string;
            addresses?: Address[];
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [2], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("userId" in data && data.userId != undefined) {
                    this.userId = data.userId;
                }
                if ("addresses" in data && data.addresses != undefined) {
                    this.addresses = data.addresses;
                }
            }
        }
        get userId() {
            return pb_1.Message.getFieldWithDefault(this, 1, "") as string;
        }
        set userId(value: string) {
            pb_1.Message.setField(this, 1, value);
        }
        get addresses() {
            return pb_1.Message.getRepeatedWrapperField(this, Address, 2) as Address[];
        }
        set addresses(value: Address[]) {
            pb_1.Message.setRepeatedWrapperField(this, 2, value);
        }
        static fromObject(data: {
            userId?: string;
            addresses?: ReturnType<typeof Address.prototype.toObject>[];
        }): GetAddressesResponse {
            const message = new GetAddressesResponse({});
            if (data.userId != null) {
                message.userId = data.userId;
            }
            if (data.addresses != null) {
                message.addresses = data.addresses.map(item => Address.fromObject(item));
            }
            return message;
        }
        toObject() {
            const data: {
                userId?: string;
                addresses?: ReturnType<typeof Address.prototype.toObject>[];
            } = {};
            if (this.userId != null) {
                data.userId = this.userId;
            }
            if (this.addresses != null) {
                data.addresses = this.addresses.map((item: Address) => item.toObject());
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.userId.length)
                writer.writeString(1, this.userId);
            if (this.addresses.length)
                writer.writeRepeatedMessage(2, this.addresses, (item: Address) => item.serialize(writer));
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): GetAddressesResponse {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new GetAddressesResponse();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.userId = reader.readString();
                        break;
                    case 2:
                        reader.readMessage(message.addresses, () => pb_1.Message.addToRepeatedWrapperField(message, 2, Address.deserialize(reader), Address));
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): GetAddressesResponse {
            return GetAddressesResponse.deserialize(bytes);
        }
    }
    export class DeleteUserRequest extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            reason?: string;
            subjectId?: string;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("reason" in data && data.reason != undefined) {
                    this.reason = data.reason;
                }
                if ("subjectId" in data && data.subjectId != undefined) {
                    this.subjectId = data.subjectId;
                }
            }
        }
        get reason() {
            return pb_1.Message.getFieldWithDefault(this, 1, "") as string;
        }
        set reason(value: string) {
            pb_1.Message.setField(this, 1, value);
        }
        get subjectId() {
            return pb_1.Message.getFieldWithDefault(this, 2, "") as string;
        }
        set subjectId(value: string) {
            pb_1.Message.setField(this, 2, value);
        }
        static fromObject(data: {
            reason?: string;
            subjectId?: string;
        }): DeleteUserRequest {
            const message = new DeleteUserRequest({});
            if (data.reason != null) {
                message.reason = data.reason;
            }
            if (data.subjectId != null) {
                message.subjectId = data.subjectId;
            }
            return message;
        }
        toObject() {
            const data: {
                reason?: string;
                subjectId?: string;
            } = {};
            if (this.reason != null) {
                data.reason = this.reason;
            }
            if (this.subjectId != null) {
                data.subjectId = this.subjectId;
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.reason.length)
                writer.writeString(1, this.reason);
            if (this.subjectId.length)
                writer.writeString(2, this.subjectId);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): DeleteUserRequest {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new DeleteUserRequest();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.reason = reader.readString();
                        break;
                    case 2:
                        message.subjectId = reader.readString();
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): DeleteUserRequest {
            return DeleteUserRequest.deserialize(bytes);
        }
    }
    export class DeleteUserResponse extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {}) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") { }
        }
        static fromObject(data: {}): DeleteUserResponse {
            const message = new DeleteUserResponse({});
            return message;
        }
        toObject() {
            const data: {} = {};
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): DeleteUserResponse {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new DeleteUserResponse();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): DeleteUserResponse {
            return DeleteUserResponse.deserialize(bytes);
        }
    }
    export class DeleteUserAdminRequest extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            userId?: string;
            reason?: string;
            subjectId?: string;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("userId" in data && data.userId != undefined) {
                    this.userId = data.userId;
                }
                if ("reason" in data && data.reason != undefined) {
                    this.reason = data.reason;
                }
                if ("subjectId" in data && data.subjectId != undefined) {
                    this.subjectId = data.subjectId;
                }
            }
        }
        get userId() {
            return pb_1.Message.getFieldWithDefault(this, 1, "") as string;
        }
        set userId(value: string) {
            pb_1.Message.setField(this, 1, value);
        }
        get reason() {
            return pb_1.Message.getFieldWithDefault(this, 2, "") as string;
        }
        set reason(value: string) {
            pb_1.Message.setField(this, 2, value);
        }
        get subjectId() {
            return pb_1.Message.getFieldWithDefault(this, 3, "") as string;
        }
        set subjectId(value: string) {
            pb_1.Message.setField(this, 3, value);
        }
        static fromObject(data: {
            userId?: string;
            reason?: string;
            subjectId?: string;
        }): DeleteUserAdminRequest {
            const message = new DeleteUserAdminRequest({});
            if (data.userId != null) {
                message.userId = data.userId;
            }
            if (data.reason != null) {
                message.reason = data.reason;
            }
            if (data.subjectId != null) {
                message.subjectId = data.subjectId;
            }
            return message;
        }
        toObject() {
            const data: {
                userId?: string;
                reason?: string;
                subjectId?: string;
            } = {};
            if (this.userId != null) {
                data.userId = this.userId;
            }
            if (this.reason != null) {
                data.reason = this.reason;
            }
            if (this.subjectId != null) {
                data.subjectId = this.subjectId;
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.userId.length)
                writer.writeString(1, this.userId);
            if (this.reason.length)
                writer.writeString(2, this.reason);
            if (this.subjectId.length)
                writer.writeString(3, this.subjectId);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): DeleteUserAdminRequest {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new DeleteUserAdminRequest();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.userId = reader.readString();
                        break;
                    case 2:
                        message.reason = reader.readString();
                        break;
                    case 3:
                        message.subjectId = reader.readString();
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): DeleteUserAdminRequest {
            return DeleteUserAdminRequest.deserialize(bytes);
        }
    }
    export class DeleteUserAdminResponse extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {}) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") { }
        }
        static fromObject(data: {}): DeleteUserAdminResponse {
            const message = new DeleteUserAdminResponse({});
            return message;
        }
        toObject() {
            const data: {} = {};
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): DeleteUserAdminResponse {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new DeleteUserAdminResponse();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): DeleteUserAdminResponse {
            return DeleteUserAdminResponse.deserialize(bytes);
        }
    }
    export class AuthUser extends pb_1.Message {
        #one_of_decls: number[][] = [[22], [23]];
        constructor(data?: any[] | ({
            email?: string;
            firstName?: string;
            lastName?: string;
            id?: string;
            organizationId?: string;
            workspaceId?: string;
            tenantId?: string;
            externalId?: string;
            emailVerified?: boolean;
            phoneVerified?: boolean;
            phone?: string;
            enabled?: boolean;
            sub?: string;
            name?: string;
            username?: string;
            document?: string;
            address?: Address[];
            userType?: UserType;
            createdAt?: dependency_3.google.protobuf.Timestamp;
            updatedAt?: dependency_3.google.protobuf.Timestamp;
            addressData?: Address;
        } & (({
            companyName?: string;
        }) | ({
            birthDate?: dependency_3.google.protobuf.Timestamp;
        })))) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [17], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("email" in data && data.email != undefined) {
                    this.email = data.email;
                }
                if ("firstName" in data && data.firstName != undefined) {
                    this.firstName = data.firstName;
                }
                if ("lastName" in data && data.lastName != undefined) {
                    this.lastName = data.lastName;
                }
                if ("id" in data && data.id != undefined) {
                    this.id = data.id;
                }
                if ("organizationId" in data && data.organizationId != undefined) {
                    this.organizationId = data.organizationId;
                }
                if ("workspaceId" in data && data.workspaceId != undefined) {
                    this.workspaceId = data.workspaceId;
                }
                if ("tenantId" in data && data.tenantId != undefined) {
                    this.tenantId = data.tenantId;
                }
                if ("externalId" in data && data.externalId != undefined) {
                    this.externalId = data.externalId;
                }
                if ("emailVerified" in data && data.emailVerified != undefined) {
                    this.emailVerified = data.emailVerified;
                }
                if ("phoneVerified" in data && data.phoneVerified != undefined) {
                    this.phoneVerified = data.phoneVerified;
                }
                if ("phone" in data && data.phone != undefined) {
                    this.phone = data.phone;
                }
                if ("enabled" in data && data.enabled != undefined) {
                    this.enabled = data.enabled;
                }
                if ("sub" in data && data.sub != undefined) {
                    this.sub = data.sub;
                }
                if ("name" in data && data.name != undefined) {
                    this.name = data.name;
                }
                if ("username" in data && data.username != undefined) {
                    this.username = data.username;
                }
                if ("document" in data && data.document != undefined) {
                    this.document = data.document;
                }
                if ("address" in data && data.address != undefined) {
                    this.address = data.address;
                }
                if ("userType" in data && data.userType != undefined) {
                    this.userType = data.userType;
                }
                if ("createdAt" in data && data.createdAt != undefined) {
                    this.createdAt = data.createdAt;
                }
                if ("updatedAt" in data && data.updatedAt != undefined) {
                    this.updatedAt = data.updatedAt;
                }
                if ("addressData" in data && data.addressData != undefined) {
                    this.addressData = data.addressData;
                }
                if ("companyName" in data && data.companyName != undefined) {
                    this.companyName = data.companyName;
                }
                if ("birthDate" in data && data.birthDate != undefined) {
                    this.birthDate = data.birthDate;
                }
            }
        }
        get email() {
            return pb_1.Message.getFieldWithDefault(this, 1, "") as string;
        }
        set email(value: string) {
            pb_1.Message.setField(this, 1, value);
        }
        get firstName() {
            return pb_1.Message.getFieldWithDefault(this, 2, "") as string;
        }
        set firstName(value: string) {
            pb_1.Message.setField(this, 2, value);
        }
        get lastName() {
            return pb_1.Message.getFieldWithDefault(this, 3, "") as string;
        }
        set lastName(value: string) {
            pb_1.Message.setField(this, 3, value);
        }
        get id() {
            return pb_1.Message.getFieldWithDefault(this, 4, "") as string;
        }
        set id(value: string) {
            pb_1.Message.setField(this, 4, value);
        }
        get organizationId() {
            return pb_1.Message.getFieldWithDefault(this, 5, "") as string;
        }
        set organizationId(value: string) {
            pb_1.Message.setField(this, 5, value);
        }
        get workspaceId() {
            return pb_1.Message.getFieldWithDefault(this, 6, "") as string;
        }
        set workspaceId(value: string) {
            pb_1.Message.setField(this, 6, value);
        }
        get tenantId() {
            return pb_1.Message.getFieldWithDefault(this, 7, "") as string;
        }
        set tenantId(value: string) {
            pb_1.Message.setField(this, 7, value);
        }
        get externalId() {
            return pb_1.Message.getFieldWithDefault(this, 8, "") as string;
        }
        set externalId(value: string) {
            pb_1.Message.setField(this, 8, value);
        }
        get emailVerified() {
            return pb_1.Message.getFieldWithDefault(this, 9, false) as boolean;
        }
        set emailVerified(value: boolean) {
            pb_1.Message.setField(this, 9, value);
        }
        get phoneVerified() {
            return pb_1.Message.getFieldWithDefault(this, 10, false) as boolean;
        }
        set phoneVerified(value: boolean) {
            pb_1.Message.setField(this, 10, value);
        }
        get phone() {
            return pb_1.Message.getFieldWithDefault(this, 11, "") as string;
        }
        set phone(value: string) {
            pb_1.Message.setField(this, 11, value);
        }
        get enabled() {
            return pb_1.Message.getFieldWithDefault(this, 12, false) as boolean;
        }
        set enabled(value: boolean) {
            pb_1.Message.setField(this, 12, value);
        }
        get sub() {
            return pb_1.Message.getFieldWithDefault(this, 13, "") as string;
        }
        set sub(value: string) {
            pb_1.Message.setField(this, 13, value);
        }
        get name() {
            return pb_1.Message.getFieldWithDefault(this, 14, "") as string;
        }
        set name(value: string) {
            pb_1.Message.setField(this, 14, value);
        }
        get username() {
            return pb_1.Message.getFieldWithDefault(this, 15, "") as string;
        }
        set username(value: string) {
            pb_1.Message.setField(this, 15, value);
        }
        get document() {
            return pb_1.Message.getFieldWithDefault(this, 16, "") as string;
        }
        set document(value: string) {
            pb_1.Message.setField(this, 16, value);
        }
        get address() {
            return pb_1.Message.getRepeatedWrapperField(this, Address, 17) as Address[];
        }
        set address(value: Address[]) {
            pb_1.Message.setRepeatedWrapperField(this, 17, value);
        }
        get userType() {
            return pb_1.Message.getFieldWithDefault(this, 18, UserType.USER_TYPE_UNSPECIFIED) as UserType;
        }
        set userType(value: UserType) {
            pb_1.Message.setField(this, 18, value);
        }
        get createdAt() {
            return pb_1.Message.getWrapperField(this, dependency_3.google.protobuf.Timestamp, 19) as dependency_3.google.protobuf.Timestamp;
        }
        set createdAt(value: dependency_3.google.protobuf.Timestamp) {
            pb_1.Message.setWrapperField(this, 19, value);
        }
        get hasCreatedAt() {
            return pb_1.Message.getField(this, 19) != null;
        }
        get updatedAt() {
            return pb_1.Message.getWrapperField(this, dependency_3.google.protobuf.Timestamp, 20) as dependency_3.google.protobuf.Timestamp;
        }
        set updatedAt(value: dependency_3.google.protobuf.Timestamp) {
            pb_1.Message.setWrapperField(this, 20, value);
        }
        get hasUpdatedAt() {
            return pb_1.Message.getField(this, 20) != null;
        }
        get addressData() {
            return pb_1.Message.getWrapperField(this, Address, 21) as Address;
        }
        set addressData(value: Address) {
            pb_1.Message.setWrapperField(this, 21, value);
        }
        get hasAddressData() {
            return pb_1.Message.getField(this, 21) != null;
        }
        get companyName() {
            return pb_1.Message.getFieldWithDefault(this, 22, "") as string;
        }
        set companyName(value: string) {
            pb_1.Message.setOneofField(this, 22, this.#one_of_decls[0], value);
        }
        get hasCompanyName() {
            return pb_1.Message.getField(this, 22) != null;
        }
        get birthDate() {
            return pb_1.Message.getWrapperField(this, dependency_3.google.protobuf.Timestamp, 23) as dependency_3.google.protobuf.Timestamp;
        }
        set birthDate(value: dependency_3.google.protobuf.Timestamp) {
            pb_1.Message.setOneofWrapperField(this, 23, this.#one_of_decls[1], value);
        }
        get hasBirthDate() {
            return pb_1.Message.getField(this, 23) != null;
        }
        get _company_name() {
            const cases: {
                [index: number]: "none" | "companyName";
            } = {
                0: "none",
                22: "companyName"
            };
            return cases[pb_1.Message.computeOneofCase(this, [22])];
        }
        get _birth_date() {
            const cases: {
                [index: number]: "none" | "birthDate";
            } = {
                0: "none",
                23: "birthDate"
            };
            return cases[pb_1.Message.computeOneofCase(this, [23])];
        }
        static fromObject(data: {
            email?: string;
            firstName?: string;
            lastName?: string;
            id?: string;
            organizationId?: string;
            workspaceId?: string;
            tenantId?: string;
            externalId?: string;
            emailVerified?: boolean;
            phoneVerified?: boolean;
            phone?: string;
            enabled?: boolean;
            sub?: string;
            name?: string;
            username?: string;
            document?: string;
            address?: ReturnType<typeof Address.prototype.toObject>[];
            userType?: UserType;
            createdAt?: ReturnType<typeof dependency_3.google.protobuf.Timestamp.prototype.toObject>;
            updatedAt?: ReturnType<typeof dependency_3.google.protobuf.Timestamp.prototype.toObject>;
            addressData?: ReturnType<typeof Address.prototype.toObject>;
            companyName?: string;
            birthDate?: ReturnType<typeof dependency_3.google.protobuf.Timestamp.prototype.toObject>;
        }): AuthUser {
            const message = new AuthUser({});
            if (data.email != null) {
                message.email = data.email;
            }
            if (data.firstName != null) {
                message.firstName = data.firstName;
            }
            if (data.lastName != null) {
                message.lastName = data.lastName;
            }
            if (data.id != null) {
                message.id = data.id;
            }
            if (data.organizationId != null) {
                message.organizationId = data.organizationId;
            }
            if (data.workspaceId != null) {
                message.workspaceId = data.workspaceId;
            }
            if (data.tenantId != null) {
                message.tenantId = data.tenantId;
            }
            if (data.externalId != null) {
                message.externalId = data.externalId;
            }
            if (data.emailVerified != null) {
                message.emailVerified = data.emailVerified;
            }
            if (data.phoneVerified != null) {
                message.phoneVerified = data.phoneVerified;
            }
            if (data.phone != null) {
                message.phone = data.phone;
            }
            if (data.enabled != null) {
                message.enabled = data.enabled;
            }
            if (data.sub != null) {
                message.sub = data.sub;
            }
            if (data.name != null) {
                message.name = data.name;
            }
            if (data.username != null) {
                message.username = data.username;
            }
            if (data.document != null) {
                message.document = data.document;
            }
            if (data.address != null) {
                message.address = data.address.map(item => Address.fromObject(item));
            }
            if (data.userType != null) {
                message.userType = data.userType;
            }
            if (data.createdAt != null) {
                message.createdAt = dependency_3.google.protobuf.Timestamp.fromObject(data.createdAt);
            }
            if (data.updatedAt != null) {
                message.updatedAt = dependency_3.google.protobuf.Timestamp.fromObject(data.updatedAt);
            }
            if (data.addressData != null) {
                message.addressData = Address.fromObject(data.addressData);
            }
            if (data.companyName != null) {
                message.companyName = data.companyName;
            }
            if (data.birthDate != null) {
                message.birthDate = dependency_3.google.protobuf.Timestamp.fromObject(data.birthDate);
            }
            return message;
        }
        toObject() {
            const data: {
                email?: string;
                firstName?: string;
                lastName?: string;
                id?: string;
                organizationId?: string;
                workspaceId?: string;
                tenantId?: string;
                externalId?: string;
                emailVerified?: boolean;
                phoneVerified?: boolean;
                phone?: string;
                enabled?: boolean;
                sub?: string;
                name?: string;
                username?: string;
                document?: string;
                address?: ReturnType<typeof Address.prototype.toObject>[];
                userType?: UserType;
                createdAt?: ReturnType<typeof dependency_3.google.protobuf.Timestamp.prototype.toObject>;
                updatedAt?: ReturnType<typeof dependency_3.google.protobuf.Timestamp.prototype.toObject>;
                addressData?: ReturnType<typeof Address.prototype.toObject>;
                companyName?: string;
                birthDate?: ReturnType<typeof dependency_3.google.protobuf.Timestamp.prototype.toObject>;
            } = {};
            if (this.email != null) {
                data.email = this.email;
            }
            if (this.firstName != null) {
                data.firstName = this.firstName;
            }
            if (this.lastName != null) {
                data.lastName = this.lastName;
            }
            if (this.id != null) {
                data.id = this.id;
            }
            if (this.organizationId != null) {
                data.organizationId = this.organizationId;
            }
            if (this.workspaceId != null) {
                data.workspaceId = this.workspaceId;
            }
            if (this.tenantId != null) {
                data.tenantId = this.tenantId;
            }
            if (this.externalId != null) {
                data.externalId = this.externalId;
            }
            if (this.emailVerified != null) {
                data.emailVerified = this.emailVerified;
            }
            if (this.phoneVerified != null) {
                data.phoneVerified = this.phoneVerified;
            }
            if (this.phone != null) {
                data.phone = this.phone;
            }
            if (this.enabled != null) {
                data.enabled = this.enabled;
            }
            if (this.sub != null) {
                data.sub = this.sub;
            }
            if (this.name != null) {
                data.name = this.name;
            }
            if (this.username != null) {
                data.username = this.username;
            }
            if (this.document != null) {
                data.document = this.document;
            }
            if (this.address != null) {
                data.address = this.address.map((item: Address) => item.toObject());
            }
            if (this.userType != null) {
                data.userType = this.userType;
            }
            if (this.createdAt != null) {
                data.createdAt = this.createdAt.toObject();
            }
            if (this.updatedAt != null) {
                data.updatedAt = this.updatedAt.toObject();
            }
            if (this.addressData != null) {
                data.addressData = this.addressData.toObject();
            }
            if (this.companyName != null) {
                data.companyName = this.companyName;
            }
            if (this.birthDate != null) {
                data.birthDate = this.birthDate.toObject();
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.email.length)
                writer.writeString(1, this.email);
            if (this.firstName.length)
                writer.writeString(2, this.firstName);
            if (this.lastName.length)
                writer.writeString(3, this.lastName);
            if (this.id.length)
                writer.writeString(4, this.id);
            if (this.organizationId.length)
                writer.writeString(5, this.organizationId);
            if (this.workspaceId.length)
                writer.writeString(6, this.workspaceId);
            if (this.tenantId.length)
                writer.writeString(7, this.tenantId);
            if (this.externalId.length)
                writer.writeString(8, this.externalId);
            if (this.emailVerified != false)
                writer.writeBool(9, this.emailVerified);
            if (this.phoneVerified != false)
                writer.writeBool(10, this.phoneVerified);
            if (this.phone.length)
                writer.writeString(11, this.phone);
            if (this.enabled != false)
                writer.writeBool(12, this.enabled);
            if (this.sub.length)
                writer.writeString(13, this.sub);
            if (this.name.length)
                writer.writeString(14, this.name);
            if (this.username.length)
                writer.writeString(15, this.username);
            if (this.document.length)
                writer.writeString(16, this.document);
            if (this.address.length)
                writer.writeRepeatedMessage(17, this.address, (item: Address) => item.serialize(writer));
            if (this.userType != UserType.USER_TYPE_UNSPECIFIED)
                writer.writeEnum(18, this.userType);
            if (this.hasCreatedAt)
                writer.writeMessage(19, this.createdAt, () => this.createdAt.serialize(writer));
            if (this.hasUpdatedAt)
                writer.writeMessage(20, this.updatedAt, () => this.updatedAt.serialize(writer));
            if (this.hasAddressData)
                writer.writeMessage(21, this.addressData, () => this.addressData.serialize(writer));
            if (this.hasCompanyName)
                writer.writeString(22, this.companyName);
            if (this.hasBirthDate)
                writer.writeMessage(23, this.birthDate, () => this.birthDate.serialize(writer));
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): AuthUser {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new AuthUser();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.email = reader.readString();
                        break;
                    case 2:
                        message.firstName = reader.readString();
                        break;
                    case 3:
                        message.lastName = reader.readString();
                        break;
                    case 4:
                        message.id = reader.readString();
                        break;
                    case 5:
                        message.organizationId = reader.readString();
                        break;
                    case 6:
                        message.workspaceId = reader.readString();
                        break;
                    case 7:
                        message.tenantId = reader.readString();
                        break;
                    case 8:
                        message.externalId = reader.readString();
                        break;
                    case 9:
                        message.emailVerified = reader.readBool();
                        break;
                    case 10:
                        message.phoneVerified = reader.readBool();
                        break;
                    case 11:
                        message.phone = reader.readString();
                        break;
                    case 12:
                        message.enabled = reader.readBool();
                        break;
                    case 13:
                        message.sub = reader.readString();
                        break;
                    case 14:
                        message.name = reader.readString();
                        break;
                    case 15:
                        message.username = reader.readString();
                        break;
                    case 16:
                        message.document = reader.readString();
                        break;
                    case 17:
                        reader.readMessage(message.address, () => pb_1.Message.addToRepeatedWrapperField(message, 17, Address.deserialize(reader), Address));
                        break;
                    case 18:
                        message.userType = reader.readEnum();
                        break;
                    case 19:
                        reader.readMessage(message.createdAt, () => message.createdAt = dependency_3.google.protobuf.Timestamp.deserialize(reader));
                        break;
                    case 20:
                        reader.readMessage(message.updatedAt, () => message.updatedAt = dependency_3.google.protobuf.Timestamp.deserialize(reader));
                        break;
                    case 21:
                        reader.readMessage(message.addressData, () => message.addressData = Address.deserialize(reader));
                        break;
                    case 22:
                        message.companyName = reader.readString();
                        break;
                    case 23:
                        reader.readMessage(message.birthDate, () => message.birthDate = dependency_3.google.protobuf.Timestamp.deserialize(reader));
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): AuthUser {
            return AuthUser.deserialize(bytes);
        }
    }
    export class ListUsersFilter extends pb_1.Message {
        #one_of_decls: number[][] = [[1], [2], [3], [4], [5], [6], [7]];
        constructor(data?: any[] | ({} & (({
            userId?: string;
        }) | ({
            name?: string;
        }) | ({
            email?: string;
        }) | ({
            userType?: UserType;
        }) | ({
            searchTerms?: string;
        }) | ({
            createdAtFrom?: dependency_3.google.protobuf.Timestamp;
        }) | ({
            createdAtTo?: dependency_3.google.protobuf.Timestamp;
        })))) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("userId" in data && data.userId != undefined) {
                    this.userId = data.userId;
                }
                if ("name" in data && data.name != undefined) {
                    this.name = data.name;
                }
                if ("email" in data && data.email != undefined) {
                    this.email = data.email;
                }
                if ("userType" in data && data.userType != undefined) {
                    this.userType = data.userType;
                }
                if ("searchTerms" in data && data.searchTerms != undefined) {
                    this.searchTerms = data.searchTerms;
                }
                if ("createdAtFrom" in data && data.createdAtFrom != undefined) {
                    this.createdAtFrom = data.createdAtFrom;
                }
                if ("createdAtTo" in data && data.createdAtTo != undefined) {
                    this.createdAtTo = data.createdAtTo;
                }
            }
        }
        get userId() {
            return pb_1.Message.getFieldWithDefault(this, 1, "") as string;
        }
        set userId(value: string) {
            pb_1.Message.setOneofField(this, 1, this.#one_of_decls[0], value);
        }
        get hasUserId() {
            return pb_1.Message.getField(this, 1) != null;
        }
        get name() {
            return pb_1.Message.getFieldWithDefault(this, 2, "") as string;
        }
        set name(value: string) {
            pb_1.Message.setOneofField(this, 2, this.#one_of_decls[1], value);
        }
        get hasName() {
            return pb_1.Message.getField(this, 2) != null;
        }
        get email() {
            return pb_1.Message.getFieldWithDefault(this, 3, "") as string;
        }
        set email(value: string) {
            pb_1.Message.setOneofField(this, 3, this.#one_of_decls[2], value);
        }
        get hasEmail() {
            return pb_1.Message.getField(this, 3) != null;
        }
        get userType() {
            return pb_1.Message.getFieldWithDefault(this, 4, UserType.USER_TYPE_UNSPECIFIED) as UserType;
        }
        set userType(value: UserType) {
            pb_1.Message.setOneofField(this, 4, this.#one_of_decls[3], value);
        }
        get hasUserType() {
            return pb_1.Message.getField(this, 4) != null;
        }
        get searchTerms() {
            return pb_1.Message.getFieldWithDefault(this, 5, "") as string;
        }
        set searchTerms(value: string) {
            pb_1.Message.setOneofField(this, 5, this.#one_of_decls[4], value);
        }
        get hasSearchTerms() {
            return pb_1.Message.getField(this, 5) != null;
        }
        get createdAtFrom() {
            return pb_1.Message.getWrapperField(this, dependency_3.google.protobuf.Timestamp, 6) as dependency_3.google.protobuf.Timestamp;
        }
        set createdAtFrom(value: dependency_3.google.protobuf.Timestamp) {
            pb_1.Message.setOneofWrapperField(this, 6, this.#one_of_decls[5], value);
        }
        get hasCreatedAtFrom() {
            return pb_1.Message.getField(this, 6) != null;
        }
        get createdAtTo() {
            return pb_1.Message.getWrapperField(this, dependency_3.google.protobuf.Timestamp, 7) as dependency_3.google.protobuf.Timestamp;
        }
        set createdAtTo(value: dependency_3.google.protobuf.Timestamp) {
            pb_1.Message.setOneofWrapperField(this, 7, this.#one_of_decls[6], value);
        }
        get hasCreatedAtTo() {
            return pb_1.Message.getField(this, 7) != null;
        }
        get _user_id() {
            const cases: {
                [index: number]: "none" | "userId";
            } = {
                0: "none",
                1: "userId"
            };
            return cases[pb_1.Message.computeOneofCase(this, [1])];
        }
        get _name() {
            const cases: {
                [index: number]: "none" | "name";
            } = {
                0: "none",
                2: "name"
            };
            return cases[pb_1.Message.computeOneofCase(this, [2])];
        }
        get _email() {
            const cases: {
                [index: number]: "none" | "email";
            } = {
                0: "none",
                3: "email"
            };
            return cases[pb_1.Message.computeOneofCase(this, [3])];
        }
        get _user_type() {
            const cases: {
                [index: number]: "none" | "userType";
            } = {
                0: "none",
                4: "userType"
            };
            return cases[pb_1.Message.computeOneofCase(this, [4])];
        }
        get _search_terms() {
            const cases: {
                [index: number]: "none" | "searchTerms";
            } = {
                0: "none",
                5: "searchTerms"
            };
            return cases[pb_1.Message.computeOneofCase(this, [5])];
        }
        get _created_at_from() {
            const cases: {
                [index: number]: "none" | "createdAtFrom";
            } = {
                0: "none",
                6: "createdAtFrom"
            };
            return cases[pb_1.Message.computeOneofCase(this, [6])];
        }
        get _created_at_to() {
            const cases: {
                [index: number]: "none" | "createdAtTo";
            } = {
                0: "none",
                7: "createdAtTo"
            };
            return cases[pb_1.Message.computeOneofCase(this, [7])];
        }
        static fromObject(data: {
            userId?: string;
            name?: string;
            email?: string;
            userType?: UserType;
            searchTerms?: string;
            createdAtFrom?: ReturnType<typeof dependency_3.google.protobuf.Timestamp.prototype.toObject>;
            createdAtTo?: ReturnType<typeof dependency_3.google.protobuf.Timestamp.prototype.toObject>;
        }): ListUsersFilter {
            const message = new ListUsersFilter({});
            if (data.userId != null) {
                message.userId = data.userId;
            }
            if (data.name != null) {
                message.name = data.name;
            }
            if (data.email != null) {
                message.email = data.email;
            }
            if (data.userType != null) {
                message.userType = data.userType;
            }
            if (data.searchTerms != null) {
                message.searchTerms = data.searchTerms;
            }
            if (data.createdAtFrom != null) {
                message.createdAtFrom = dependency_3.google.protobuf.Timestamp.fromObject(data.createdAtFrom);
            }
            if (data.createdAtTo != null) {
                message.createdAtTo = dependency_3.google.protobuf.Timestamp.fromObject(data.createdAtTo);
            }
            return message;
        }
        toObject() {
            const data: {
                userId?: string;
                name?: string;
                email?: string;
                userType?: UserType;
                searchTerms?: string;
                createdAtFrom?: ReturnType<typeof dependency_3.google.protobuf.Timestamp.prototype.toObject>;
                createdAtTo?: ReturnType<typeof dependency_3.google.protobuf.Timestamp.prototype.toObject>;
            } = {};
            if (this.userId != null) {
                data.userId = this.userId;
            }
            if (this.name != null) {
                data.name = this.name;
            }
            if (this.email != null) {
                data.email = this.email;
            }
            if (this.userType != null) {
                data.userType = this.userType;
            }
            if (this.searchTerms != null) {
                data.searchTerms = this.searchTerms;
            }
            if (this.createdAtFrom != null) {
                data.createdAtFrom = this.createdAtFrom.toObject();
            }
            if (this.createdAtTo != null) {
                data.createdAtTo = this.createdAtTo.toObject();
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.hasUserId)
                writer.writeString(1, this.userId);
            if (this.hasName)
                writer.writeString(2, this.name);
            if (this.hasEmail)
                writer.writeString(3, this.email);
            if (this.hasUserType)
                writer.writeEnum(4, this.userType);
            if (this.hasSearchTerms)
                writer.writeString(5, this.searchTerms);
            if (this.hasCreatedAtFrom)
                writer.writeMessage(6, this.createdAtFrom, () => this.createdAtFrom.serialize(writer));
            if (this.hasCreatedAtTo)
                writer.writeMessage(7, this.createdAtTo, () => this.createdAtTo.serialize(writer));
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): ListUsersFilter {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new ListUsersFilter();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.userId = reader.readString();
                        break;
                    case 2:
                        message.name = reader.readString();
                        break;
                    case 3:
                        message.email = reader.readString();
                        break;
                    case 4:
                        message.userType = reader.readEnum();
                        break;
                    case 5:
                        message.searchTerms = reader.readString();
                        break;
                    case 6:
                        reader.readMessage(message.createdAtFrom, () => message.createdAtFrom = dependency_3.google.protobuf.Timestamp.deserialize(reader));
                        break;
                    case 7:
                        reader.readMessage(message.createdAtTo, () => message.createdAtTo = dependency_3.google.protobuf.Timestamp.deserialize(reader));
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): ListUsersFilter {
            return ListUsersFilter.deserialize(bytes);
        }
    }
    export class ListUsersRequest extends pb_1.Message {
        #one_of_decls: number[][] = [[1], [2]];
        constructor(data?: any[] | ({} & (({
            pagination?: dependency_4.common.v1.PaginationRequest;
        }) | ({
            filter?: ListUsersFilter;
        })))) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("pagination" in data && data.pagination != undefined) {
                    this.pagination = data.pagination;
                }
                if ("filter" in data && data.filter != undefined) {
                    this.filter = data.filter;
                }
            }
        }
        get pagination() {
            return pb_1.Message.getWrapperField(this, dependency_4.common.v1.PaginationRequest, 1) as dependency_4.common.v1.PaginationRequest;
        }
        set pagination(value: dependency_4.common.v1.PaginationRequest) {
            pb_1.Message.setOneofWrapperField(this, 1, this.#one_of_decls[0], value);
        }
        get hasPagination() {
            return pb_1.Message.getField(this, 1) != null;
        }
        get filter() {
            return pb_1.Message.getWrapperField(this, ListUsersFilter, 2) as ListUsersFilter;
        }
        set filter(value: ListUsersFilter) {
            pb_1.Message.setOneofWrapperField(this, 2, this.#one_of_decls[1], value);
        }
        get hasFilter() {
            return pb_1.Message.getField(this, 2) != null;
        }
        get _pagination() {
            const cases: {
                [index: number]: "none" | "pagination";
            } = {
                0: "none",
                1: "pagination"
            };
            return cases[pb_1.Message.computeOneofCase(this, [1])];
        }
        get _filter() {
            const cases: {
                [index: number]: "none" | "filter";
            } = {
                0: "none",
                2: "filter"
            };
            return cases[pb_1.Message.computeOneofCase(this, [2])];
        }
        static fromObject(data: {
            pagination?: ReturnType<typeof dependency_4.common.v1.PaginationRequest.prototype.toObject>;
            filter?: ReturnType<typeof ListUsersFilter.prototype.toObject>;
        }): ListUsersRequest {
            const message = new ListUsersRequest({});
            if (data.pagination != null) {
                message.pagination = dependency_4.common.v1.PaginationRequest.fromObject(data.pagination);
            }
            if (data.filter != null) {
                message.filter = ListUsersFilter.fromObject(data.filter);
            }
            return message;
        }
        toObject() {
            const data: {
                pagination?: ReturnType<typeof dependency_4.common.v1.PaginationRequest.prototype.toObject>;
                filter?: ReturnType<typeof ListUsersFilter.prototype.toObject>;
            } = {};
            if (this.pagination != null) {
                data.pagination = this.pagination.toObject();
            }
            if (this.filter != null) {
                data.filter = this.filter.toObject();
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.hasPagination)
                writer.writeMessage(1, this.pagination, () => this.pagination.serialize(writer));
            if (this.hasFilter)
                writer.writeMessage(2, this.filter, () => this.filter.serialize(writer));
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): ListUsersRequest {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new ListUsersRequest();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        reader.readMessage(message.pagination, () => message.pagination = dependency_4.common.v1.PaginationRequest.deserialize(reader));
                        break;
                    case 2:
                        reader.readMessage(message.filter, () => message.filter = ListUsersFilter.deserialize(reader));
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): ListUsersRequest {
            return ListUsersRequest.deserialize(bytes);
        }
    }
    export class ListUsersResponse extends pb_1.Message {
        #one_of_decls: number[][] = [[2]];
        constructor(data?: any[] | ({
            users?: AuthUser[];
        } & (({
            pagination?: dependency_4.common.v1.PaginationResponse;
        })))) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [1], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("users" in data && data.users != undefined) {
                    this.users = data.users;
                }
                if ("pagination" in data && data.pagination != undefined) {
                    this.pagination = data.pagination;
                }
            }
        }
        get users() {
            return pb_1.Message.getRepeatedWrapperField(this, AuthUser, 1) as AuthUser[];
        }
        set users(value: AuthUser[]) {
            pb_1.Message.setRepeatedWrapperField(this, 1, value);
        }
        get pagination() {
            return pb_1.Message.getWrapperField(this, dependency_4.common.v1.PaginationResponse, 2) as dependency_4.common.v1.PaginationResponse;
        }
        set pagination(value: dependency_4.common.v1.PaginationResponse) {
            pb_1.Message.setOneofWrapperField(this, 2, this.#one_of_decls[0], value);
        }
        get hasPagination() {
            return pb_1.Message.getField(this, 2) != null;
        }
        get _pagination() {
            const cases: {
                [index: number]: "none" | "pagination";
            } = {
                0: "none",
                2: "pagination"
            };
            return cases[pb_1.Message.computeOneofCase(this, [2])];
        }
        static fromObject(data: {
            users?: ReturnType<typeof AuthUser.prototype.toObject>[];
            pagination?: ReturnType<typeof dependency_4.common.v1.PaginationResponse.prototype.toObject>;
        }): ListUsersResponse {
            const message = new ListUsersResponse({});
            if (data.users != null) {
                message.users = data.users.map(item => AuthUser.fromObject(item));
            }
            if (data.pagination != null) {
                message.pagination = dependency_4.common.v1.PaginationResponse.fromObject(data.pagination);
            }
            return message;
        }
        toObject() {
            const data: {
                users?: ReturnType<typeof AuthUser.prototype.toObject>[];
                pagination?: ReturnType<typeof dependency_4.common.v1.PaginationResponse.prototype.toObject>;
            } = {};
            if (this.users != null) {
                data.users = this.users.map((item: AuthUser) => item.toObject());
            }
            if (this.pagination != null) {
                data.pagination = this.pagination.toObject();
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.users.length)
                writer.writeRepeatedMessage(1, this.users, (item: AuthUser) => item.serialize(writer));
            if (this.hasPagination)
                writer.writeMessage(2, this.pagination, () => this.pagination.serialize(writer));
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): ListUsersResponse {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new ListUsersResponse();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        reader.readMessage(message.users, () => pb_1.Message.addToRepeatedWrapperField(message, 1, AuthUser.deserialize(reader), AuthUser));
                        break;
                    case 2:
                        reader.readMessage(message.pagination, () => message.pagination = dependency_4.common.v1.PaginationResponse.deserialize(reader));
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): ListUsersResponse {
            return ListUsersResponse.deserialize(bytes);
        }
    }
    export class ChangeUserProfileRequest extends pb_1.Message {
        #one_of_decls: number[][] = [[1], [2], [3]];
        constructor(data?: any[] | ({
            userId?: string;
        } & (({
            firstName?: string;
        }) | ({
            lastName?: string;
        }) | ({
            phoneNumber?: string;
        })))) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("firstName" in data && data.firstName != undefined) {
                    this.firstName = data.firstName;
                }
                if ("lastName" in data && data.lastName != undefined) {
                    this.lastName = data.lastName;
                }
                if ("phoneNumber" in data && data.phoneNumber != undefined) {
                    this.phoneNumber = data.phoneNumber;
                }
                if ("userId" in data && data.userId != undefined) {
                    this.userId = data.userId;
                }
            }
        }
        get firstName() {
            return pb_1.Message.getFieldWithDefault(this, 1, "") as string;
        }
        set firstName(value: string) {
            pb_1.Message.setOneofField(this, 1, this.#one_of_decls[0], value);
        }
        get hasFirstName() {
            return pb_1.Message.getField(this, 1) != null;
        }
        get lastName() {
            return pb_1.Message.getFieldWithDefault(this, 2, "") as string;
        }
        set lastName(value: string) {
            pb_1.Message.setOneofField(this, 2, this.#one_of_decls[1], value);
        }
        get hasLastName() {
            return pb_1.Message.getField(this, 2) != null;
        }
        get phoneNumber() {
            return pb_1.Message.getFieldWithDefault(this, 3, "") as string;
        }
        set phoneNumber(value: string) {
            pb_1.Message.setOneofField(this, 3, this.#one_of_decls[2], value);
        }
        get hasPhoneNumber() {
            return pb_1.Message.getField(this, 3) != null;
        }
        get userId() {
            return pb_1.Message.getFieldWithDefault(this, 4, "") as string;
        }
        set userId(value: string) {
            pb_1.Message.setField(this, 4, value);
        }
        get _first_name() {
            const cases: {
                [index: number]: "none" | "firstName";
            } = {
                0: "none",
                1: "firstName"
            };
            return cases[pb_1.Message.computeOneofCase(this, [1])];
        }
        get _last_name() {
            const cases: {
                [index: number]: "none" | "lastName";
            } = {
                0: "none",
                2: "lastName"
            };
            return cases[pb_1.Message.computeOneofCase(this, [2])];
        }
        get _phone_number() {
            const cases: {
                [index: number]: "none" | "phoneNumber";
            } = {
                0: "none",
                3: "phoneNumber"
            };
            return cases[pb_1.Message.computeOneofCase(this, [3])];
        }
        static fromObject(data: {
            firstName?: string;
            lastName?: string;
            phoneNumber?: string;
            userId?: string;
        }): ChangeUserProfileRequest {
            const message = new ChangeUserProfileRequest({});
            if (data.firstName != null) {
                message.firstName = data.firstName;
            }
            if (data.lastName != null) {
                message.lastName = data.lastName;
            }
            if (data.phoneNumber != null) {
                message.phoneNumber = data.phoneNumber;
            }
            if (data.userId != null) {
                message.userId = data.userId;
            }
            return message;
        }
        toObject() {
            const data: {
                firstName?: string;
                lastName?: string;
                phoneNumber?: string;
                userId?: string;
            } = {};
            if (this.firstName != null) {
                data.firstName = this.firstName;
            }
            if (this.lastName != null) {
                data.lastName = this.lastName;
            }
            if (this.phoneNumber != null) {
                data.phoneNumber = this.phoneNumber;
            }
            if (this.userId != null) {
                data.userId = this.userId;
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.hasFirstName)
                writer.writeString(1, this.firstName);
            if (this.hasLastName)
                writer.writeString(2, this.lastName);
            if (this.hasPhoneNumber)
                writer.writeString(3, this.phoneNumber);
            if (this.userId.length)
                writer.writeString(4, this.userId);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): ChangeUserProfileRequest {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new ChangeUserProfileRequest();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.firstName = reader.readString();
                        break;
                    case 2:
                        message.lastName = reader.readString();
                        break;
                    case 3:
                        message.phoneNumber = reader.readString();
                        break;
                    case 4:
                        message.userId = reader.readString();
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): ChangeUserProfileRequest {
            return ChangeUserProfileRequest.deserialize(bytes);
        }
    }
    export class ChangeUserProfileResponse extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            user?: AuthUser;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("user" in data && data.user != undefined) {
                    this.user = data.user;
                }
            }
        }
        get user() {
            return pb_1.Message.getWrapperField(this, AuthUser, 1) as AuthUser;
        }
        set user(value: AuthUser) {
            pb_1.Message.setWrapperField(this, 1, value);
        }
        get hasUser() {
            return pb_1.Message.getField(this, 1) != null;
        }
        static fromObject(data: {
            user?: ReturnType<typeof AuthUser.prototype.toObject>;
        }): ChangeUserProfileResponse {
            const message = new ChangeUserProfileResponse({});
            if (data.user != null) {
                message.user = AuthUser.fromObject(data.user);
            }
            return message;
        }
        toObject() {
            const data: {
                user?: ReturnType<typeof AuthUser.prototype.toObject>;
            } = {};
            if (this.user != null) {
                data.user = this.user.toObject();
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.hasUser)
                writer.writeMessage(1, this.user, () => this.user.serialize(writer));
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): ChangeUserProfileResponse {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new ChangeUserProfileResponse();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        reader.readMessage(message.user, () => message.user = AuthUser.deserialize(reader));
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): ChangeUserProfileResponse {
            return ChangeUserProfileResponse.deserialize(bytes);
        }
    }
    export class StartPasswordChangeRequest extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            newPassword?: string;
            userId?: string;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("newPassword" in data && data.newPassword != undefined) {
                    this.newPassword = data.newPassword;
                }
                if ("userId" in data && data.userId != undefined) {
                    this.userId = data.userId;
                }
            }
        }
        get newPassword() {
            return pb_1.Message.getFieldWithDefault(this, 1, "") as string;
        }
        set newPassword(value: string) {
            pb_1.Message.setField(this, 1, value);
        }
        get userId() {
            return pb_1.Message.getFieldWithDefault(this, 2, "") as string;
        }
        set userId(value: string) {
            pb_1.Message.setField(this, 2, value);
        }
        static fromObject(data: {
            newPassword?: string;
            userId?: string;
        }): StartPasswordChangeRequest {
            const message = new StartPasswordChangeRequest({});
            if (data.newPassword != null) {
                message.newPassword = data.newPassword;
            }
            if (data.userId != null) {
                message.userId = data.userId;
            }
            return message;
        }
        toObject() {
            const data: {
                newPassword?: string;
                userId?: string;
            } = {};
            if (this.newPassword != null) {
                data.newPassword = this.newPassword;
            }
            if (this.userId != null) {
                data.userId = this.userId;
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.newPassword.length)
                writer.writeString(1, this.newPassword);
            if (this.userId.length)
                writer.writeString(2, this.userId);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): StartPasswordChangeRequest {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new StartPasswordChangeRequest();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.newPassword = reader.readString();
                        break;
                    case 2:
                        message.userId = reader.readString();
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): StartPasswordChangeRequest {
            return StartPasswordChangeRequest.deserialize(bytes);
        }
    }
    export class StartPasswordChangeResponse extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            sessionId?: string;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("sessionId" in data && data.sessionId != undefined) {
                    this.sessionId = data.sessionId;
                }
            }
        }
        get sessionId() {
            return pb_1.Message.getFieldWithDefault(this, 1, "") as string;
        }
        set sessionId(value: string) {
            pb_1.Message.setField(this, 1, value);
        }
        static fromObject(data: {
            sessionId?: string;
        }): StartPasswordChangeResponse {
            const message = new StartPasswordChangeResponse({});
            if (data.sessionId != null) {
                message.sessionId = data.sessionId;
            }
            return message;
        }
        toObject() {
            const data: {
                sessionId?: string;
            } = {};
            if (this.sessionId != null) {
                data.sessionId = this.sessionId;
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.sessionId.length)
                writer.writeString(1, this.sessionId);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): StartPasswordChangeResponse {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new StartPasswordChangeResponse();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.sessionId = reader.readString();
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): StartPasswordChangeResponse {
            return StartPasswordChangeResponse.deserialize(bytes);
        }
    }
    export class VerifyPasswordChangeRequest extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            sessionId?: string;
            challenge?: string;
            username?: string;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("sessionId" in data && data.sessionId != undefined) {
                    this.sessionId = data.sessionId;
                }
                if ("challenge" in data && data.challenge != undefined) {
                    this.challenge = data.challenge;
                }
                if ("username" in data && data.username != undefined) {
                    this.username = data.username;
                }
            }
        }
        get sessionId() {
            return pb_1.Message.getFieldWithDefault(this, 1, "") as string;
        }
        set sessionId(value: string) {
            pb_1.Message.setField(this, 1, value);
        }
        get challenge() {
            return pb_1.Message.getFieldWithDefault(this, 2, "") as string;
        }
        set challenge(value: string) {
            pb_1.Message.setField(this, 2, value);
        }
        get username() {
            return pb_1.Message.getFieldWithDefault(this, 3, "") as string;
        }
        set username(value: string) {
            pb_1.Message.setField(this, 3, value);
        }
        static fromObject(data: {
            sessionId?: string;
            challenge?: string;
            username?: string;
        }): VerifyPasswordChangeRequest {
            const message = new VerifyPasswordChangeRequest({});
            if (data.sessionId != null) {
                message.sessionId = data.sessionId;
            }
            if (data.challenge != null) {
                message.challenge = data.challenge;
            }
            if (data.username != null) {
                message.username = data.username;
            }
            return message;
        }
        toObject() {
            const data: {
                sessionId?: string;
                challenge?: string;
                username?: string;
            } = {};
            if (this.sessionId != null) {
                data.sessionId = this.sessionId;
            }
            if (this.challenge != null) {
                data.challenge = this.challenge;
            }
            if (this.username != null) {
                data.username = this.username;
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.sessionId.length)
                writer.writeString(1, this.sessionId);
            if (this.challenge.length)
                writer.writeString(2, this.challenge);
            if (this.username.length)
                writer.writeString(3, this.username);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): VerifyPasswordChangeRequest {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new VerifyPasswordChangeRequest();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.sessionId = reader.readString();
                        break;
                    case 2:
                        message.challenge = reader.readString();
                        break;
                    case 3:
                        message.username = reader.readString();
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): VerifyPasswordChangeRequest {
            return VerifyPasswordChangeRequest.deserialize(bytes);
        }
    }
    export class VerifyPasswordChangeResponse extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            user?: AuthUser;
            sessionId?: string;
            errorMessage?: string;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("user" in data && data.user != undefined) {
                    this.user = data.user;
                }
                if ("sessionId" in data && data.sessionId != undefined) {
                    this.sessionId = data.sessionId;
                }
                if ("errorMessage" in data && data.errorMessage != undefined) {
                    this.errorMessage = data.errorMessage;
                }
            }
        }
        get user() {
            return pb_1.Message.getWrapperField(this, AuthUser, 1) as AuthUser;
        }
        set user(value: AuthUser) {
            pb_1.Message.setWrapperField(this, 1, value);
        }
        get hasUser() {
            return pb_1.Message.getField(this, 1) != null;
        }
        get sessionId() {
            return pb_1.Message.getFieldWithDefault(this, 2, "") as string;
        }
        set sessionId(value: string) {
            pb_1.Message.setField(this, 2, value);
        }
        get errorMessage() {
            return pb_1.Message.getFieldWithDefault(this, 3, "") as string;
        }
        set errorMessage(value: string) {
            pb_1.Message.setField(this, 3, value);
        }
        static fromObject(data: {
            user?: ReturnType<typeof AuthUser.prototype.toObject>;
            sessionId?: string;
            errorMessage?: string;
        }): VerifyPasswordChangeResponse {
            const message = new VerifyPasswordChangeResponse({});
            if (data.user != null) {
                message.user = AuthUser.fromObject(data.user);
            }
            if (data.sessionId != null) {
                message.sessionId = data.sessionId;
            }
            if (data.errorMessage != null) {
                message.errorMessage = data.errorMessage;
            }
            return message;
        }
        toObject() {
            const data: {
                user?: ReturnType<typeof AuthUser.prototype.toObject>;
                sessionId?: string;
                errorMessage?: string;
            } = {};
            if (this.user != null) {
                data.user = this.user.toObject();
            }
            if (this.sessionId != null) {
                data.sessionId = this.sessionId;
            }
            if (this.errorMessage != null) {
                data.errorMessage = this.errorMessage;
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.hasUser)
                writer.writeMessage(1, this.user, () => this.user.serialize(writer));
            if (this.sessionId.length)
                writer.writeString(2, this.sessionId);
            if (this.errorMessage.length)
                writer.writeString(3, this.errorMessage);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): VerifyPasswordChangeResponse {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new VerifyPasswordChangeResponse();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        reader.readMessage(message.user, () => message.user = AuthUser.deserialize(reader));
                        break;
                    case 2:
                        message.sessionId = reader.readString();
                        break;
                    case 3:
                        message.errorMessage = reader.readString();
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): VerifyPasswordChangeResponse {
            return VerifyPasswordChangeResponse.deserialize(bytes);
        }
    }
    export class StartEmailChangeRequest extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            newEmail?: string;
            userId?: string;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("newEmail" in data && data.newEmail != undefined) {
                    this.newEmail = data.newEmail;
                }
                if ("userId" in data && data.userId != undefined) {
                    this.userId = data.userId;
                }
            }
        }
        get newEmail() {
            return pb_1.Message.getFieldWithDefault(this, 1, "") as string;
        }
        set newEmail(value: string) {
            pb_1.Message.setField(this, 1, value);
        }
        get userId() {
            return pb_1.Message.getFieldWithDefault(this, 2, "") as string;
        }
        set userId(value: string) {
            pb_1.Message.setField(this, 2, value);
        }
        static fromObject(data: {
            newEmail?: string;
            userId?: string;
        }): StartEmailChangeRequest {
            const message = new StartEmailChangeRequest({});
            if (data.newEmail != null) {
                message.newEmail = data.newEmail;
            }
            if (data.userId != null) {
                message.userId = data.userId;
            }
            return message;
        }
        toObject() {
            const data: {
                newEmail?: string;
                userId?: string;
            } = {};
            if (this.newEmail != null) {
                data.newEmail = this.newEmail;
            }
            if (this.userId != null) {
                data.userId = this.userId;
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.newEmail.length)
                writer.writeString(1, this.newEmail);
            if (this.userId.length)
                writer.writeString(2, this.userId);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): StartEmailChangeRequest {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new StartEmailChangeRequest();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.newEmail = reader.readString();
                        break;
                    case 2:
                        message.userId = reader.readString();
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): StartEmailChangeRequest {
            return StartEmailChangeRequest.deserialize(bytes);
        }
    }
    export class StartEmailChangeResponse extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            sessionId?: string;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("sessionId" in data && data.sessionId != undefined) {
                    this.sessionId = data.sessionId;
                }
            }
        }
        get sessionId() {
            return pb_1.Message.getFieldWithDefault(this, 1, "") as string;
        }
        set sessionId(value: string) {
            pb_1.Message.setField(this, 1, value);
        }
        static fromObject(data: {
            sessionId?: string;
        }): StartEmailChangeResponse {
            const message = new StartEmailChangeResponse({});
            if (data.sessionId != null) {
                message.sessionId = data.sessionId;
            }
            return message;
        }
        toObject() {
            const data: {
                sessionId?: string;
            } = {};
            if (this.sessionId != null) {
                data.sessionId = this.sessionId;
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.sessionId.length)
                writer.writeString(1, this.sessionId);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): StartEmailChangeResponse {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new StartEmailChangeResponse();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.sessionId = reader.readString();
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): StartEmailChangeResponse {
            return StartEmailChangeResponse.deserialize(bytes);
        }
    }
    export class VerifyEmailChangeRequest extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            sessionId?: string;
            challenge?: string;
            username?: string;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("sessionId" in data && data.sessionId != undefined) {
                    this.sessionId = data.sessionId;
                }
                if ("challenge" in data && data.challenge != undefined) {
                    this.challenge = data.challenge;
                }
                if ("username" in data && data.username != undefined) {
                    this.username = data.username;
                }
            }
        }
        get sessionId() {
            return pb_1.Message.getFieldWithDefault(this, 1, "") as string;
        }
        set sessionId(value: string) {
            pb_1.Message.setField(this, 1, value);
        }
        get challenge() {
            return pb_1.Message.getFieldWithDefault(this, 2, "") as string;
        }
        set challenge(value: string) {
            pb_1.Message.setField(this, 2, value);
        }
        get username() {
            return pb_1.Message.getFieldWithDefault(this, 3, "") as string;
        }
        set username(value: string) {
            pb_1.Message.setField(this, 3, value);
        }
        static fromObject(data: {
            sessionId?: string;
            challenge?: string;
            username?: string;
        }): VerifyEmailChangeRequest {
            const message = new VerifyEmailChangeRequest({});
            if (data.sessionId != null) {
                message.sessionId = data.sessionId;
            }
            if (data.challenge != null) {
                message.challenge = data.challenge;
            }
            if (data.username != null) {
                message.username = data.username;
            }
            return message;
        }
        toObject() {
            const data: {
                sessionId?: string;
                challenge?: string;
                username?: string;
            } = {};
            if (this.sessionId != null) {
                data.sessionId = this.sessionId;
            }
            if (this.challenge != null) {
                data.challenge = this.challenge;
            }
            if (this.username != null) {
                data.username = this.username;
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.sessionId.length)
                writer.writeString(1, this.sessionId);
            if (this.challenge.length)
                writer.writeString(2, this.challenge);
            if (this.username.length)
                writer.writeString(3, this.username);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): VerifyEmailChangeRequest {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new VerifyEmailChangeRequest();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.sessionId = reader.readString();
                        break;
                    case 2:
                        message.challenge = reader.readString();
                        break;
                    case 3:
                        message.username = reader.readString();
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): VerifyEmailChangeRequest {
            return VerifyEmailChangeRequest.deserialize(bytes);
        }
    }
    export class VerifyEmailChangeResponse extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            user?: AuthUser;
            sessionId?: string;
            errorMessage?: string;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("user" in data && data.user != undefined) {
                    this.user = data.user;
                }
                if ("sessionId" in data && data.sessionId != undefined) {
                    this.sessionId = data.sessionId;
                }
                if ("errorMessage" in data && data.errorMessage != undefined) {
                    this.errorMessage = data.errorMessage;
                }
            }
        }
        get user() {
            return pb_1.Message.getWrapperField(this, AuthUser, 1) as AuthUser;
        }
        set user(value: AuthUser) {
            pb_1.Message.setWrapperField(this, 1, value);
        }
        get hasUser() {
            return pb_1.Message.getField(this, 1) != null;
        }
        get sessionId() {
            return pb_1.Message.getFieldWithDefault(this, 2, "") as string;
        }
        set sessionId(value: string) {
            pb_1.Message.setField(this, 2, value);
        }
        get errorMessage() {
            return pb_1.Message.getFieldWithDefault(this, 3, "") as string;
        }
        set errorMessage(value: string) {
            pb_1.Message.setField(this, 3, value);
        }
        static fromObject(data: {
            user?: ReturnType<typeof AuthUser.prototype.toObject>;
            sessionId?: string;
            errorMessage?: string;
        }): VerifyEmailChangeResponse {
            const message = new VerifyEmailChangeResponse({});
            if (data.user != null) {
                message.user = AuthUser.fromObject(data.user);
            }
            if (data.sessionId != null) {
                message.sessionId = data.sessionId;
            }
            if (data.errorMessage != null) {
                message.errorMessage = data.errorMessage;
            }
            return message;
        }
        toObject() {
            const data: {
                user?: ReturnType<typeof AuthUser.prototype.toObject>;
                sessionId?: string;
                errorMessage?: string;
            } = {};
            if (this.user != null) {
                data.user = this.user.toObject();
            }
            if (this.sessionId != null) {
                data.sessionId = this.sessionId;
            }
            if (this.errorMessage != null) {
                data.errorMessage = this.errorMessage;
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.hasUser)
                writer.writeMessage(1, this.user, () => this.user.serialize(writer));
            if (this.sessionId.length)
                writer.writeString(2, this.sessionId);
            if (this.errorMessage.length)
                writer.writeString(3, this.errorMessage);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): VerifyEmailChangeResponse {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new VerifyEmailChangeResponse();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        reader.readMessage(message.user, () => message.user = AuthUser.deserialize(reader));
                        break;
                    case 2:
                        message.sessionId = reader.readString();
                        break;
                    case 3:
                        message.errorMessage = reader.readString();
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): VerifyEmailChangeResponse {
            return VerifyEmailChangeResponse.deserialize(bytes);
        }
    }
    export class UpdateAuthUserRequest extends pb_1.Message {
        #one_of_decls: number[][] = [[8], [10], [12], [13]];
        constructor(data?: any[] | ({
            userId?: string;
            firstName?: string;
            lastName?: string;
            email?: string;
            organizationId?: string;
            workspaceId?: string;
            username?: string;
            externalId?: string;
            phone?: string;
        } & (({
            document?: string;
        }) | ({
            address?: Address;
        }) | ({
            companyName?: string;
        }) | ({
            birthDate?: dependency_3.google.protobuf.Timestamp;
        })))) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("userId" in data && data.userId != undefined) {
                    this.userId = data.userId;
                }
                if ("firstName" in data && data.firstName != undefined) {
                    this.firstName = data.firstName;
                }
                if ("lastName" in data && data.lastName != undefined) {
                    this.lastName = data.lastName;
                }
                if ("email" in data && data.email != undefined) {
                    this.email = data.email;
                }
                if ("organizationId" in data && data.organizationId != undefined) {
                    this.organizationId = data.organizationId;
                }
                if ("workspaceId" in data && data.workspaceId != undefined) {
                    this.workspaceId = data.workspaceId;
                }
                if ("username" in data && data.username != undefined) {
                    this.username = data.username;
                }
                if ("document" in data && data.document != undefined) {
                    this.document = data.document;
                }
                if ("externalId" in data && data.externalId != undefined) {
                    this.externalId = data.externalId;
                }
                if ("address" in data && data.address != undefined) {
                    this.address = data.address;
                }
                if ("phone" in data && data.phone != undefined) {
                    this.phone = data.phone;
                }
                if ("companyName" in data && data.companyName != undefined) {
                    this.companyName = data.companyName;
                }
                if ("birthDate" in data && data.birthDate != undefined) {
                    this.birthDate = data.birthDate;
                }
            }
        }
        get userId() {
            return pb_1.Message.getFieldWithDefault(this, 1, "") as string;
        }
        set userId(value: string) {
            pb_1.Message.setField(this, 1, value);
        }
        get firstName() {
            return pb_1.Message.getFieldWithDefault(this, 2, "") as string;
        }
        set firstName(value: string) {
            pb_1.Message.setField(this, 2, value);
        }
        get lastName() {
            return pb_1.Message.getFieldWithDefault(this, 3, "") as string;
        }
        set lastName(value: string) {
            pb_1.Message.setField(this, 3, value);
        }
        get email() {
            return pb_1.Message.getFieldWithDefault(this, 4, "") as string;
        }
        set email(value: string) {
            pb_1.Message.setField(this, 4, value);
        }
        get organizationId() {
            return pb_1.Message.getFieldWithDefault(this, 5, "") as string;
        }
        set organizationId(value: string) {
            pb_1.Message.setField(this, 5, value);
        }
        get workspaceId() {
            return pb_1.Message.getFieldWithDefault(this, 6, "") as string;
        }
        set workspaceId(value: string) {
            pb_1.Message.setField(this, 6, value);
        }
        get username() {
            return pb_1.Message.getFieldWithDefault(this, 7, "") as string;
        }
        set username(value: string) {
            pb_1.Message.setField(this, 7, value);
        }
        get document() {
            return pb_1.Message.getFieldWithDefault(this, 8, "") as string;
        }
        set document(value: string) {
            pb_1.Message.setOneofField(this, 8, this.#one_of_decls[0], value);
        }
        get hasDocument() {
            return pb_1.Message.getField(this, 8) != null;
        }
        get externalId() {
            return pb_1.Message.getFieldWithDefault(this, 9, "") as string;
        }
        set externalId(value: string) {
            pb_1.Message.setField(this, 9, value);
        }
        get address() {
            return pb_1.Message.getWrapperField(this, Address, 10) as Address;
        }
        set address(value: Address) {
            pb_1.Message.setOneofWrapperField(this, 10, this.#one_of_decls[1], value);
        }
        get hasAddress() {
            return pb_1.Message.getField(this, 10) != null;
        }
        get phone() {
            return pb_1.Message.getFieldWithDefault(this, 11, "") as string;
        }
        set phone(value: string) {
            pb_1.Message.setField(this, 11, value);
        }
        get companyName() {
            return pb_1.Message.getFieldWithDefault(this, 12, "") as string;
        }
        set companyName(value: string) {
            pb_1.Message.setOneofField(this, 12, this.#one_of_decls[2], value);
        }
        get hasCompanyName() {
            return pb_1.Message.getField(this, 12) != null;
        }
        get birthDate() {
            return pb_1.Message.getWrapperField(this, dependency_3.google.protobuf.Timestamp, 13) as dependency_3.google.protobuf.Timestamp;
        }
        set birthDate(value: dependency_3.google.protobuf.Timestamp) {
            pb_1.Message.setOneofWrapperField(this, 13, this.#one_of_decls[3], value);
        }
        get hasBirthDate() {
            return pb_1.Message.getField(this, 13) != null;
        }
        get _document() {
            const cases: {
                [index: number]: "none" | "document";
            } = {
                0: "none",
                8: "document"
            };
            return cases[pb_1.Message.computeOneofCase(this, [8])];
        }
        get _address() {
            const cases: {
                [index: number]: "none" | "address";
            } = {
                0: "none",
                10: "address"
            };
            return cases[pb_1.Message.computeOneofCase(this, [10])];
        }
        get _company_name() {
            const cases: {
                [index: number]: "none" | "companyName";
            } = {
                0: "none",
                12: "companyName"
            };
            return cases[pb_1.Message.computeOneofCase(this, [12])];
        }
        get _birth_date() {
            const cases: {
                [index: number]: "none" | "birthDate";
            } = {
                0: "none",
                13: "birthDate"
            };
            return cases[pb_1.Message.computeOneofCase(this, [13])];
        }
        static fromObject(data: {
            userId?: string;
            firstName?: string;
            lastName?: string;
            email?: string;
            organizationId?: string;
            workspaceId?: string;
            username?: string;
            document?: string;
            externalId?: string;
            address?: ReturnType<typeof Address.prototype.toObject>;
            phone?: string;
            companyName?: string;
            birthDate?: ReturnType<typeof dependency_3.google.protobuf.Timestamp.prototype.toObject>;
        }): UpdateAuthUserRequest {
            const message = new UpdateAuthUserRequest({});
            if (data.userId != null) {
                message.userId = data.userId;
            }
            if (data.firstName != null) {
                message.firstName = data.firstName;
            }
            if (data.lastName != null) {
                message.lastName = data.lastName;
            }
            if (data.email != null) {
                message.email = data.email;
            }
            if (data.organizationId != null) {
                message.organizationId = data.organizationId;
            }
            if (data.workspaceId != null) {
                message.workspaceId = data.workspaceId;
            }
            if (data.username != null) {
                message.username = data.username;
            }
            if (data.document != null) {
                message.document = data.document;
            }
            if (data.externalId != null) {
                message.externalId = data.externalId;
            }
            if (data.address != null) {
                message.address = Address.fromObject(data.address);
            }
            if (data.phone != null) {
                message.phone = data.phone;
            }
            if (data.companyName != null) {
                message.companyName = data.companyName;
            }
            if (data.birthDate != null) {
                message.birthDate = dependency_3.google.protobuf.Timestamp.fromObject(data.birthDate);
            }
            return message;
        }
        toObject() {
            const data: {
                userId?: string;
                firstName?: string;
                lastName?: string;
                email?: string;
                organizationId?: string;
                workspaceId?: string;
                username?: string;
                document?: string;
                externalId?: string;
                address?: ReturnType<typeof Address.prototype.toObject>;
                phone?: string;
                companyName?: string;
                birthDate?: ReturnType<typeof dependency_3.google.protobuf.Timestamp.prototype.toObject>;
            } = {};
            if (this.userId != null) {
                data.userId = this.userId;
            }
            if (this.firstName != null) {
                data.firstName = this.firstName;
            }
            if (this.lastName != null) {
                data.lastName = this.lastName;
            }
            if (this.email != null) {
                data.email = this.email;
            }
            if (this.organizationId != null) {
                data.organizationId = this.organizationId;
            }
            if (this.workspaceId != null) {
                data.workspaceId = this.workspaceId;
            }
            if (this.username != null) {
                data.username = this.username;
            }
            if (this.document != null) {
                data.document = this.document;
            }
            if (this.externalId != null) {
                data.externalId = this.externalId;
            }
            if (this.address != null) {
                data.address = this.address.toObject();
            }
            if (this.phone != null) {
                data.phone = this.phone;
            }
            if (this.companyName != null) {
                data.companyName = this.companyName;
            }
            if (this.birthDate != null) {
                data.birthDate = this.birthDate.toObject();
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.userId.length)
                writer.writeString(1, this.userId);
            if (this.firstName.length)
                writer.writeString(2, this.firstName);
            if (this.lastName.length)
                writer.writeString(3, this.lastName);
            if (this.email.length)
                writer.writeString(4, this.email);
            if (this.organizationId.length)
                writer.writeString(5, this.organizationId);
            if (this.workspaceId.length)
                writer.writeString(6, this.workspaceId);
            if (this.username.length)
                writer.writeString(7, this.username);
            if (this.hasDocument)
                writer.writeString(8, this.document);
            if (this.externalId.length)
                writer.writeString(9, this.externalId);
            if (this.hasAddress)
                writer.writeMessage(10, this.address, () => this.address.serialize(writer));
            if (this.phone.length)
                writer.writeString(11, this.phone);
            if (this.hasCompanyName)
                writer.writeString(12, this.companyName);
            if (this.hasBirthDate)
                writer.writeMessage(13, this.birthDate, () => this.birthDate.serialize(writer));
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): UpdateAuthUserRequest {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new UpdateAuthUserRequest();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.userId = reader.readString();
                        break;
                    case 2:
                        message.firstName = reader.readString();
                        break;
                    case 3:
                        message.lastName = reader.readString();
                        break;
                    case 4:
                        message.email = reader.readString();
                        break;
                    case 5:
                        message.organizationId = reader.readString();
                        break;
                    case 6:
                        message.workspaceId = reader.readString();
                        break;
                    case 7:
                        message.username = reader.readString();
                        break;
                    case 8:
                        message.document = reader.readString();
                        break;
                    case 9:
                        message.externalId = reader.readString();
                        break;
                    case 10:
                        reader.readMessage(message.address, () => message.address = Address.deserialize(reader));
                        break;
                    case 11:
                        message.phone = reader.readString();
                        break;
                    case 12:
                        message.companyName = reader.readString();
                        break;
                    case 13:
                        reader.readMessage(message.birthDate, () => message.birthDate = dependency_3.google.protobuf.Timestamp.deserialize(reader));
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): UpdateAuthUserRequest {
            return UpdateAuthUserRequest.deserialize(bytes);
        }
    }
    export class UpdateAuthUserResponse extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {}) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") { }
        }
        static fromObject(data: {}): UpdateAuthUserResponse {
            const message = new UpdateAuthUserResponse({});
            return message;
        }
        toObject() {
            const data: {} = {};
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): UpdateAuthUserResponse {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new UpdateAuthUserResponse();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): UpdateAuthUserResponse {
            return UpdateAuthUserResponse.deserialize(bytes);
        }
    }
    export class GetAuthUserRequest extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            userId?: string;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("userId" in data && data.userId != undefined) {
                    this.userId = data.userId;
                }
            }
        }
        get userId() {
            return pb_1.Message.getFieldWithDefault(this, 1, "") as string;
        }
        set userId(value: string) {
            pb_1.Message.setField(this, 1, value);
        }
        static fromObject(data: {
            userId?: string;
        }): GetAuthUserRequest {
            const message = new GetAuthUserRequest({});
            if (data.userId != null) {
                message.userId = data.userId;
            }
            return message;
        }
        toObject() {
            const data: {
                userId?: string;
            } = {};
            if (this.userId != null) {
                data.userId = this.userId;
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.userId.length)
                writer.writeString(1, this.userId);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): GetAuthUserRequest {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new GetAuthUserRequest();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.userId = reader.readString();
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): GetAuthUserRequest {
            return GetAuthUserRequest.deserialize(bytes);
        }
    }
    export class GetAuthUserByEmailRequest extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            email?: string;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("email" in data && data.email != undefined) {
                    this.email = data.email;
                }
            }
        }
        get email() {
            return pb_1.Message.getFieldWithDefault(this, 1, "") as string;
        }
        set email(value: string) {
            pb_1.Message.setField(this, 1, value);
        }
        static fromObject(data: {
            email?: string;
        }): GetAuthUserByEmailRequest {
            const message = new GetAuthUserByEmailRequest({});
            if (data.email != null) {
                message.email = data.email;
            }
            return message;
        }
        toObject() {
            const data: {
                email?: string;
            } = {};
            if (this.email != null) {
                data.email = this.email;
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.email.length)
                writer.writeString(1, this.email);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): GetAuthUserByEmailRequest {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new GetAuthUserByEmailRequest();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.email = reader.readString();
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): GetAuthUserByEmailRequest {
            return GetAuthUserByEmailRequest.deserialize(bytes);
        }
    }
    export class GetAuthUserByEmailResponse extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            user?: AuthUser;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("user" in data && data.user != undefined) {
                    this.user = data.user;
                }
            }
        }
        get user() {
            return pb_1.Message.getWrapperField(this, AuthUser, 1) as AuthUser;
        }
        set user(value: AuthUser) {
            pb_1.Message.setWrapperField(this, 1, value);
        }
        get hasUser() {
            return pb_1.Message.getField(this, 1) != null;
        }
        static fromObject(data: {
            user?: ReturnType<typeof AuthUser.prototype.toObject>;
        }): GetAuthUserByEmailResponse {
            const message = new GetAuthUserByEmailResponse({});
            if (data.user != null) {
                message.user = AuthUser.fromObject(data.user);
            }
            return message;
        }
        toObject() {
            const data: {
                user?: ReturnType<typeof AuthUser.prototype.toObject>;
            } = {};
            if (this.user != null) {
                data.user = this.user.toObject();
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.hasUser)
                writer.writeMessage(1, this.user, () => this.user.serialize(writer));
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): GetAuthUserByEmailResponse {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new GetAuthUserByEmailResponse();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        reader.readMessage(message.user, () => message.user = AuthUser.deserialize(reader));
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): GetAuthUserByEmailResponse {
            return GetAuthUserByEmailResponse.deserialize(bytes);
        }
    }
    export class GetAuthUserResponse extends pb_1.Message {
        #one_of_decls: number[][] = [[17], [18]];
        constructor(data?: any[] | ({
            email?: string;
            firstName?: string;
            lastName?: string;
            id?: string;
            organizationId?: string;
            workspaceId?: string;
            tenantId?: string;
            externalId?: string;
            emailVerified?: boolean;
            phoneVerified?: boolean;
            phone?: string;
            enabled?: boolean;
            sub?: string;
            name?: string;
            document?: string;
            address?: Address;
        } & (({
            companyName?: string;
        }) | ({
            birthDate?: dependency_3.google.protobuf.Timestamp;
        })))) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("email" in data && data.email != undefined) {
                    this.email = data.email;
                }
                if ("firstName" in data && data.firstName != undefined) {
                    this.firstName = data.firstName;
                }
                if ("lastName" in data && data.lastName != undefined) {
                    this.lastName = data.lastName;
                }
                if ("id" in data && data.id != undefined) {
                    this.id = data.id;
                }
                if ("organizationId" in data && data.organizationId != undefined) {
                    this.organizationId = data.organizationId;
                }
                if ("workspaceId" in data && data.workspaceId != undefined) {
                    this.workspaceId = data.workspaceId;
                }
                if ("tenantId" in data && data.tenantId != undefined) {
                    this.tenantId = data.tenantId;
                }
                if ("externalId" in data && data.externalId != undefined) {
                    this.externalId = data.externalId;
                }
                if ("emailVerified" in data && data.emailVerified != undefined) {
                    this.emailVerified = data.emailVerified;
                }
                if ("phoneVerified" in data && data.phoneVerified != undefined) {
                    this.phoneVerified = data.phoneVerified;
                }
                if ("phone" in data && data.phone != undefined) {
                    this.phone = data.phone;
                }
                if ("enabled" in data && data.enabled != undefined) {
                    this.enabled = data.enabled;
                }
                if ("sub" in data && data.sub != undefined) {
                    this.sub = data.sub;
                }
                if ("name" in data && data.name != undefined) {
                    this.name = data.name;
                }
                if ("document" in data && data.document != undefined) {
                    this.document = data.document;
                }
                if ("address" in data && data.address != undefined) {
                    this.address = data.address;
                }
                if ("companyName" in data && data.companyName != undefined) {
                    this.companyName = data.companyName;
                }
                if ("birthDate" in data && data.birthDate != undefined) {
                    this.birthDate = data.birthDate;
                }
            }
        }
        get email() {
            return pb_1.Message.getFieldWithDefault(this, 1, "") as string;
        }
        set email(value: string) {
            pb_1.Message.setField(this, 1, value);
        }
        get firstName() {
            return pb_1.Message.getFieldWithDefault(this, 2, "") as string;
        }
        set firstName(value: string) {
            pb_1.Message.setField(this, 2, value);
        }
        get lastName() {
            return pb_1.Message.getFieldWithDefault(this, 3, "") as string;
        }
        set lastName(value: string) {
            pb_1.Message.setField(this, 3, value);
        }
        get id() {
            return pb_1.Message.getFieldWithDefault(this, 4, "") as string;
        }
        set id(value: string) {
            pb_1.Message.setField(this, 4, value);
        }
        get organizationId() {
            return pb_1.Message.getFieldWithDefault(this, 5, "") as string;
        }
        set organizationId(value: string) {
            pb_1.Message.setField(this, 5, value);
        }
        get workspaceId() {
            return pb_1.Message.getFieldWithDefault(this, 6, "") as string;
        }
        set workspaceId(value: string) {
            pb_1.Message.setField(this, 6, value);
        }
        get tenantId() {
            return pb_1.Message.getFieldWithDefault(this, 7, "") as string;
        }
        set tenantId(value: string) {
            pb_1.Message.setField(this, 7, value);
        }
        get externalId() {
            return pb_1.Message.getFieldWithDefault(this, 8, "") as string;
        }
        set externalId(value: string) {
            pb_1.Message.setField(this, 8, value);
        }
        get emailVerified() {
            return pb_1.Message.getFieldWithDefault(this, 9, false) as boolean;
        }
        set emailVerified(value: boolean) {
            pb_1.Message.setField(this, 9, value);
        }
        get phoneVerified() {
            return pb_1.Message.getFieldWithDefault(this, 10, false) as boolean;
        }
        set phoneVerified(value: boolean) {
            pb_1.Message.setField(this, 10, value);
        }
        get phone() {
            return pb_1.Message.getFieldWithDefault(this, 11, "") as string;
        }
        set phone(value: string) {
            pb_1.Message.setField(this, 11, value);
        }
        get enabled() {
            return pb_1.Message.getFieldWithDefault(this, 12, false) as boolean;
        }
        set enabled(value: boolean) {
            pb_1.Message.setField(this, 12, value);
        }
        get sub() {
            return pb_1.Message.getFieldWithDefault(this, 13, "") as string;
        }
        set sub(value: string) {
            pb_1.Message.setField(this, 13, value);
        }
        get name() {
            return pb_1.Message.getFieldWithDefault(this, 14, "") as string;
        }
        set name(value: string) {
            pb_1.Message.setField(this, 14, value);
        }
        get document() {
            return pb_1.Message.getFieldWithDefault(this, 15, "") as string;
        }
        set document(value: string) {
            pb_1.Message.setField(this, 15, value);
        }
        get address() {
            return pb_1.Message.getWrapperField(this, Address, 16) as Address;
        }
        set address(value: Address) {
            pb_1.Message.setWrapperField(this, 16, value);
        }
        get hasAddress() {
            return pb_1.Message.getField(this, 16) != null;
        }
        get companyName() {
            return pb_1.Message.getFieldWithDefault(this, 17, "") as string;
        }
        set companyName(value: string) {
            pb_1.Message.setOneofField(this, 17, this.#one_of_decls[0], value);
        }
        get hasCompanyName() {
            return pb_1.Message.getField(this, 17) != null;
        }
        get birthDate() {
            return pb_1.Message.getWrapperField(this, dependency_3.google.protobuf.Timestamp, 18) as dependency_3.google.protobuf.Timestamp;
        }
        set birthDate(value: dependency_3.google.protobuf.Timestamp) {
            pb_1.Message.setOneofWrapperField(this, 18, this.#one_of_decls[1], value);
        }
        get hasBirthDate() {
            return pb_1.Message.getField(this, 18) != null;
        }
        get _company_name() {
            const cases: {
                [index: number]: "none" | "companyName";
            } = {
                0: "none",
                17: "companyName"
            };
            return cases[pb_1.Message.computeOneofCase(this, [17])];
        }
        get _birth_date() {
            const cases: {
                [index: number]: "none" | "birthDate";
            } = {
                0: "none",
                18: "birthDate"
            };
            return cases[pb_1.Message.computeOneofCase(this, [18])];
        }
        static fromObject(data: {
            email?: string;
            firstName?: string;
            lastName?: string;
            id?: string;
            organizationId?: string;
            workspaceId?: string;
            tenantId?: string;
            externalId?: string;
            emailVerified?: boolean;
            phoneVerified?: boolean;
            phone?: string;
            enabled?: boolean;
            sub?: string;
            name?: string;
            document?: string;
            address?: ReturnType<typeof Address.prototype.toObject>;
            companyName?: string;
            birthDate?: ReturnType<typeof dependency_3.google.protobuf.Timestamp.prototype.toObject>;
        }): GetAuthUserResponse {
            const message = new GetAuthUserResponse({});
            if (data.email != null) {
                message.email = data.email;
            }
            if (data.firstName != null) {
                message.firstName = data.firstName;
            }
            if (data.lastName != null) {
                message.lastName = data.lastName;
            }
            if (data.id != null) {
                message.id = data.id;
            }
            if (data.organizationId != null) {
                message.organizationId = data.organizationId;
            }
            if (data.workspaceId != null) {
                message.workspaceId = data.workspaceId;
            }
            if (data.tenantId != null) {
                message.tenantId = data.tenantId;
            }
            if (data.externalId != null) {
                message.externalId = data.externalId;
            }
            if (data.emailVerified != null) {
                message.emailVerified = data.emailVerified;
            }
            if (data.phoneVerified != null) {
                message.phoneVerified = data.phoneVerified;
            }
            if (data.phone != null) {
                message.phone = data.phone;
            }
            if (data.enabled != null) {
                message.enabled = data.enabled;
            }
            if (data.sub != null) {
                message.sub = data.sub;
            }
            if (data.name != null) {
                message.name = data.name;
            }
            if (data.document != null) {
                message.document = data.document;
            }
            if (data.address != null) {
                message.address = Address.fromObject(data.address);
            }
            if (data.companyName != null) {
                message.companyName = data.companyName;
            }
            if (data.birthDate != null) {
                message.birthDate = dependency_3.google.protobuf.Timestamp.fromObject(data.birthDate);
            }
            return message;
        }
        toObject() {
            const data: {
                email?: string;
                firstName?: string;
                lastName?: string;
                id?: string;
                organizationId?: string;
                workspaceId?: string;
                tenantId?: string;
                externalId?: string;
                emailVerified?: boolean;
                phoneVerified?: boolean;
                phone?: string;
                enabled?: boolean;
                sub?: string;
                name?: string;
                document?: string;
                address?: ReturnType<typeof Address.prototype.toObject>;
                companyName?: string;
                birthDate?: ReturnType<typeof dependency_3.google.protobuf.Timestamp.prototype.toObject>;
            } = {};
            if (this.email != null) {
                data.email = this.email;
            }
            if (this.firstName != null) {
                data.firstName = this.firstName;
            }
            if (this.lastName != null) {
                data.lastName = this.lastName;
            }
            if (this.id != null) {
                data.id = this.id;
            }
            if (this.organizationId != null) {
                data.organizationId = this.organizationId;
            }
            if (this.workspaceId != null) {
                data.workspaceId = this.workspaceId;
            }
            if (this.tenantId != null) {
                data.tenantId = this.tenantId;
            }
            if (this.externalId != null) {
                data.externalId = this.externalId;
            }
            if (this.emailVerified != null) {
                data.emailVerified = this.emailVerified;
            }
            if (this.phoneVerified != null) {
                data.phoneVerified = this.phoneVerified;
            }
            if (this.phone != null) {
                data.phone = this.phone;
            }
            if (this.enabled != null) {
                data.enabled = this.enabled;
            }
            if (this.sub != null) {
                data.sub = this.sub;
            }
            if (this.name != null) {
                data.name = this.name;
            }
            if (this.document != null) {
                data.document = this.document;
            }
            if (this.address != null) {
                data.address = this.address.toObject();
            }
            if (this.companyName != null) {
                data.companyName = this.companyName;
            }
            if (this.birthDate != null) {
                data.birthDate = this.birthDate.toObject();
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.email.length)
                writer.writeString(1, this.email);
            if (this.firstName.length)
                writer.writeString(2, this.firstName);
            if (this.lastName.length)
                writer.writeString(3, this.lastName);
            if (this.id.length)
                writer.writeString(4, this.id);
            if (this.organizationId.length)
                writer.writeString(5, this.organizationId);
            if (this.workspaceId.length)
                writer.writeString(6, this.workspaceId);
            if (this.tenantId.length)
                writer.writeString(7, this.tenantId);
            if (this.externalId.length)
                writer.writeString(8, this.externalId);
            if (this.emailVerified != false)
                writer.writeBool(9, this.emailVerified);
            if (this.phoneVerified != false)
                writer.writeBool(10, this.phoneVerified);
            if (this.phone.length)
                writer.writeString(11, this.phone);
            if (this.enabled != false)
                writer.writeBool(12, this.enabled);
            if (this.sub.length)
                writer.writeString(13, this.sub);
            if (this.name.length)
                writer.writeString(14, this.name);
            if (this.document.length)
                writer.writeString(15, this.document);
            if (this.hasAddress)
                writer.writeMessage(16, this.address, () => this.address.serialize(writer));
            if (this.hasCompanyName)
                writer.writeString(17, this.companyName);
            if (this.hasBirthDate)
                writer.writeMessage(18, this.birthDate, () => this.birthDate.serialize(writer));
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): GetAuthUserResponse {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new GetAuthUserResponse();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.email = reader.readString();
                        break;
                    case 2:
                        message.firstName = reader.readString();
                        break;
                    case 3:
                        message.lastName = reader.readString();
                        break;
                    case 4:
                        message.id = reader.readString();
                        break;
                    case 5:
                        message.organizationId = reader.readString();
                        break;
                    case 6:
                        message.workspaceId = reader.readString();
                        break;
                    case 7:
                        message.tenantId = reader.readString();
                        break;
                    case 8:
                        message.externalId = reader.readString();
                        break;
                    case 9:
                        message.emailVerified = reader.readBool();
                        break;
                    case 10:
                        message.phoneVerified = reader.readBool();
                        break;
                    case 11:
                        message.phone = reader.readString();
                        break;
                    case 12:
                        message.enabled = reader.readBool();
                        break;
                    case 13:
                        message.sub = reader.readString();
                        break;
                    case 14:
                        message.name = reader.readString();
                        break;
                    case 15:
                        message.document = reader.readString();
                        break;
                    case 16:
                        reader.readMessage(message.address, () => message.address = Address.deserialize(reader));
                        break;
                    case 17:
                        message.companyName = reader.readString();
                        break;
                    case 18:
                        reader.readMessage(message.birthDate, () => message.birthDate = dependency_3.google.protobuf.Timestamp.deserialize(reader));
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): GetAuthUserResponse {
            return GetAuthUserResponse.deserialize(bytes);
        }
    }
    export class ResendValidationCodeChallengeRequest extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            sessionId?: string;
            method?: MethodValidationCode;
            username?: string;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("sessionId" in data && data.sessionId != undefined) {
                    this.sessionId = data.sessionId;
                }
                if ("method" in data && data.method != undefined) {
                    this.method = data.method;
                }
                if ("username" in data && data.username != undefined) {
                    this.username = data.username;
                }
            }
        }
        get sessionId() {
            return pb_1.Message.getFieldWithDefault(this, 1, "") as string;
        }
        set sessionId(value: string) {
            pb_1.Message.setField(this, 1, value);
        }
        get method() {
            return pb_1.Message.getFieldWithDefault(this, 2, MethodValidationCode.METHOD_VALIDATION_CODE_UNSPECIFIED) as MethodValidationCode;
        }
        set method(value: MethodValidationCode) {
            pb_1.Message.setField(this, 2, value);
        }
        get username() {
            return pb_1.Message.getFieldWithDefault(this, 3, "") as string;
        }
        set username(value: string) {
            pb_1.Message.setField(this, 3, value);
        }
        static fromObject(data: {
            sessionId?: string;
            method?: MethodValidationCode;
            username?: string;
        }): ResendValidationCodeChallengeRequest {
            const message = new ResendValidationCodeChallengeRequest({});
            if (data.sessionId != null) {
                message.sessionId = data.sessionId;
            }
            if (data.method != null) {
                message.method = data.method;
            }
            if (data.username != null) {
                message.username = data.username;
            }
            return message;
        }
        toObject() {
            const data: {
                sessionId?: string;
                method?: MethodValidationCode;
                username?: string;
            } = {};
            if (this.sessionId != null) {
                data.sessionId = this.sessionId;
            }
            if (this.method != null) {
                data.method = this.method;
            }
            if (this.username != null) {
                data.username = this.username;
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.sessionId.length)
                writer.writeString(1, this.sessionId);
            if (this.method != MethodValidationCode.METHOD_VALIDATION_CODE_UNSPECIFIED)
                writer.writeEnum(2, this.method);
            if (this.username.length)
                writer.writeString(3, this.username);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): ResendValidationCodeChallengeRequest {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new ResendValidationCodeChallengeRequest();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.sessionId = reader.readString();
                        break;
                    case 2:
                        message.method = reader.readEnum();
                        break;
                    case 3:
                        message.username = reader.readString();
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): ResendValidationCodeChallengeRequest {
            return ResendValidationCodeChallengeRequest.deserialize(bytes);
        }
    }
    export class ResendValidationCodeChallengeResponse extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            sessionId?: string;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("sessionId" in data && data.sessionId != undefined) {
                    this.sessionId = data.sessionId;
                }
            }
        }
        get sessionId() {
            return pb_1.Message.getFieldWithDefault(this, 1, "") as string;
        }
        set sessionId(value: string) {
            pb_1.Message.setField(this, 1, value);
        }
        static fromObject(data: {
            sessionId?: string;
        }): ResendValidationCodeChallengeResponse {
            const message = new ResendValidationCodeChallengeResponse({});
            if (data.sessionId != null) {
                message.sessionId = data.sessionId;
            }
            return message;
        }
        toObject() {
            const data: {
                sessionId?: string;
            } = {};
            if (this.sessionId != null) {
                data.sessionId = this.sessionId;
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.sessionId.length)
                writer.writeString(1, this.sessionId);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): ResendValidationCodeChallengeResponse {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new ResendValidationCodeChallengeResponse();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.sessionId = reader.readString();
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): ResendValidationCodeChallengeResponse {
            return ResendValidationCodeChallengeResponse.deserialize(bytes);
        }
    }
    export class LoginOTPRequest extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            identifier?: string;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("identifier" in data && data.identifier != undefined) {
                    this.identifier = data.identifier;
                }
            }
        }
        get identifier() {
            return pb_1.Message.getFieldWithDefault(this, 1, "") as string;
        }
        set identifier(value: string) {
            pb_1.Message.setField(this, 1, value);
        }
        static fromObject(data: {
            identifier?: string;
        }): LoginOTPRequest {
            const message = new LoginOTPRequest({});
            if (data.identifier != null) {
                message.identifier = data.identifier;
            }
            return message;
        }
        toObject() {
            const data: {
                identifier?: string;
            } = {};
            if (this.identifier != null) {
                data.identifier = this.identifier;
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.identifier.length)
                writer.writeString(1, this.identifier);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): LoginOTPRequest {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new LoginOTPRequest();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.identifier = reader.readString();
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): LoginOTPRequest {
            return LoginOTPRequest.deserialize(bytes);
        }
    }
    export class LoginOTPResponse extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            otpSent?: boolean;
            message?: string;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("otpSent" in data && data.otpSent != undefined) {
                    this.otpSent = data.otpSent;
                }
                if ("message" in data && data.message != undefined) {
                    this.message = data.message;
                }
            }
        }
        get otpSent() {
            return pb_1.Message.getFieldWithDefault(this, 1, false) as boolean;
        }
        set otpSent(value: boolean) {
            pb_1.Message.setField(this, 1, value);
        }
        get message() {
            return pb_1.Message.getFieldWithDefault(this, 2, "") as string;
        }
        set message(value: string) {
            pb_1.Message.setField(this, 2, value);
        }
        static fromObject(data: {
            otpSent?: boolean;
            message?: string;
        }): LoginOTPResponse {
            const message = new LoginOTPResponse({});
            if (data.otpSent != null) {
                message.otpSent = data.otpSent;
            }
            if (data.message != null) {
                message.message = data.message;
            }
            return message;
        }
        toObject() {
            const data: {
                otpSent?: boolean;
                message?: string;
            } = {};
            if (this.otpSent != null) {
                data.otpSent = this.otpSent;
            }
            if (this.message != null) {
                data.message = this.message;
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.otpSent != false)
                writer.writeBool(1, this.otpSent);
            if (this.message.length)
                writer.writeString(2, this.message);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): LoginOTPResponse {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new LoginOTPResponse();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.otpSent = reader.readBool();
                        break;
                    case 2:
                        message.message = reader.readString();
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): LoginOTPResponse {
            return LoginOTPResponse.deserialize(bytes);
        }
    }
    export class ValidateLoginOTPRequest extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            identifier?: string;
            otpCode?: string;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("identifier" in data && data.identifier != undefined) {
                    this.identifier = data.identifier;
                }
                if ("otpCode" in data && data.otpCode != undefined) {
                    this.otpCode = data.otpCode;
                }
            }
        }
        get identifier() {
            return pb_1.Message.getFieldWithDefault(this, 1, "") as string;
        }
        set identifier(value: string) {
            pb_1.Message.setField(this, 1, value);
        }
        get otpCode() {
            return pb_1.Message.getFieldWithDefault(this, 2, "") as string;
        }
        set otpCode(value: string) {
            pb_1.Message.setField(this, 2, value);
        }
        static fromObject(data: {
            identifier?: string;
            otpCode?: string;
        }): ValidateLoginOTPRequest {
            const message = new ValidateLoginOTPRequest({});
            if (data.identifier != null) {
                message.identifier = data.identifier;
            }
            if (data.otpCode != null) {
                message.otpCode = data.otpCode;
            }
            return message;
        }
        toObject() {
            const data: {
                identifier?: string;
                otpCode?: string;
            } = {};
            if (this.identifier != null) {
                data.identifier = this.identifier;
            }
            if (this.otpCode != null) {
                data.otpCode = this.otpCode;
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.identifier.length)
                writer.writeString(1, this.identifier);
            if (this.otpCode.length)
                writer.writeString(2, this.otpCode);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): ValidateLoginOTPRequest {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new ValidateLoginOTPRequest();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.identifier = reader.readString();
                        break;
                    case 2:
                        message.otpCode = reader.readString();
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): ValidateLoginOTPRequest {
            return ValidateLoginOTPRequest.deserialize(bytes);
        }
    }
    export class ValidateLoginOTPResponse extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            accessToken?: string;
            refreshToken?: string;
            tokenType?: string;
            expiresIn?: number;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("accessToken" in data && data.accessToken != undefined) {
                    this.accessToken = data.accessToken;
                }
                if ("refreshToken" in data && data.refreshToken != undefined) {
                    this.refreshToken = data.refreshToken;
                }
                if ("tokenType" in data && data.tokenType != undefined) {
                    this.tokenType = data.tokenType;
                }
                if ("expiresIn" in data && data.expiresIn != undefined) {
                    this.expiresIn = data.expiresIn;
                }
            }
        }
        get accessToken() {
            return pb_1.Message.getFieldWithDefault(this, 1, "") as string;
        }
        set accessToken(value: string) {
            pb_1.Message.setField(this, 1, value);
        }
        get refreshToken() {
            return pb_1.Message.getFieldWithDefault(this, 2, "") as string;
        }
        set refreshToken(value: string) {
            pb_1.Message.setField(this, 2, value);
        }
        get tokenType() {
            return pb_1.Message.getFieldWithDefault(this, 3, "") as string;
        }
        set tokenType(value: string) {
            pb_1.Message.setField(this, 3, value);
        }
        get expiresIn() {
            return pb_1.Message.getFieldWithDefault(this, 4, 0) as number;
        }
        set expiresIn(value: number) {
            pb_1.Message.setField(this, 4, value);
        }
        static fromObject(data: {
            accessToken?: string;
            refreshToken?: string;
            tokenType?: string;
            expiresIn?: number;
        }): ValidateLoginOTPResponse {
            const message = new ValidateLoginOTPResponse({});
            if (data.accessToken != null) {
                message.accessToken = data.accessToken;
            }
            if (data.refreshToken != null) {
                message.refreshToken = data.refreshToken;
            }
            if (data.tokenType != null) {
                message.tokenType = data.tokenType;
            }
            if (data.expiresIn != null) {
                message.expiresIn = data.expiresIn;
            }
            return message;
        }
        toObject() {
            const data: {
                accessToken?: string;
                refreshToken?: string;
                tokenType?: string;
                expiresIn?: number;
            } = {};
            if (this.accessToken != null) {
                data.accessToken = this.accessToken;
            }
            if (this.refreshToken != null) {
                data.refreshToken = this.refreshToken;
            }
            if (this.tokenType != null) {
                data.tokenType = this.tokenType;
            }
            if (this.expiresIn != null) {
                data.expiresIn = this.expiresIn;
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.accessToken.length)
                writer.writeString(1, this.accessToken);
            if (this.refreshToken.length)
                writer.writeString(2, this.refreshToken);
            if (this.tokenType.length)
                writer.writeString(3, this.tokenType);
            if (this.expiresIn != 0)
                writer.writeInt64(4, this.expiresIn);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): ValidateLoginOTPResponse {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new ValidateLoginOTPResponse();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.accessToken = reader.readString();
                        break;
                    case 2:
                        message.refreshToken = reader.readString();
                        break;
                    case 3:
                        message.tokenType = reader.readString();
                        break;
                    case 4:
                        message.expiresIn = reader.readInt64();
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): ValidateLoginOTPResponse {
            return ValidateLoginOTPResponse.deserialize(bytes);
        }
    }
    export class CheckTokenRequest extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            token?: string;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("token" in data && data.token != undefined) {
                    this.token = data.token;
                }
            }
        }
        get token() {
            return pb_1.Message.getFieldWithDefault(this, 1, "") as string;
        }
        set token(value: string) {
            pb_1.Message.setField(this, 1, value);
        }
        static fromObject(data: {
            token?: string;
        }): CheckTokenRequest {
            const message = new CheckTokenRequest({});
            if (data.token != null) {
                message.token = data.token;
            }
            return message;
        }
        toObject() {
            const data: {
                token?: string;
            } = {};
            if (this.token != null) {
                data.token = this.token;
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.token.length)
                writer.writeString(1, this.token);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): CheckTokenRequest {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new CheckTokenRequest();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.token = reader.readString();
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): CheckTokenRequest {
            return CheckTokenRequest.deserialize(bytes);
        }
    }
    export class CheckTokenResponse extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {}) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") { }
        }
        static fromObject(data: {}): CheckTokenResponse {
            const message = new CheckTokenResponse({});
            return message;
        }
        toObject() {
            const data: {} = {};
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): CheckTokenResponse {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new CheckTokenResponse();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): CheckTokenResponse {
            return CheckTokenResponse.deserialize(bytes);
        }
    }
    export class ResetMyPasswordRequest extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            sessionId?: string;
            code?: string;
            newPassword?: string;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("sessionId" in data && data.sessionId != undefined) {
                    this.sessionId = data.sessionId;
                }
                if ("code" in data && data.code != undefined) {
                    this.code = data.code;
                }
                if ("newPassword" in data && data.newPassword != undefined) {
                    this.newPassword = data.newPassword;
                }
            }
        }
        get sessionId() {
            return pb_1.Message.getFieldWithDefault(this, 1, "") as string;
        }
        set sessionId(value: string) {
            pb_1.Message.setField(this, 1, value);
        }
        get code() {
            return pb_1.Message.getFieldWithDefault(this, 2, "") as string;
        }
        set code(value: string) {
            pb_1.Message.setField(this, 2, value);
        }
        get newPassword() {
            return pb_1.Message.getFieldWithDefault(this, 3, "") as string;
        }
        set newPassword(value: string) {
            pb_1.Message.setField(this, 3, value);
        }
        static fromObject(data: {
            sessionId?: string;
            code?: string;
            newPassword?: string;
        }): ResetMyPasswordRequest {
            const message = new ResetMyPasswordRequest({});
            if (data.sessionId != null) {
                message.sessionId = data.sessionId;
            }
            if (data.code != null) {
                message.code = data.code;
            }
            if (data.newPassword != null) {
                message.newPassword = data.newPassword;
            }
            return message;
        }
        toObject() {
            const data: {
                sessionId?: string;
                code?: string;
                newPassword?: string;
            } = {};
            if (this.sessionId != null) {
                data.sessionId = this.sessionId;
            }
            if (this.code != null) {
                data.code = this.code;
            }
            if (this.newPassword != null) {
                data.newPassword = this.newPassword;
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.sessionId.length)
                writer.writeString(1, this.sessionId);
            if (this.code.length)
                writer.writeString(2, this.code);
            if (this.newPassword.length)
                writer.writeString(3, this.newPassword);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): ResetMyPasswordRequest {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new ResetMyPasswordRequest();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.sessionId = reader.readString();
                        break;
                    case 2:
                        message.code = reader.readString();
                        break;
                    case 3:
                        message.newPassword = reader.readString();
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): ResetMyPasswordRequest {
            return ResetMyPasswordRequest.deserialize(bytes);
        }
    }
    export class ResetMyPasswordResponse extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {}) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") { }
        }
        static fromObject(data: {}): ResetMyPasswordResponse {
            const message = new ResetMyPasswordResponse({});
            return message;
        }
        toObject() {
            const data: {} = {};
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): ResetMyPasswordResponse {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new ResetMyPasswordResponse();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): ResetMyPasswordResponse {
            return ResetMyPasswordResponse.deserialize(bytes);
        }
    }
    export class LoginRequest extends pb_1.Message {
        #one_of_decls: number[][] = [[1, 2, 3]];
        constructor(data?: any[] | ({} & (({
            passwordAuth?: PasswordAuth;
            passwordlessAuth?: never;
            serviceAuth?: never;
        } | {
            passwordAuth?: never;
            passwordlessAuth?: PasswordlessAuth;
            serviceAuth?: never;
        } | {
            passwordAuth?: never;
            passwordlessAuth?: never;
            serviceAuth?: ServiceAuth;
        })))) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("passwordAuth" in data && data.passwordAuth != undefined) {
                    this.passwordAuth = data.passwordAuth;
                }
                if ("passwordlessAuth" in data && data.passwordlessAuth != undefined) {
                    this.passwordlessAuth = data.passwordlessAuth;
                }
                if ("serviceAuth" in data && data.serviceAuth != undefined) {
                    this.serviceAuth = data.serviceAuth;
                }
            }
        }
        get passwordAuth() {
            return pb_1.Message.getWrapperField(this, PasswordAuth, 1) as PasswordAuth;
        }
        set passwordAuth(value: PasswordAuth) {
            pb_1.Message.setOneofWrapperField(this, 1, this.#one_of_decls[0], value);
        }
        get hasPasswordAuth() {
            return pb_1.Message.getField(this, 1) != null;
        }
        get passwordlessAuth() {
            return pb_1.Message.getWrapperField(this, PasswordlessAuth, 2) as PasswordlessAuth;
        }
        set passwordlessAuth(value: PasswordlessAuth) {
            pb_1.Message.setOneofWrapperField(this, 2, this.#one_of_decls[0], value);
        }
        get hasPasswordlessAuth() {
            return pb_1.Message.getField(this, 2) != null;
        }
        get serviceAuth() {
            return pb_1.Message.getWrapperField(this, ServiceAuth, 3) as ServiceAuth;
        }
        set serviceAuth(value: ServiceAuth) {
            pb_1.Message.setOneofWrapperField(this, 3, this.#one_of_decls[0], value);
        }
        get hasServiceAuth() {
            return pb_1.Message.getField(this, 3) != null;
        }
        get auth_method() {
            const cases: {
                [index: number]: "none" | "passwordAuth" | "passwordlessAuth" | "serviceAuth";
            } = {
                0: "none",
                1: "passwordAuth",
                2: "passwordlessAuth",
                3: "serviceAuth"
            };
            return cases[pb_1.Message.computeOneofCase(this, [1, 2, 3])];
        }
        static fromObject(data: {
            passwordAuth?: ReturnType<typeof PasswordAuth.prototype.toObject>;
            passwordlessAuth?: ReturnType<typeof PasswordlessAuth.prototype.toObject>;
            serviceAuth?: ReturnType<typeof ServiceAuth.prototype.toObject>;
        }): LoginRequest {
            const message = new LoginRequest({});
            if (data.passwordAuth != null) {
                message.passwordAuth = PasswordAuth.fromObject(data.passwordAuth);
            }
            if (data.passwordlessAuth != null) {
                message.passwordlessAuth = PasswordlessAuth.fromObject(data.passwordlessAuth);
            }
            if (data.serviceAuth != null) {
                message.serviceAuth = ServiceAuth.fromObject(data.serviceAuth);
            }
            return message;
        }
        toObject() {
            const data: {
                passwordAuth?: ReturnType<typeof PasswordAuth.prototype.toObject>;
                passwordlessAuth?: ReturnType<typeof PasswordlessAuth.prototype.toObject>;
                serviceAuth?: ReturnType<typeof ServiceAuth.prototype.toObject>;
            } = {};
            if (this.passwordAuth != null) {
                data.passwordAuth = this.passwordAuth.toObject();
            }
            if (this.passwordlessAuth != null) {
                data.passwordlessAuth = this.passwordlessAuth.toObject();
            }
            if (this.serviceAuth != null) {
                data.serviceAuth = this.serviceAuth.toObject();
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.hasPasswordAuth)
                writer.writeMessage(1, this.passwordAuth, () => this.passwordAuth.serialize(writer));
            if (this.hasPasswordlessAuth)
                writer.writeMessage(2, this.passwordlessAuth, () => this.passwordlessAuth.serialize(writer));
            if (this.hasServiceAuth)
                writer.writeMessage(3, this.serviceAuth, () => this.serviceAuth.serialize(writer));
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): LoginRequest {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new LoginRequest();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        reader.readMessage(message.passwordAuth, () => message.passwordAuth = PasswordAuth.deserialize(reader));
                        break;
                    case 2:
                        reader.readMessage(message.passwordlessAuth, () => message.passwordlessAuth = PasswordlessAuth.deserialize(reader));
                        break;
                    case 3:
                        reader.readMessage(message.serviceAuth, () => message.serviceAuth = ServiceAuth.deserialize(reader));
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): LoginRequest {
            return LoginRequest.deserialize(bytes);
        }
    }
    export class ServiceAuth extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            clientId?: string;
            clientSecret?: string;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("clientId" in data && data.clientId != undefined) {
                    this.clientId = data.clientId;
                }
                if ("clientSecret" in data && data.clientSecret != undefined) {
                    this.clientSecret = data.clientSecret;
                }
            }
        }
        get clientId() {
            return pb_1.Message.getFieldWithDefault(this, 1, "") as string;
        }
        set clientId(value: string) {
            pb_1.Message.setField(this, 1, value);
        }
        get clientSecret() {
            return pb_1.Message.getFieldWithDefault(this, 2, "") as string;
        }
        set clientSecret(value: string) {
            pb_1.Message.setField(this, 2, value);
        }
        static fromObject(data: {
            clientId?: string;
            clientSecret?: string;
        }): ServiceAuth {
            const message = new ServiceAuth({});
            if (data.clientId != null) {
                message.clientId = data.clientId;
            }
            if (data.clientSecret != null) {
                message.clientSecret = data.clientSecret;
            }
            return message;
        }
        toObject() {
            const data: {
                clientId?: string;
                clientSecret?: string;
            } = {};
            if (this.clientId != null) {
                data.clientId = this.clientId;
            }
            if (this.clientSecret != null) {
                data.clientSecret = this.clientSecret;
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.clientId.length)
                writer.writeString(1, this.clientId);
            if (this.clientSecret.length)
                writer.writeString(2, this.clientSecret);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): ServiceAuth {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new ServiceAuth();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.clientId = reader.readString();
                        break;
                    case 2:
                        message.clientSecret = reader.readString();
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): ServiceAuth {
            return ServiceAuth.deserialize(bytes);
        }
    }
    export class PasswordAuth extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            username?: string;
            password?: string;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("username" in data && data.username != undefined) {
                    this.username = data.username;
                }
                if ("password" in data && data.password != undefined) {
                    this.password = data.password;
                }
            }
        }
        get username() {
            return pb_1.Message.getFieldWithDefault(this, 1, "") as string;
        }
        set username(value: string) {
            pb_1.Message.setField(this, 1, value);
        }
        get password() {
            return pb_1.Message.getFieldWithDefault(this, 2, "") as string;
        }
        set password(value: string) {
            pb_1.Message.setField(this, 2, value);
        }
        static fromObject(data: {
            username?: string;
            password?: string;
        }): PasswordAuth {
            const message = new PasswordAuth({});
            if (data.username != null) {
                message.username = data.username;
            }
            if (data.password != null) {
                message.password = data.password;
            }
            return message;
        }
        toObject() {
            const data: {
                username?: string;
                password?: string;
            } = {};
            if (this.username != null) {
                data.username = this.username;
            }
            if (this.password != null) {
                data.password = this.password;
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.username.length)
                writer.writeString(1, this.username);
            if (this.password.length)
                writer.writeString(2, this.password);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): PasswordAuth {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new PasswordAuth();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.username = reader.readString();
                        break;
                    case 2:
                        message.password = reader.readString();
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): PasswordAuth {
            return PasswordAuth.deserialize(bytes);
        }
    }
    export class PasswordlessAuth extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            identifier?: string;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("identifier" in data && data.identifier != undefined) {
                    this.identifier = data.identifier;
                }
            }
        }
        get identifier() {
            return pb_1.Message.getFieldWithDefault(this, 1, "") as string;
        }
        set identifier(value: string) {
            pb_1.Message.setField(this, 1, value);
        }
        static fromObject(data: {
            identifier?: string;
        }): PasswordlessAuth {
            const message = new PasswordlessAuth({});
            if (data.identifier != null) {
                message.identifier = data.identifier;
            }
            return message;
        }
        toObject() {
            const data: {
                identifier?: string;
            } = {};
            if (this.identifier != null) {
                data.identifier = this.identifier;
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.identifier.length)
                writer.writeString(1, this.identifier);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): PasswordlessAuth {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new PasswordlessAuth();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.identifier = reader.readString();
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): PasswordlessAuth {
            return PasswordlessAuth.deserialize(bytes);
        }
    }
    export class LoginResponse extends pb_1.Message {
        #one_of_decls: number[][] = [[1, 2]];
        constructor(data?: any[] | ({} & (({
            tokens?: TokenResponse;
            mfaChallenge?: never;
        } | {
            tokens?: never;
            mfaChallenge?: MFAChallenge;
        })))) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("tokens" in data && data.tokens != undefined) {
                    this.tokens = data.tokens;
                }
                if ("mfaChallenge" in data && data.mfaChallenge != undefined) {
                    this.mfaChallenge = data.mfaChallenge;
                }
            }
        }
        get tokens() {
            return pb_1.Message.getWrapperField(this, TokenResponse, 1) as TokenResponse;
        }
        set tokens(value: TokenResponse) {
            pb_1.Message.setOneofWrapperField(this, 1, this.#one_of_decls[0], value);
        }
        get hasTokens() {
            return pb_1.Message.getField(this, 1) != null;
        }
        get mfaChallenge() {
            return pb_1.Message.getWrapperField(this, MFAChallenge, 2) as MFAChallenge;
        }
        set mfaChallenge(value: MFAChallenge) {
            pb_1.Message.setOneofWrapperField(this, 2, this.#one_of_decls[0], value);
        }
        get hasMfaChallenge() {
            return pb_1.Message.getField(this, 2) != null;
        }
        get response() {
            const cases: {
                [index: number]: "none" | "tokens" | "mfaChallenge";
            } = {
                0: "none",
                1: "tokens",
                2: "mfaChallenge"
            };
            return cases[pb_1.Message.computeOneofCase(this, [1, 2])];
        }
        static fromObject(data: {
            tokens?: ReturnType<typeof TokenResponse.prototype.toObject>;
            mfaChallenge?: ReturnType<typeof MFAChallenge.prototype.toObject>;
        }): LoginResponse {
            const message = new LoginResponse({});
            if (data.tokens != null) {
                message.tokens = TokenResponse.fromObject(data.tokens);
            }
            if (data.mfaChallenge != null) {
                message.mfaChallenge = MFAChallenge.fromObject(data.mfaChallenge);
            }
            return message;
        }
        toObject() {
            const data: {
                tokens?: ReturnType<typeof TokenResponse.prototype.toObject>;
                mfaChallenge?: ReturnType<typeof MFAChallenge.prototype.toObject>;
            } = {};
            if (this.tokens != null) {
                data.tokens = this.tokens.toObject();
            }
            if (this.mfaChallenge != null) {
                data.mfaChallenge = this.mfaChallenge.toObject();
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.hasTokens)
                writer.writeMessage(1, this.tokens, () => this.tokens.serialize(writer));
            if (this.hasMfaChallenge)
                writer.writeMessage(2, this.mfaChallenge, () => this.mfaChallenge.serialize(writer));
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): LoginResponse {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new LoginResponse();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        reader.readMessage(message.tokens, () => message.tokens = TokenResponse.deserialize(reader));
                        break;
                    case 2:
                        reader.readMessage(message.mfaChallenge, () => message.mfaChallenge = MFAChallenge.deserialize(reader));
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): LoginResponse {
            return LoginResponse.deserialize(bytes);
        }
    }
    export class MFAChallenge extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            mfaSessionId?: string;
            mfaMethods?: string[];
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [2], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("mfaSessionId" in data && data.mfaSessionId != undefined) {
                    this.mfaSessionId = data.mfaSessionId;
                }
                if ("mfaMethods" in data && data.mfaMethods != undefined) {
                    this.mfaMethods = data.mfaMethods;
                }
            }
        }
        get mfaSessionId() {
            return pb_1.Message.getFieldWithDefault(this, 1, "") as string;
        }
        set mfaSessionId(value: string) {
            pb_1.Message.setField(this, 1, value);
        }
        get mfaMethods() {
            return pb_1.Message.getFieldWithDefault(this, 2, []) as string[];
        }
        set mfaMethods(value: string[]) {
            pb_1.Message.setField(this, 2, value);
        }
        static fromObject(data: {
            mfaSessionId?: string;
            mfaMethods?: string[];
        }): MFAChallenge {
            const message = new MFAChallenge({});
            if (data.mfaSessionId != null) {
                message.mfaSessionId = data.mfaSessionId;
            }
            if (data.mfaMethods != null) {
                message.mfaMethods = data.mfaMethods;
            }
            return message;
        }
        toObject() {
            const data: {
                mfaSessionId?: string;
                mfaMethods?: string[];
            } = {};
            if (this.mfaSessionId != null) {
                data.mfaSessionId = this.mfaSessionId;
            }
            if (this.mfaMethods != null) {
                data.mfaMethods = this.mfaMethods;
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.mfaSessionId.length)
                writer.writeString(1, this.mfaSessionId);
            if (this.mfaMethods.length)
                writer.writeRepeatedString(2, this.mfaMethods);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): MFAChallenge {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new MFAChallenge();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.mfaSessionId = reader.readString();
                        break;
                    case 2:
                        pb_1.Message.addToRepeatedField(message, 2, reader.readString());
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): MFAChallenge {
            return MFAChallenge.deserialize(bytes);
        }
    }
    export class RefreshTokenRequest extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            refreshToken?: string;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("refreshToken" in data && data.refreshToken != undefined) {
                    this.refreshToken = data.refreshToken;
                }
            }
        }
        get refreshToken() {
            return pb_1.Message.getFieldWithDefault(this, 1, "") as string;
        }
        set refreshToken(value: string) {
            pb_1.Message.setField(this, 1, value);
        }
        static fromObject(data: {
            refreshToken?: string;
        }): RefreshTokenRequest {
            const message = new RefreshTokenRequest({});
            if (data.refreshToken != null) {
                message.refreshToken = data.refreshToken;
            }
            return message;
        }
        toObject() {
            const data: {
                refreshToken?: string;
            } = {};
            if (this.refreshToken != null) {
                data.refreshToken = this.refreshToken;
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.refreshToken.length)
                writer.writeString(1, this.refreshToken);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): RefreshTokenRequest {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new RefreshTokenRequest();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.refreshToken = reader.readString();
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): RefreshTokenRequest {
            return RefreshTokenRequest.deserialize(bytes);
        }
    }
    export class ForgotMyPasswordRequest extends pb_1.Message {
        #one_of_decls: number[][] = [[1, 2]];
        constructor(data?: any[] | ({} & (({
            email?: string;
            phone?: never;
        } | {
            email?: never;
            phone?: string;
        })))) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("email" in data && data.email != undefined) {
                    this.email = data.email;
                }
                if ("phone" in data && data.phone != undefined) {
                    this.phone = data.phone;
                }
            }
        }
        get email() {
            return pb_1.Message.getFieldWithDefault(this, 1, "") as string;
        }
        set email(value: string) {
            pb_1.Message.setOneofField(this, 1, this.#one_of_decls[0], value);
        }
        get hasEmail() {
            return pb_1.Message.getField(this, 1) != null;
        }
        get phone() {
            return pb_1.Message.getFieldWithDefault(this, 2, "") as string;
        }
        set phone(value: string) {
            pb_1.Message.setOneofField(this, 2, this.#one_of_decls[0], value);
        }
        get hasPhone() {
            return pb_1.Message.getField(this, 2) != null;
        }
        get type() {
            const cases: {
                [index: number]: "none" | "email" | "phone";
            } = {
                0: "none",
                1: "email",
                2: "phone"
            };
            return cases[pb_1.Message.computeOneofCase(this, [1, 2])];
        }
        static fromObject(data: {
            email?: string;
            phone?: string;
        }): ForgotMyPasswordRequest {
            const message = new ForgotMyPasswordRequest({});
            if (data.email != null) {
                message.email = data.email;
            }
            if (data.phone != null) {
                message.phone = data.phone;
            }
            return message;
        }
        toObject() {
            const data: {
                email?: string;
                phone?: string;
            } = {};
            if (this.email != null) {
                data.email = this.email;
            }
            if (this.phone != null) {
                data.phone = this.phone;
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.hasEmail)
                writer.writeString(1, this.email);
            if (this.hasPhone)
                writer.writeString(2, this.phone);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): ForgotMyPasswordRequest {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new ForgotMyPasswordRequest();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.email = reader.readString();
                        break;
                    case 2:
                        message.phone = reader.readString();
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): ForgotMyPasswordRequest {
            return ForgotMyPasswordRequest.deserialize(bytes);
        }
    }
    export class ForgotMyPasswordResponse extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            expiration?: number;
            emailMask?: string;
            phoneMask?: string;
            resetSessionId?: string;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("expiration" in data && data.expiration != undefined) {
                    this.expiration = data.expiration;
                }
                if ("emailMask" in data && data.emailMask != undefined) {
                    this.emailMask = data.emailMask;
                }
                if ("phoneMask" in data && data.phoneMask != undefined) {
                    this.phoneMask = data.phoneMask;
                }
                if ("resetSessionId" in data && data.resetSessionId != undefined) {
                    this.resetSessionId = data.resetSessionId;
                }
            }
        }
        get expiration() {
            return pb_1.Message.getFieldWithDefault(this, 1, 0) as number;
        }
        set expiration(value: number) {
            pb_1.Message.setField(this, 1, value);
        }
        get emailMask() {
            return pb_1.Message.getFieldWithDefault(this, 2, "") as string;
        }
        set emailMask(value: string) {
            pb_1.Message.setField(this, 2, value);
        }
        get phoneMask() {
            return pb_1.Message.getFieldWithDefault(this, 3, "") as string;
        }
        set phoneMask(value: string) {
            pb_1.Message.setField(this, 3, value);
        }
        get resetSessionId() {
            return pb_1.Message.getFieldWithDefault(this, 4, "") as string;
        }
        set resetSessionId(value: string) {
            pb_1.Message.setField(this, 4, value);
        }
        static fromObject(data: {
            expiration?: number;
            emailMask?: string;
            phoneMask?: string;
            resetSessionId?: string;
        }): ForgotMyPasswordResponse {
            const message = new ForgotMyPasswordResponse({});
            if (data.expiration != null) {
                message.expiration = data.expiration;
            }
            if (data.emailMask != null) {
                message.emailMask = data.emailMask;
            }
            if (data.phoneMask != null) {
                message.phoneMask = data.phoneMask;
            }
            if (data.resetSessionId != null) {
                message.resetSessionId = data.resetSessionId;
            }
            return message;
        }
        toObject() {
            const data: {
                expiration?: number;
                emailMask?: string;
                phoneMask?: string;
                resetSessionId?: string;
            } = {};
            if (this.expiration != null) {
                data.expiration = this.expiration;
            }
            if (this.emailMask != null) {
                data.emailMask = this.emailMask;
            }
            if (this.phoneMask != null) {
                data.phoneMask = this.phoneMask;
            }
            if (this.resetSessionId != null) {
                data.resetSessionId = this.resetSessionId;
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.expiration != 0)
                writer.writeInt32(1, this.expiration);
            if (this.emailMask.length)
                writer.writeString(2, this.emailMask);
            if (this.phoneMask.length)
                writer.writeString(3, this.phoneMask);
            if (this.resetSessionId.length)
                writer.writeString(4, this.resetSessionId);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): ForgotMyPasswordResponse {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new ForgotMyPasswordResponse();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.expiration = reader.readInt32();
                        break;
                    case 2:
                        message.emailMask = reader.readString();
                        break;
                    case 3:
                        message.phoneMask = reader.readString();
                        break;
                    case 4:
                        message.resetSessionId = reader.readString();
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): ForgotMyPasswordResponse {
            return ForgotMyPasswordResponse.deserialize(bytes);
        }
    }
    export class LogoutRequest extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            refreshToken?: string;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("refreshToken" in data && data.refreshToken != undefined) {
                    this.refreshToken = data.refreshToken;
                }
            }
        }
        get refreshToken() {
            return pb_1.Message.getFieldWithDefault(this, 1, "") as string;
        }
        set refreshToken(value: string) {
            pb_1.Message.setField(this, 1, value);
        }
        static fromObject(data: {
            refreshToken?: string;
        }): LogoutRequest {
            const message = new LogoutRequest({});
            if (data.refreshToken != null) {
                message.refreshToken = data.refreshToken;
            }
            return message;
        }
        toObject() {
            const data: {
                refreshToken?: string;
            } = {};
            if (this.refreshToken != null) {
                data.refreshToken = this.refreshToken;
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.refreshToken.length)
                writer.writeString(1, this.refreshToken);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): LogoutRequest {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new LogoutRequest();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.refreshToken = reader.readString();
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): LogoutRequest {
            return LogoutRequest.deserialize(bytes);
        }
    }
    export class LogoutResponse extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            success?: boolean;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("success" in data && data.success != undefined) {
                    this.success = data.success;
                }
            }
        }
        get success() {
            return pb_1.Message.getFieldWithDefault(this, 1, false) as boolean;
        }
        set success(value: boolean) {
            pb_1.Message.setField(this, 1, value);
        }
        static fromObject(data: {
            success?: boolean;
        }): LogoutResponse {
            const message = new LogoutResponse({});
            if (data.success != null) {
                message.success = data.success;
            }
            return message;
        }
        toObject() {
            const data: {
                success?: boolean;
            } = {};
            if (this.success != null) {
                data.success = this.success;
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.success != false)
                writer.writeBool(1, this.success);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): LogoutResponse {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new LogoutResponse();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.success = reader.readBool();
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): LogoutResponse {
            return LogoutResponse.deserialize(bytes);
        }
    }
    export class LoginOAuthRequest extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            redirectUri?: string;
            scope?: string[];
            codeChallengeMethod?: CodeChallengeMethod;
            provider?: string;
            organizationId?: string;
            workspaceId?: string;
            tenantId?: string;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [2], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("redirectUri" in data && data.redirectUri != undefined) {
                    this.redirectUri = data.redirectUri;
                }
                if ("scope" in data && data.scope != undefined) {
                    this.scope = data.scope;
                }
                if ("codeChallengeMethod" in data && data.codeChallengeMethod != undefined) {
                    this.codeChallengeMethod = data.codeChallengeMethod;
                }
                if ("provider" in data && data.provider != undefined) {
                    this.provider = data.provider;
                }
                if ("organizationId" in data && data.organizationId != undefined) {
                    this.organizationId = data.organizationId;
                }
                if ("workspaceId" in data && data.workspaceId != undefined) {
                    this.workspaceId = data.workspaceId;
                }
                if ("tenantId" in data && data.tenantId != undefined) {
                    this.tenantId = data.tenantId;
                }
            }
        }
        get redirectUri() {
            return pb_1.Message.getFieldWithDefault(this, 1, "") as string;
        }
        set redirectUri(value: string) {
            pb_1.Message.setField(this, 1, value);
        }
        get scope() {
            return pb_1.Message.getFieldWithDefault(this, 2, []) as string[];
        }
        set scope(value: string[]) {
            pb_1.Message.setField(this, 2, value);
        }
        get codeChallengeMethod() {
            return pb_1.Message.getFieldWithDefault(this, 3, CodeChallengeMethod.CODE_CHALLENGE_METHOD_UNSPECIFIED) as CodeChallengeMethod;
        }
        set codeChallengeMethod(value: CodeChallengeMethod) {
            pb_1.Message.setField(this, 3, value);
        }
        get provider() {
            return pb_1.Message.getFieldWithDefault(this, 4, "") as string;
        }
        set provider(value: string) {
            pb_1.Message.setField(this, 4, value);
        }
        get organizationId() {
            return pb_1.Message.getFieldWithDefault(this, 5, "") as string;
        }
        set organizationId(value: string) {
            pb_1.Message.setField(this, 5, value);
        }
        get workspaceId() {
            return pb_1.Message.getFieldWithDefault(this, 6, "") as string;
        }
        set workspaceId(value: string) {
            pb_1.Message.setField(this, 6, value);
        }
        get tenantId() {
            return pb_1.Message.getFieldWithDefault(this, 7, "") as string;
        }
        set tenantId(value: string) {
            pb_1.Message.setField(this, 7, value);
        }
        static fromObject(data: {
            redirectUri?: string;
            scope?: string[];
            codeChallengeMethod?: CodeChallengeMethod;
            provider?: string;
            organizationId?: string;
            workspaceId?: string;
            tenantId?: string;
        }): LoginOAuthRequest {
            const message = new LoginOAuthRequest({});
            if (data.redirectUri != null) {
                message.redirectUri = data.redirectUri;
            }
            if (data.scope != null) {
                message.scope = data.scope;
            }
            if (data.codeChallengeMethod != null) {
                message.codeChallengeMethod = data.codeChallengeMethod;
            }
            if (data.provider != null) {
                message.provider = data.provider;
            }
            if (data.organizationId != null) {
                message.organizationId = data.organizationId;
            }
            if (data.workspaceId != null) {
                message.workspaceId = data.workspaceId;
            }
            if (data.tenantId != null) {
                message.tenantId = data.tenantId;
            }
            return message;
        }
        toObject() {
            const data: {
                redirectUri?: string;
                scope?: string[];
                codeChallengeMethod?: CodeChallengeMethod;
                provider?: string;
                organizationId?: string;
                workspaceId?: string;
                tenantId?: string;
            } = {};
            if (this.redirectUri != null) {
                data.redirectUri = this.redirectUri;
            }
            if (this.scope != null) {
                data.scope = this.scope;
            }
            if (this.codeChallengeMethod != null) {
                data.codeChallengeMethod = this.codeChallengeMethod;
            }
            if (this.provider != null) {
                data.provider = this.provider;
            }
            if (this.organizationId != null) {
                data.organizationId = this.organizationId;
            }
            if (this.workspaceId != null) {
                data.workspaceId = this.workspaceId;
            }
            if (this.tenantId != null) {
                data.tenantId = this.tenantId;
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.redirectUri.length)
                writer.writeString(1, this.redirectUri);
            if (this.scope.length)
                writer.writeRepeatedString(2, this.scope);
            if (this.codeChallengeMethod != CodeChallengeMethod.CODE_CHALLENGE_METHOD_UNSPECIFIED)
                writer.writeEnum(3, this.codeChallengeMethod);
            if (this.provider.length)
                writer.writeString(4, this.provider);
            if (this.organizationId.length)
                writer.writeString(5, this.organizationId);
            if (this.workspaceId.length)
                writer.writeString(6, this.workspaceId);
            if (this.tenantId.length)
                writer.writeString(7, this.tenantId);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): LoginOAuthRequest {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new LoginOAuthRequest();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.redirectUri = reader.readString();
                        break;
                    case 2:
                        pb_1.Message.addToRepeatedField(message, 2, reader.readString());
                        break;
                    case 3:
                        message.codeChallengeMethod = reader.readEnum();
                        break;
                    case 4:
                        message.provider = reader.readString();
                        break;
                    case 5:
                        message.organizationId = reader.readString();
                        break;
                    case 6:
                        message.workspaceId = reader.readString();
                        break;
                    case 7:
                        message.tenantId = reader.readString();
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): LoginOAuthRequest {
            return LoginOAuthRequest.deserialize(bytes);
        }
    }
    export class LoginOAuthResponse extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            authUrl?: string;
            state?: string;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("authUrl" in data && data.authUrl != undefined) {
                    this.authUrl = data.authUrl;
                }
                if ("state" in data && data.state != undefined) {
                    this.state = data.state;
                }
            }
        }
        get authUrl() {
            return pb_1.Message.getFieldWithDefault(this, 1, "") as string;
        }
        set authUrl(value: string) {
            pb_1.Message.setField(this, 1, value);
        }
        get state() {
            return pb_1.Message.getFieldWithDefault(this, 2, "") as string;
        }
        set state(value: string) {
            pb_1.Message.setField(this, 2, value);
        }
        static fromObject(data: {
            authUrl?: string;
            state?: string;
        }): LoginOAuthResponse {
            const message = new LoginOAuthResponse({});
            if (data.authUrl != null) {
                message.authUrl = data.authUrl;
            }
            if (data.state != null) {
                message.state = data.state;
            }
            return message;
        }
        toObject() {
            const data: {
                authUrl?: string;
                state?: string;
            } = {};
            if (this.authUrl != null) {
                data.authUrl = this.authUrl;
            }
            if (this.state != null) {
                data.state = this.state;
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.authUrl.length)
                writer.writeString(1, this.authUrl);
            if (this.state.length)
                writer.writeString(2, this.state);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): LoginOAuthResponse {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new LoginOAuthResponse();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.authUrl = reader.readString();
                        break;
                    case 2:
                        message.state = reader.readString();
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): LoginOAuthResponse {
            return LoginOAuthResponse.deserialize(bytes);
        }
    }
    export class ValidateCodeOAuthRequest extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            code?: string;
            state?: string;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("code" in data && data.code != undefined) {
                    this.code = data.code;
                }
                if ("state" in data && data.state != undefined) {
                    this.state = data.state;
                }
            }
        }
        get code() {
            return pb_1.Message.getFieldWithDefault(this, 1, "") as string;
        }
        set code(value: string) {
            pb_1.Message.setField(this, 1, value);
        }
        get state() {
            return pb_1.Message.getFieldWithDefault(this, 2, "") as string;
        }
        set state(value: string) {
            pb_1.Message.setField(this, 2, value);
        }
        static fromObject(data: {
            code?: string;
            state?: string;
        }): ValidateCodeOAuthRequest {
            const message = new ValidateCodeOAuthRequest({});
            if (data.code != null) {
                message.code = data.code;
            }
            if (data.state != null) {
                message.state = data.state;
            }
            return message;
        }
        toObject() {
            const data: {
                code?: string;
                state?: string;
            } = {};
            if (this.code != null) {
                data.code = this.code;
            }
            if (this.state != null) {
                data.state = this.state;
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.code.length)
                writer.writeString(1, this.code);
            if (this.state.length)
                writer.writeString(2, this.state);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): ValidateCodeOAuthRequest {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new ValidateCodeOAuthRequest();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.code = reader.readString();
                        break;
                    case 2:
                        message.state = reader.readString();
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): ValidateCodeOAuthRequest {
            return ValidateCodeOAuthRequest.deserialize(bytes);
        }
    }
    export class ValidateCodeOAuthResponse extends pb_1.Message {
        #one_of_decls: number[][] = [[1, 2]];
        constructor(data?: any[] | ({} & (({
            tokens?: TokenResponse;
            mfaChallenge?: never;
        } | {
            tokens?: never;
            mfaChallenge?: MFAChallenge;
        })))) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("tokens" in data && data.tokens != undefined) {
                    this.tokens = data.tokens;
                }
                if ("mfaChallenge" in data && data.mfaChallenge != undefined) {
                    this.mfaChallenge = data.mfaChallenge;
                }
            }
        }
        get tokens() {
            return pb_1.Message.getWrapperField(this, TokenResponse, 1) as TokenResponse;
        }
        set tokens(value: TokenResponse) {
            pb_1.Message.setOneofWrapperField(this, 1, this.#one_of_decls[0], value);
        }
        get hasTokens() {
            return pb_1.Message.getField(this, 1) != null;
        }
        get mfaChallenge() {
            return pb_1.Message.getWrapperField(this, MFAChallenge, 2) as MFAChallenge;
        }
        set mfaChallenge(value: MFAChallenge) {
            pb_1.Message.setOneofWrapperField(this, 2, this.#one_of_decls[0], value);
        }
        get hasMfaChallenge() {
            return pb_1.Message.getField(this, 2) != null;
        }
        get response() {
            const cases: {
                [index: number]: "none" | "tokens" | "mfaChallenge";
            } = {
                0: "none",
                1: "tokens",
                2: "mfaChallenge"
            };
            return cases[pb_1.Message.computeOneofCase(this, [1, 2])];
        }
        static fromObject(data: {
            tokens?: ReturnType<typeof TokenResponse.prototype.toObject>;
            mfaChallenge?: ReturnType<typeof MFAChallenge.prototype.toObject>;
        }): ValidateCodeOAuthResponse {
            const message = new ValidateCodeOAuthResponse({});
            if (data.tokens != null) {
                message.tokens = TokenResponse.fromObject(data.tokens);
            }
            if (data.mfaChallenge != null) {
                message.mfaChallenge = MFAChallenge.fromObject(data.mfaChallenge);
            }
            return message;
        }
        toObject() {
            const data: {
                tokens?: ReturnType<typeof TokenResponse.prototype.toObject>;
                mfaChallenge?: ReturnType<typeof MFAChallenge.prototype.toObject>;
            } = {};
            if (this.tokens != null) {
                data.tokens = this.tokens.toObject();
            }
            if (this.mfaChallenge != null) {
                data.mfaChallenge = this.mfaChallenge.toObject();
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.hasTokens)
                writer.writeMessage(1, this.tokens, () => this.tokens.serialize(writer));
            if (this.hasMfaChallenge)
                writer.writeMessage(2, this.mfaChallenge, () => this.mfaChallenge.serialize(writer));
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): ValidateCodeOAuthResponse {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new ValidateCodeOAuthResponse();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        reader.readMessage(message.tokens, () => message.tokens = TokenResponse.deserialize(reader));
                        break;
                    case 2:
                        reader.readMessage(message.mfaChallenge, () => message.mfaChallenge = MFAChallenge.deserialize(reader));
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): ValidateCodeOAuthResponse {
            return ValidateCodeOAuthResponse.deserialize(bytes);
        }
    }
    export class RefreshTokenResponse extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            tokens?: TokenResponse;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("tokens" in data && data.tokens != undefined) {
                    this.tokens = data.tokens;
                }
            }
        }
        get tokens() {
            return pb_1.Message.getWrapperField(this, TokenResponse, 1) as TokenResponse;
        }
        set tokens(value: TokenResponse) {
            pb_1.Message.setWrapperField(this, 1, value);
        }
        get hasTokens() {
            return pb_1.Message.getField(this, 1) != null;
        }
        static fromObject(data: {
            tokens?: ReturnType<typeof TokenResponse.prototype.toObject>;
        }): RefreshTokenResponse {
            const message = new RefreshTokenResponse({});
            if (data.tokens != null) {
                message.tokens = TokenResponse.fromObject(data.tokens);
            }
            return message;
        }
        toObject() {
            const data: {
                tokens?: ReturnType<typeof TokenResponse.prototype.toObject>;
            } = {};
            if (this.tokens != null) {
                data.tokens = this.tokens.toObject();
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.hasTokens)
                writer.writeMessage(1, this.tokens, () => this.tokens.serialize(writer));
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): RefreshTokenResponse {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new RefreshTokenResponse();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        reader.readMessage(message.tokens, () => message.tokens = TokenResponse.deserialize(reader));
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): RefreshTokenResponse {
            return RefreshTokenResponse.deserialize(bytes);
        }
    }
    export class ValidateMFARequest extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            mfaSessionId?: string;
            code?: string;
            method?: MethodValidationCode;
            username?: string;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("mfaSessionId" in data && data.mfaSessionId != undefined) {
                    this.mfaSessionId = data.mfaSessionId;
                }
                if ("code" in data && data.code != undefined) {
                    this.code = data.code;
                }
                if ("method" in data && data.method != undefined) {
                    this.method = data.method;
                }
                if ("username" in data && data.username != undefined) {
                    this.username = data.username;
                }
            }
        }
        get mfaSessionId() {
            return pb_1.Message.getFieldWithDefault(this, 1, "") as string;
        }
        set mfaSessionId(value: string) {
            pb_1.Message.setField(this, 1, value);
        }
        get code() {
            return pb_1.Message.getFieldWithDefault(this, 2, "") as string;
        }
        set code(value: string) {
            pb_1.Message.setField(this, 2, value);
        }
        get method() {
            return pb_1.Message.getFieldWithDefault(this, 3, MethodValidationCode.METHOD_VALIDATION_CODE_UNSPECIFIED) as MethodValidationCode;
        }
        set method(value: MethodValidationCode) {
            pb_1.Message.setField(this, 3, value);
        }
        get username() {
            return pb_1.Message.getFieldWithDefault(this, 4, "") as string;
        }
        set username(value: string) {
            pb_1.Message.setField(this, 4, value);
        }
        static fromObject(data: {
            mfaSessionId?: string;
            code?: string;
            method?: MethodValidationCode;
            username?: string;
        }): ValidateMFARequest {
            const message = new ValidateMFARequest({});
            if (data.mfaSessionId != null) {
                message.mfaSessionId = data.mfaSessionId;
            }
            if (data.code != null) {
                message.code = data.code;
            }
            if (data.method != null) {
                message.method = data.method;
            }
            if (data.username != null) {
                message.username = data.username;
            }
            return message;
        }
        toObject() {
            const data: {
                mfaSessionId?: string;
                code?: string;
                method?: MethodValidationCode;
                username?: string;
            } = {};
            if (this.mfaSessionId != null) {
                data.mfaSessionId = this.mfaSessionId;
            }
            if (this.code != null) {
                data.code = this.code;
            }
            if (this.method != null) {
                data.method = this.method;
            }
            if (this.username != null) {
                data.username = this.username;
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.mfaSessionId.length)
                writer.writeString(1, this.mfaSessionId);
            if (this.code.length)
                writer.writeString(2, this.code);
            if (this.method != MethodValidationCode.METHOD_VALIDATION_CODE_UNSPECIFIED)
                writer.writeEnum(3, this.method);
            if (this.username.length)
                writer.writeString(4, this.username);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): ValidateMFARequest {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new ValidateMFARequest();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.mfaSessionId = reader.readString();
                        break;
                    case 2:
                        message.code = reader.readString();
                        break;
                    case 3:
                        message.method = reader.readEnum();
                        break;
                    case 4:
                        message.username = reader.readString();
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): ValidateMFARequest {
            return ValidateMFARequest.deserialize(bytes);
        }
    }
    export class ValidateMFAResponse extends pb_1.Message {
        #one_of_decls: number[][] = [[1, 2]];
        constructor(data?: any[] | ({} & (({
            tokens?: TokenResponse;
            mfaChallenge?: never;
        } | {
            tokens?: never;
            mfaChallenge?: MFAChallenge;
        })))) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("tokens" in data && data.tokens != undefined) {
                    this.tokens = data.tokens;
                }
                if ("mfaChallenge" in data && data.mfaChallenge != undefined) {
                    this.mfaChallenge = data.mfaChallenge;
                }
            }
        }
        get tokens() {
            return pb_1.Message.getWrapperField(this, TokenResponse, 1) as TokenResponse;
        }
        set tokens(value: TokenResponse) {
            pb_1.Message.setOneofWrapperField(this, 1, this.#one_of_decls[0], value);
        }
        get hasTokens() {
            return pb_1.Message.getField(this, 1) != null;
        }
        get mfaChallenge() {
            return pb_1.Message.getWrapperField(this, MFAChallenge, 2) as MFAChallenge;
        }
        set mfaChallenge(value: MFAChallenge) {
            pb_1.Message.setOneofWrapperField(this, 2, this.#one_of_decls[0], value);
        }
        get hasMfaChallenge() {
            return pb_1.Message.getField(this, 2) != null;
        }
        get response() {
            const cases: {
                [index: number]: "none" | "tokens" | "mfaChallenge";
            } = {
                0: "none",
                1: "tokens",
                2: "mfaChallenge"
            };
            return cases[pb_1.Message.computeOneofCase(this, [1, 2])];
        }
        static fromObject(data: {
            tokens?: ReturnType<typeof TokenResponse.prototype.toObject>;
            mfaChallenge?: ReturnType<typeof MFAChallenge.prototype.toObject>;
        }): ValidateMFAResponse {
            const message = new ValidateMFAResponse({});
            if (data.tokens != null) {
                message.tokens = TokenResponse.fromObject(data.tokens);
            }
            if (data.mfaChallenge != null) {
                message.mfaChallenge = MFAChallenge.fromObject(data.mfaChallenge);
            }
            return message;
        }
        toObject() {
            const data: {
                tokens?: ReturnType<typeof TokenResponse.prototype.toObject>;
                mfaChallenge?: ReturnType<typeof MFAChallenge.prototype.toObject>;
            } = {};
            if (this.tokens != null) {
                data.tokens = this.tokens.toObject();
            }
            if (this.mfaChallenge != null) {
                data.mfaChallenge = this.mfaChallenge.toObject();
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.hasTokens)
                writer.writeMessage(1, this.tokens, () => this.tokens.serialize(writer));
            if (this.hasMfaChallenge)
                writer.writeMessage(2, this.mfaChallenge, () => this.mfaChallenge.serialize(writer));
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): ValidateMFAResponse {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new ValidateMFAResponse();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        reader.readMessage(message.tokens, () => message.tokens = TokenResponse.deserialize(reader));
                        break;
                    case 2:
                        reader.readMessage(message.mfaChallenge, () => message.mfaChallenge = MFAChallenge.deserialize(reader));
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): ValidateMFAResponse {
            return ValidateMFAResponse.deserialize(bytes);
        }
    }
    export class TokenResponse extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            accessToken?: string;
            refreshToken?: string;
            tokenType?: string;
            expiresIn?: number;
            isTemporaryPassword?: boolean;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("accessToken" in data && data.accessToken != undefined) {
                    this.accessToken = data.accessToken;
                }
                if ("refreshToken" in data && data.refreshToken != undefined) {
                    this.refreshToken = data.refreshToken;
                }
                if ("tokenType" in data && data.tokenType != undefined) {
                    this.tokenType = data.tokenType;
                }
                if ("expiresIn" in data && data.expiresIn != undefined) {
                    this.expiresIn = data.expiresIn;
                }
                if ("isTemporaryPassword" in data && data.isTemporaryPassword != undefined) {
                    this.isTemporaryPassword = data.isTemporaryPassword;
                }
            }
        }
        get accessToken() {
            return pb_1.Message.getFieldWithDefault(this, 1, "") as string;
        }
        set accessToken(value: string) {
            pb_1.Message.setField(this, 1, value);
        }
        get refreshToken() {
            return pb_1.Message.getFieldWithDefault(this, 2, "") as string;
        }
        set refreshToken(value: string) {
            pb_1.Message.setField(this, 2, value);
        }
        get tokenType() {
            return pb_1.Message.getFieldWithDefault(this, 3, "") as string;
        }
        set tokenType(value: string) {
            pb_1.Message.setField(this, 3, value);
        }
        get expiresIn() {
            return pb_1.Message.getFieldWithDefault(this, 4, 0) as number;
        }
        set expiresIn(value: number) {
            pb_1.Message.setField(this, 4, value);
        }
        get isTemporaryPassword() {
            return pb_1.Message.getFieldWithDefault(this, 5, false) as boolean;
        }
        set isTemporaryPassword(value: boolean) {
            pb_1.Message.setField(this, 5, value);
        }
        static fromObject(data: {
            accessToken?: string;
            refreshToken?: string;
            tokenType?: string;
            expiresIn?: number;
            isTemporaryPassword?: boolean;
        }): TokenResponse {
            const message = new TokenResponse({});
            if (data.accessToken != null) {
                message.accessToken = data.accessToken;
            }
            if (data.refreshToken != null) {
                message.refreshToken = data.refreshToken;
            }
            if (data.tokenType != null) {
                message.tokenType = data.tokenType;
            }
            if (data.expiresIn != null) {
                message.expiresIn = data.expiresIn;
            }
            if (data.isTemporaryPassword != null) {
                message.isTemporaryPassword = data.isTemporaryPassword;
            }
            return message;
        }
        toObject() {
            const data: {
                accessToken?: string;
                refreshToken?: string;
                tokenType?: string;
                expiresIn?: number;
                isTemporaryPassword?: boolean;
            } = {};
            if (this.accessToken != null) {
                data.accessToken = this.accessToken;
            }
            if (this.refreshToken != null) {
                data.refreshToken = this.refreshToken;
            }
            if (this.tokenType != null) {
                data.tokenType = this.tokenType;
            }
            if (this.expiresIn != null) {
                data.expiresIn = this.expiresIn;
            }
            if (this.isTemporaryPassword != null) {
                data.isTemporaryPassword = this.isTemporaryPassword;
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.accessToken.length)
                writer.writeString(1, this.accessToken);
            if (this.refreshToken.length)
                writer.writeString(2, this.refreshToken);
            if (this.tokenType.length)
                writer.writeString(3, this.tokenType);
            if (this.expiresIn != 0)
                writer.writeInt64(4, this.expiresIn);
            if (this.isTemporaryPassword != false)
                writer.writeBool(5, this.isTemporaryPassword);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): TokenResponse {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new TokenResponse();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.accessToken = reader.readString();
                        break;
                    case 2:
                        message.refreshToken = reader.readString();
                        break;
                    case 3:
                        message.tokenType = reader.readString();
                        break;
                    case 4:
                        message.expiresIn = reader.readInt64();
                        break;
                    case 5:
                        message.isTemporaryPassword = reader.readBool();
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): TokenResponse {
            return TokenResponse.deserialize(bytes);
        }
    }
    export class SignUpRequest extends pb_1.Message {
        #one_of_decls: number[][] = [[10], [11], [12]];
        constructor(data?: any[] | ({
            firstName?: string;
            lastName?: string;
            phoneNumber?: string;
            username?: string;
            password?: string;
            email?: string;
            organizationId?: string;
            workspaceId?: string;
            tenantId?: string;
        } & (({
            document?: string;
        }) | ({
            companyName?: string;
        }) | ({
            birthDate?: dependency_3.google.protobuf.Timestamp;
        })))) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("firstName" in data && data.firstName != undefined) {
                    this.firstName = data.firstName;
                }
                if ("lastName" in data && data.lastName != undefined) {
                    this.lastName = data.lastName;
                }
                if ("phoneNumber" in data && data.phoneNumber != undefined) {
                    this.phoneNumber = data.phoneNumber;
                }
                if ("username" in data && data.username != undefined) {
                    this.username = data.username;
                }
                if ("password" in data && data.password != undefined) {
                    this.password = data.password;
                }
                if ("email" in data && data.email != undefined) {
                    this.email = data.email;
                }
                if ("organizationId" in data && data.organizationId != undefined) {
                    this.organizationId = data.organizationId;
                }
                if ("workspaceId" in data && data.workspaceId != undefined) {
                    this.workspaceId = data.workspaceId;
                }
                if ("tenantId" in data && data.tenantId != undefined) {
                    this.tenantId = data.tenantId;
                }
                if ("document" in data && data.document != undefined) {
                    this.document = data.document;
                }
                if ("companyName" in data && data.companyName != undefined) {
                    this.companyName = data.companyName;
                }
                if ("birthDate" in data && data.birthDate != undefined) {
                    this.birthDate = data.birthDate;
                }
            }
        }
        get firstName() {
            return pb_1.Message.getFieldWithDefault(this, 1, "") as string;
        }
        set firstName(value: string) {
            pb_1.Message.setField(this, 1, value);
        }
        get lastName() {
            return pb_1.Message.getFieldWithDefault(this, 2, "") as string;
        }
        set lastName(value: string) {
            pb_1.Message.setField(this, 2, value);
        }
        get phoneNumber() {
            return pb_1.Message.getFieldWithDefault(this, 3, "") as string;
        }
        set phoneNumber(value: string) {
            pb_1.Message.setField(this, 3, value);
        }
        get username() {
            return pb_1.Message.getFieldWithDefault(this, 4, "") as string;
        }
        set username(value: string) {
            pb_1.Message.setField(this, 4, value);
        }
        get password() {
            return pb_1.Message.getFieldWithDefault(this, 5, "") as string;
        }
        set password(value: string) {
            pb_1.Message.setField(this, 5, value);
        }
        get email() {
            return pb_1.Message.getFieldWithDefault(this, 6, "") as string;
        }
        set email(value: string) {
            pb_1.Message.setField(this, 6, value);
        }
        get organizationId() {
            return pb_1.Message.getFieldWithDefault(this, 7, "") as string;
        }
        set organizationId(value: string) {
            pb_1.Message.setField(this, 7, value);
        }
        get workspaceId() {
            return pb_1.Message.getFieldWithDefault(this, 8, "") as string;
        }
        set workspaceId(value: string) {
            pb_1.Message.setField(this, 8, value);
        }
        get tenantId() {
            return pb_1.Message.getFieldWithDefault(this, 9, "") as string;
        }
        set tenantId(value: string) {
            pb_1.Message.setField(this, 9, value);
        }
        get document() {
            return pb_1.Message.getFieldWithDefault(this, 10, "") as string;
        }
        set document(value: string) {
            pb_1.Message.setOneofField(this, 10, this.#one_of_decls[0], value);
        }
        get hasDocument() {
            return pb_1.Message.getField(this, 10) != null;
        }
        get companyName() {
            return pb_1.Message.getFieldWithDefault(this, 11, "") as string;
        }
        set companyName(value: string) {
            pb_1.Message.setOneofField(this, 11, this.#one_of_decls[1], value);
        }
        get hasCompanyName() {
            return pb_1.Message.getField(this, 11) != null;
        }
        get birthDate() {
            return pb_1.Message.getWrapperField(this, dependency_3.google.protobuf.Timestamp, 12) as dependency_3.google.protobuf.Timestamp;
        }
        set birthDate(value: dependency_3.google.protobuf.Timestamp) {
            pb_1.Message.setOneofWrapperField(this, 12, this.#one_of_decls[2], value);
        }
        get hasBirthDate() {
            return pb_1.Message.getField(this, 12) != null;
        }
        get _document() {
            const cases: {
                [index: number]: "none" | "document";
            } = {
                0: "none",
                10: "document"
            };
            return cases[pb_1.Message.computeOneofCase(this, [10])];
        }
        get _company_name() {
            const cases: {
                [index: number]: "none" | "companyName";
            } = {
                0: "none",
                11: "companyName"
            };
            return cases[pb_1.Message.computeOneofCase(this, [11])];
        }
        get _birth_date() {
            const cases: {
                [index: number]: "none" | "birthDate";
            } = {
                0: "none",
                12: "birthDate"
            };
            return cases[pb_1.Message.computeOneofCase(this, [12])];
        }
        static fromObject(data: {
            firstName?: string;
            lastName?: string;
            phoneNumber?: string;
            username?: string;
            password?: string;
            email?: string;
            organizationId?: string;
            workspaceId?: string;
            tenantId?: string;
            document?: string;
            companyName?: string;
            birthDate?: ReturnType<typeof dependency_3.google.protobuf.Timestamp.prototype.toObject>;
        }): SignUpRequest {
            const message = new SignUpRequest({});
            if (data.firstName != null) {
                message.firstName = data.firstName;
            }
            if (data.lastName != null) {
                message.lastName = data.lastName;
            }
            if (data.phoneNumber != null) {
                message.phoneNumber = data.phoneNumber;
            }
            if (data.username != null) {
                message.username = data.username;
            }
            if (data.password != null) {
                message.password = data.password;
            }
            if (data.email != null) {
                message.email = data.email;
            }
            if (data.organizationId != null) {
                message.organizationId = data.organizationId;
            }
            if (data.workspaceId != null) {
                message.workspaceId = data.workspaceId;
            }
            if (data.tenantId != null) {
                message.tenantId = data.tenantId;
            }
            if (data.document != null) {
                message.document = data.document;
            }
            if (data.companyName != null) {
                message.companyName = data.companyName;
            }
            if (data.birthDate != null) {
                message.birthDate = dependency_3.google.protobuf.Timestamp.fromObject(data.birthDate);
            }
            return message;
        }
        toObject() {
            const data: {
                firstName?: string;
                lastName?: string;
                phoneNumber?: string;
                username?: string;
                password?: string;
                email?: string;
                organizationId?: string;
                workspaceId?: string;
                tenantId?: string;
                document?: string;
                companyName?: string;
                birthDate?: ReturnType<typeof dependency_3.google.protobuf.Timestamp.prototype.toObject>;
            } = {};
            if (this.firstName != null) {
                data.firstName = this.firstName;
            }
            if (this.lastName != null) {
                data.lastName = this.lastName;
            }
            if (this.phoneNumber != null) {
                data.phoneNumber = this.phoneNumber;
            }
            if (this.username != null) {
                data.username = this.username;
            }
            if (this.password != null) {
                data.password = this.password;
            }
            if (this.email != null) {
                data.email = this.email;
            }
            if (this.organizationId != null) {
                data.organizationId = this.organizationId;
            }
            if (this.workspaceId != null) {
                data.workspaceId = this.workspaceId;
            }
            if (this.tenantId != null) {
                data.tenantId = this.tenantId;
            }
            if (this.document != null) {
                data.document = this.document;
            }
            if (this.companyName != null) {
                data.companyName = this.companyName;
            }
            if (this.birthDate != null) {
                data.birthDate = this.birthDate.toObject();
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.firstName.length)
                writer.writeString(1, this.firstName);
            if (this.lastName.length)
                writer.writeString(2, this.lastName);
            if (this.phoneNumber.length)
                writer.writeString(3, this.phoneNumber);
            if (this.username.length)
                writer.writeString(4, this.username);
            if (this.password.length)
                writer.writeString(5, this.password);
            if (this.email.length)
                writer.writeString(6, this.email);
            if (this.organizationId.length)
                writer.writeString(7, this.organizationId);
            if (this.workspaceId.length)
                writer.writeString(8, this.workspaceId);
            if (this.tenantId.length)
                writer.writeString(9, this.tenantId);
            if (this.hasDocument)
                writer.writeString(10, this.document);
            if (this.hasCompanyName)
                writer.writeString(11, this.companyName);
            if (this.hasBirthDate)
                writer.writeMessage(12, this.birthDate, () => this.birthDate.serialize(writer));
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): SignUpRequest {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new SignUpRequest();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.firstName = reader.readString();
                        break;
                    case 2:
                        message.lastName = reader.readString();
                        break;
                    case 3:
                        message.phoneNumber = reader.readString();
                        break;
                    case 4:
                        message.username = reader.readString();
                        break;
                    case 5:
                        message.password = reader.readString();
                        break;
                    case 6:
                        message.email = reader.readString();
                        break;
                    case 7:
                        message.organizationId = reader.readString();
                        break;
                    case 8:
                        message.workspaceId = reader.readString();
                        break;
                    case 9:
                        message.tenantId = reader.readString();
                        break;
                    case 10:
                        message.document = reader.readString();
                        break;
                    case 11:
                        message.companyName = reader.readString();
                        break;
                    case 12:
                        reader.readMessage(message.birthDate, () => message.birthDate = dependency_3.google.protobuf.Timestamp.deserialize(reader));
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): SignUpRequest {
            return SignUpRequest.deserialize(bytes);
        }
    }
    export class SignUpResponse extends pb_1.Message {
        #one_of_decls: number[][] = [[1]];
        constructor(data?: any[] | ({} & (({
            mfaChallenge?: MFAChallenge;
        })))) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("mfaChallenge" in data && data.mfaChallenge != undefined) {
                    this.mfaChallenge = data.mfaChallenge;
                }
            }
        }
        get mfaChallenge() {
            return pb_1.Message.getWrapperField(this, MFAChallenge, 1) as MFAChallenge;
        }
        set mfaChallenge(value: MFAChallenge) {
            pb_1.Message.setOneofWrapperField(this, 1, this.#one_of_decls[0], value);
        }
        get hasMfaChallenge() {
            return pb_1.Message.getField(this, 1) != null;
        }
        get response() {
            const cases: {
                [index: number]: "none" | "mfaChallenge";
            } = {
                0: "none",
                1: "mfaChallenge"
            };
            return cases[pb_1.Message.computeOneofCase(this, [1])];
        }
        static fromObject(data: {
            mfaChallenge?: ReturnType<typeof MFAChallenge.prototype.toObject>;
        }): SignUpResponse {
            const message = new SignUpResponse({});
            if (data.mfaChallenge != null) {
                message.mfaChallenge = MFAChallenge.fromObject(data.mfaChallenge);
            }
            return message;
        }
        toObject() {
            const data: {
                mfaChallenge?: ReturnType<typeof MFAChallenge.prototype.toObject>;
            } = {};
            if (this.mfaChallenge != null) {
                data.mfaChallenge = this.mfaChallenge.toObject();
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.hasMfaChallenge)
                writer.writeMessage(1, this.mfaChallenge, () => this.mfaChallenge.serialize(writer));
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): SignUpResponse {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new SignUpResponse();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        reader.readMessage(message.mfaChallenge, () => message.mfaChallenge = MFAChallenge.deserialize(reader));
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): SignUpResponse {
            return SignUpResponse.deserialize(bytes);
        }
    }
    export abstract class UnimplementedAuthServiceService {
        static definition = {
            Login: {
                path: "/auth.v1.AuthService/Login",
                requestStream: false,
                responseStream: false,
                requestSerialize: (message: LoginRequest) => Buffer.from(message.serialize()),
                requestDeserialize: (bytes: Buffer) => LoginRequest.deserialize(new Uint8Array(bytes)),
                responseSerialize: (message: LoginResponse) => Buffer.from(message.serialize()),
                responseDeserialize: (bytes: Buffer) => LoginResponse.deserialize(new Uint8Array(bytes))
            },
            RefreshToken: {
                path: "/auth.v1.AuthService/RefreshToken",
                requestStream: false,
                responseStream: false,
                requestSerialize: (message: RefreshTokenRequest) => Buffer.from(message.serialize()),
                requestDeserialize: (bytes: Buffer) => RefreshTokenRequest.deserialize(new Uint8Array(bytes)),
                responseSerialize: (message: RefreshTokenResponse) => Buffer.from(message.serialize()),
                responseDeserialize: (bytes: Buffer) => RefreshTokenResponse.deserialize(new Uint8Array(bytes))
            },
            ForgotMyPassword: {
                path: "/auth.v1.AuthService/ForgotMyPassword",
                requestStream: false,
                responseStream: false,
                requestSerialize: (message: ForgotMyPasswordRequest) => Buffer.from(message.serialize()),
                requestDeserialize: (bytes: Buffer) => ForgotMyPasswordRequest.deserialize(new Uint8Array(bytes)),
                responseSerialize: (message: ForgotMyPasswordResponse) => Buffer.from(message.serialize()),
                responseDeserialize: (bytes: Buffer) => ForgotMyPasswordResponse.deserialize(new Uint8Array(bytes))
            },
            ResetMyPassword: {
                path: "/auth.v1.AuthService/ResetMyPassword",
                requestStream: false,
                responseStream: false,
                requestSerialize: (message: ResetMyPasswordRequest) => Buffer.from(message.serialize()),
                requestDeserialize: (bytes: Buffer) => ResetMyPasswordRequest.deserialize(new Uint8Array(bytes)),
                responseSerialize: (message: ResetMyPasswordResponse) => Buffer.from(message.serialize()),
                responseDeserialize: (bytes: Buffer) => ResetMyPasswordResponse.deserialize(new Uint8Array(bytes))
            },
            Logout: {
                path: "/auth.v1.AuthService/Logout",
                requestStream: false,
                responseStream: false,
                requestSerialize: (message: LogoutRequest) => Buffer.from(message.serialize()),
                requestDeserialize: (bytes: Buffer) => LogoutRequest.deserialize(new Uint8Array(bytes)),
                responseSerialize: (message: LogoutResponse) => Buffer.from(message.serialize()),
                responseDeserialize: (bytes: Buffer) => LogoutResponse.deserialize(new Uint8Array(bytes))
            },
            LoginOAuth: {
                path: "/auth.v1.AuthService/LoginOAuth",
                requestStream: false,
                responseStream: false,
                requestSerialize: (message: LoginOAuthRequest) => Buffer.from(message.serialize()),
                requestDeserialize: (bytes: Buffer) => LoginOAuthRequest.deserialize(new Uint8Array(bytes)),
                responseSerialize: (message: LoginOAuthResponse) => Buffer.from(message.serialize()),
                responseDeserialize: (bytes: Buffer) => LoginOAuthResponse.deserialize(new Uint8Array(bytes))
            },
            ValidateCodeOAuth: {
                path: "/auth.v1.AuthService/ValidateCodeOAuth",
                requestStream: false,
                responseStream: false,
                requestSerialize: (message: ValidateCodeOAuthRequest) => Buffer.from(message.serialize()),
                requestDeserialize: (bytes: Buffer) => ValidateCodeOAuthRequest.deserialize(new Uint8Array(bytes)),
                responseSerialize: (message: ValidateCodeOAuthResponse) => Buffer.from(message.serialize()),
                responseDeserialize: (bytes: Buffer) => ValidateCodeOAuthResponse.deserialize(new Uint8Array(bytes))
            },
            ValidateMFA: {
                path: "/auth.v1.AuthService/ValidateMFA",
                requestStream: false,
                responseStream: false,
                requestSerialize: (message: ValidateMFARequest) => Buffer.from(message.serialize()),
                requestDeserialize: (bytes: Buffer) => ValidateMFARequest.deserialize(new Uint8Array(bytes)),
                responseSerialize: (message: ValidateMFAResponse) => Buffer.from(message.serialize()),
                responseDeserialize: (bytes: Buffer) => ValidateMFAResponse.deserialize(new Uint8Array(bytes))
            },
            ResendValidationCodeChallenge: {
                path: "/auth.v1.AuthService/ResendValidationCodeChallenge",
                requestStream: false,
                responseStream: false,
                requestSerialize: (message: ResendValidationCodeChallengeRequest) => Buffer.from(message.serialize()),
                requestDeserialize: (bytes: Buffer) => ResendValidationCodeChallengeRequest.deserialize(new Uint8Array(bytes)),
                responseSerialize: (message: ResendValidationCodeChallengeResponse) => Buffer.from(message.serialize()),
                responseDeserialize: (bytes: Buffer) => ResendValidationCodeChallengeResponse.deserialize(new Uint8Array(bytes))
            },
            SignUp: {
                path: "/auth.v1.AuthService/SignUp",
                requestStream: false,
                responseStream: false,
                requestSerialize: (message: SignUpRequest) => Buffer.from(message.serialize()),
                requestDeserialize: (bytes: Buffer) => SignUpRequest.deserialize(new Uint8Array(bytes)),
                responseSerialize: (message: SignUpResponse) => Buffer.from(message.serialize()),
                responseDeserialize: (bytes: Buffer) => SignUpResponse.deserialize(new Uint8Array(bytes))
            },
            CheckToken: {
                path: "/auth.v1.AuthService/CheckToken",
                requestStream: false,
                responseStream: false,
                requestSerialize: (message: CheckTokenRequest) => Buffer.from(message.serialize()),
                requestDeserialize: (bytes: Buffer) => CheckTokenRequest.deserialize(new Uint8Array(bytes)),
                responseSerialize: (message: CheckTokenResponse) => Buffer.from(message.serialize()),
                responseDeserialize: (bytes: Buffer) => CheckTokenResponse.deserialize(new Uint8Array(bytes))
            },
            LoginOTP: {
                path: "/auth.v1.AuthService/LoginOTP",
                requestStream: false,
                responseStream: false,
                requestSerialize: (message: LoginOTPRequest) => Buffer.from(message.serialize()),
                requestDeserialize: (bytes: Buffer) => LoginOTPRequest.deserialize(new Uint8Array(bytes)),
                responseSerialize: (message: LoginOTPResponse) => Buffer.from(message.serialize()),
                responseDeserialize: (bytes: Buffer) => LoginOTPResponse.deserialize(new Uint8Array(bytes))
            },
            ListUsers: {
                path: "/auth.v1.AuthService/ListUsers",
                requestStream: false,
                responseStream: false,
                requestSerialize: (message: ListUsersRequest) => Buffer.from(message.serialize()),
                requestDeserialize: (bytes: Buffer) => ListUsersRequest.deserialize(new Uint8Array(bytes)),
                responseSerialize: (message: ListUsersResponse) => Buffer.from(message.serialize()),
                responseDeserialize: (bytes: Buffer) => ListUsersResponse.deserialize(new Uint8Array(bytes))
            },
            ValidateLoginOTP: {
                path: "/auth.v1.AuthService/ValidateLoginOTP",
                requestStream: false,
                responseStream: false,
                requestSerialize: (message: ValidateLoginOTPRequest) => Buffer.from(message.serialize()),
                requestDeserialize: (bytes: Buffer) => ValidateLoginOTPRequest.deserialize(new Uint8Array(bytes)),
                responseSerialize: (message: ValidateLoginOTPResponse) => Buffer.from(message.serialize()),
                responseDeserialize: (bytes: Buffer) => ValidateLoginOTPResponse.deserialize(new Uint8Array(bytes))
            },
            GetAuthUser: {
                path: "/auth.v1.AuthService/GetAuthUser",
                requestStream: false,
                responseStream: false,
                requestSerialize: (message: GetAuthUserRequest) => Buffer.from(message.serialize()),
                requestDeserialize: (bytes: Buffer) => GetAuthUserRequest.deserialize(new Uint8Array(bytes)),
                responseSerialize: (message: GetAuthUserResponse) => Buffer.from(message.serialize()),
                responseDeserialize: (bytes: Buffer) => GetAuthUserResponse.deserialize(new Uint8Array(bytes))
            },
            GetAuthUserByEmail: {
                path: "/auth.v1.AuthService/GetAuthUserByEmail",
                requestStream: false,
                responseStream: false,
                requestSerialize: (message: GetAuthUserByEmailRequest) => Buffer.from(message.serialize()),
                requestDeserialize: (bytes: Buffer) => GetAuthUserByEmailRequest.deserialize(new Uint8Array(bytes)),
                responseSerialize: (message: GetAuthUserByEmailResponse) => Buffer.from(message.serialize()),
                responseDeserialize: (bytes: Buffer) => GetAuthUserByEmailResponse.deserialize(new Uint8Array(bytes))
            },
            GetAddresses: {
                path: "/auth.v1.AuthService/GetAddresses",
                requestStream: false,
                responseStream: false,
                requestSerialize: (message: GetAddressesRequest) => Buffer.from(message.serialize()),
                requestDeserialize: (bytes: Buffer) => GetAddressesRequest.deserialize(new Uint8Array(bytes)),
                responseSerialize: (message: GetAddressesResponse) => Buffer.from(message.serialize()),
                responseDeserialize: (bytes: Buffer) => GetAddressesResponse.deserialize(new Uint8Array(bytes))
            },
            UpsertAddress: {
                path: "/auth.v1.AuthService/UpsertAddress",
                requestStream: false,
                responseStream: false,
                requestSerialize: (message: UpsertAddressRequest) => Buffer.from(message.serialize()),
                requestDeserialize: (bytes: Buffer) => UpsertAddressRequest.deserialize(new Uint8Array(bytes)),
                responseSerialize: (message: UpsertAddressResponse) => Buffer.from(message.serialize()),
                responseDeserialize: (bytes: Buffer) => UpsertAddressResponse.deserialize(new Uint8Array(bytes))
            },
            DeleteAddress: {
                path: "/auth.v1.AuthService/DeleteAddress",
                requestStream: false,
                responseStream: false,
                requestSerialize: (message: DeleteAddressRequest) => Buffer.from(message.serialize()),
                requestDeserialize: (bytes: Buffer) => DeleteAddressRequest.deserialize(new Uint8Array(bytes)),
                responseSerialize: (message: DeleteAddressResponse) => Buffer.from(message.serialize()),
                responseDeserialize: (bytes: Buffer) => DeleteAddressResponse.deserialize(new Uint8Array(bytes))
            },
            UpdateAuthUser: {
                path: "/auth.v1.AuthService/UpdateAuthUser",
                requestStream: false,
                responseStream: false,
                requestSerialize: (message: UpdateAuthUserRequest) => Buffer.from(message.serialize()),
                requestDeserialize: (bytes: Buffer) => UpdateAuthUserRequest.deserialize(new Uint8Array(bytes)),
                responseSerialize: (message: UpdateAuthUserResponse) => Buffer.from(message.serialize()),
                responseDeserialize: (bytes: Buffer) => UpdateAuthUserResponse.deserialize(new Uint8Array(bytes))
            },
            StartPasswordChange: {
                path: "/auth.v1.AuthService/StartPasswordChange",
                requestStream: false,
                responseStream: false,
                requestSerialize: (message: StartPasswordChangeRequest) => Buffer.from(message.serialize()),
                requestDeserialize: (bytes: Buffer) => StartPasswordChangeRequest.deserialize(new Uint8Array(bytes)),
                responseSerialize: (message: StartPasswordChangeResponse) => Buffer.from(message.serialize()),
                responseDeserialize: (bytes: Buffer) => StartPasswordChangeResponse.deserialize(new Uint8Array(bytes))
            },
            ConfirmPasswordChange: {
                path: "/auth.v1.AuthService/ConfirmPasswordChange",
                requestStream: false,
                responseStream: false,
                requestSerialize: (message: ConfirmPasswordChangeRequest) => Buffer.from(message.serialize()),
                requestDeserialize: (bytes: Buffer) => ConfirmPasswordChangeRequest.deserialize(new Uint8Array(bytes)),
                responseSerialize: (message: ConfirmPasswordChangeResponse) => Buffer.from(message.serialize()),
                responseDeserialize: (bytes: Buffer) => ConfirmPasswordChangeResponse.deserialize(new Uint8Array(bytes))
            },
            VerifyPasswordChange: {
                path: "/auth.v1.AuthService/VerifyPasswordChange",
                requestStream: false,
                responseStream: false,
                requestSerialize: (message: VerifyPasswordChangeRequest) => Buffer.from(message.serialize()),
                requestDeserialize: (bytes: Buffer) => VerifyPasswordChangeRequest.deserialize(new Uint8Array(bytes)),
                responseSerialize: (message: VerifyPasswordChangeResponse) => Buffer.from(message.serialize()),
                responseDeserialize: (bytes: Buffer) => VerifyPasswordChangeResponse.deserialize(new Uint8Array(bytes))
            },
            StartEmailChange: {
                path: "/auth.v1.AuthService/StartEmailChange",
                requestStream: false,
                responseStream: false,
                requestSerialize: (message: StartEmailChangeRequest) => Buffer.from(message.serialize()),
                requestDeserialize: (bytes: Buffer) => StartEmailChangeRequest.deserialize(new Uint8Array(bytes)),
                responseSerialize: (message: StartEmailChangeResponse) => Buffer.from(message.serialize()),
                responseDeserialize: (bytes: Buffer) => StartEmailChangeResponse.deserialize(new Uint8Array(bytes))
            },
            VerifyEmailChange: {
                path: "/auth.v1.AuthService/VerifyEmailChange",
                requestStream: false,
                responseStream: false,
                requestSerialize: (message: VerifyEmailChangeRequest) => Buffer.from(message.serialize()),
                requestDeserialize: (bytes: Buffer) => VerifyEmailChangeRequest.deserialize(new Uint8Array(bytes)),
                responseSerialize: (message: VerifyEmailChangeResponse) => Buffer.from(message.serialize()),
                responseDeserialize: (bytes: Buffer) => VerifyEmailChangeResponse.deserialize(new Uint8Array(bytes))
            },
            ChangeProfile: {
                path: "/auth.v1.AuthService/ChangeProfile",
                requestStream: false,
                responseStream: false,
                requestSerialize: (message: ChangeUserProfileRequest) => Buffer.from(message.serialize()),
                requestDeserialize: (bytes: Buffer) => ChangeUserProfileRequest.deserialize(new Uint8Array(bytes)),
                responseSerialize: (message: ChangeUserProfileResponse) => Buffer.from(message.serialize()),
                responseDeserialize: (bytes: Buffer) => ChangeUserProfileResponse.deserialize(new Uint8Array(bytes))
            },
            DeleteUser: {
                path: "/auth.v1.AuthService/DeleteUser",
                requestStream: false,
                responseStream: false,
                requestSerialize: (message: DeleteUserRequest) => Buffer.from(message.serialize()),
                requestDeserialize: (bytes: Buffer) => DeleteUserRequest.deserialize(new Uint8Array(bytes)),
                responseSerialize: (message: DeleteUserResponse) => Buffer.from(message.serialize()),
                responseDeserialize: (bytes: Buffer) => DeleteUserResponse.deserialize(new Uint8Array(bytes))
            },
            DeleteUserAdmin: {
                path: "/auth.v1.AuthService/DeleteUserAdmin",
                requestStream: false,
                responseStream: false,
                requestSerialize: (message: DeleteUserAdminRequest) => Buffer.from(message.serialize()),
                requestDeserialize: (bytes: Buffer) => DeleteUserAdminRequest.deserialize(new Uint8Array(bytes)),
                responseSerialize: (message: DeleteUserAdminResponse) => Buffer.from(message.serialize()),
                responseDeserialize: (bytes: Buffer) => DeleteUserAdminResponse.deserialize(new Uint8Array(bytes))
            },
            MigrateUser: {
                path: "/auth.v1.AuthService/MigrateUser",
                requestStream: false,
                responseStream: false,
                requestSerialize: (message: MigrateUserRequest) => Buffer.from(message.serialize()),
                requestDeserialize: (bytes: Buffer) => MigrateUserRequest.deserialize(new Uint8Array(bytes)),
                responseSerialize: (message: MigrateUserResponse) => Buffer.from(message.serialize()),
                responseDeserialize: (bytes: Buffer) => MigrateUserResponse.deserialize(new Uint8Array(bytes))
            },
            GetUserMenu: {
                path: "/auth.v1.AuthService/GetUserMenu",
                requestStream: false,
                responseStream: false,
                requestSerialize: (message: GetUserMenuRequest) => Buffer.from(message.serialize()),
                requestDeserialize: (bytes: Buffer) => GetUserMenuRequest.deserialize(new Uint8Array(bytes)),
                responseSerialize: (message: GetUserMenuResponse) => Buffer.from(message.serialize()),
                responseDeserialize: (bytes: Buffer) => GetUserMenuResponse.deserialize(new Uint8Array(bytes))
            },
            GetUserPermissions: {
                path: "/auth.v1.AuthService/GetUserPermissions",
                requestStream: false,
                responseStream: false,
                requestSerialize: (message: GetUserPermissionsRequest) => Buffer.from(message.serialize()),
                requestDeserialize: (bytes: Buffer) => GetUserPermissionsRequest.deserialize(new Uint8Array(bytes)),
                responseSerialize: (message: GetUserPermissionsResponse) => Buffer.from(message.serialize()),
                responseDeserialize: (bytes: Buffer) => GetUserPermissionsResponse.deserialize(new Uint8Array(bytes))
            },
            GetRoles: {
                path: "/auth.v1.AuthService/GetRoles",
                requestStream: false,
                responseStream: false,
                requestSerialize: (message: GetRolesRequest) => Buffer.from(message.serialize()),
                requestDeserialize: (bytes: Buffer) => GetRolesRequest.deserialize(new Uint8Array(bytes)),
                responseSerialize: (message: GetRolesResponse) => Buffer.from(message.serialize()),
                responseDeserialize: (bytes: Buffer) => GetRolesResponse.deserialize(new Uint8Array(bytes))
            },
            UpdateRoles: {
                path: "/auth.v1.AuthService/UpdateRoles",
                requestStream: false,
                responseStream: false,
                requestSerialize: (message: UpdateRolesRequest) => Buffer.from(message.serialize()),
                requestDeserialize: (bytes: Buffer) => UpdateRolesRequest.deserialize(new Uint8Array(bytes)),
                responseSerialize: (message: UpdateRolesResponse) => Buffer.from(message.serialize()),
                responseDeserialize: (bytes: Buffer) => UpdateRolesResponse.deserialize(new Uint8Array(bytes))
            }
        };
        [method: string]: grpc_1.UntypedHandleCall;
        abstract Login(call: grpc_1.ServerUnaryCall<LoginRequest, LoginResponse>, callback: grpc_1.sendUnaryData<LoginResponse>): void;
        abstract RefreshToken(call: grpc_1.ServerUnaryCall<RefreshTokenRequest, RefreshTokenResponse>, callback: grpc_1.sendUnaryData<RefreshTokenResponse>): void;
        abstract ForgotMyPassword(call: grpc_1.ServerUnaryCall<ForgotMyPasswordRequest, ForgotMyPasswordResponse>, callback: grpc_1.sendUnaryData<ForgotMyPasswordResponse>): void;
        abstract ResetMyPassword(call: grpc_1.ServerUnaryCall<ResetMyPasswordRequest, ResetMyPasswordResponse>, callback: grpc_1.sendUnaryData<ResetMyPasswordResponse>): void;
        abstract Logout(call: grpc_1.ServerUnaryCall<LogoutRequest, LogoutResponse>, callback: grpc_1.sendUnaryData<LogoutResponse>): void;
        abstract LoginOAuth(call: grpc_1.ServerUnaryCall<LoginOAuthRequest, LoginOAuthResponse>, callback: grpc_1.sendUnaryData<LoginOAuthResponse>): void;
        abstract ValidateCodeOAuth(call: grpc_1.ServerUnaryCall<ValidateCodeOAuthRequest, ValidateCodeOAuthResponse>, callback: grpc_1.sendUnaryData<ValidateCodeOAuthResponse>): void;
        abstract ValidateMFA(call: grpc_1.ServerUnaryCall<ValidateMFARequest, ValidateMFAResponse>, callback: grpc_1.sendUnaryData<ValidateMFAResponse>): void;
        abstract ResendValidationCodeChallenge(call: grpc_1.ServerUnaryCall<ResendValidationCodeChallengeRequest, ResendValidationCodeChallengeResponse>, callback: grpc_1.sendUnaryData<ResendValidationCodeChallengeResponse>): void;
        abstract SignUp(call: grpc_1.ServerUnaryCall<SignUpRequest, SignUpResponse>, callback: grpc_1.sendUnaryData<SignUpResponse>): void;
        abstract CheckToken(call: grpc_1.ServerUnaryCall<CheckTokenRequest, CheckTokenResponse>, callback: grpc_1.sendUnaryData<CheckTokenResponse>): void;
        abstract LoginOTP(call: grpc_1.ServerUnaryCall<LoginOTPRequest, LoginOTPResponse>, callback: grpc_1.sendUnaryData<LoginOTPResponse>): void;
        abstract ListUsers(call: grpc_1.ServerUnaryCall<ListUsersRequest, ListUsersResponse>, callback: grpc_1.sendUnaryData<ListUsersResponse>): void;
        abstract ValidateLoginOTP(call: grpc_1.ServerUnaryCall<ValidateLoginOTPRequest, ValidateLoginOTPResponse>, callback: grpc_1.sendUnaryData<ValidateLoginOTPResponse>): void;
        abstract GetAuthUser(call: grpc_1.ServerUnaryCall<GetAuthUserRequest, GetAuthUserResponse>, callback: grpc_1.sendUnaryData<GetAuthUserResponse>): void;
        abstract GetAuthUserByEmail(call: grpc_1.ServerUnaryCall<GetAuthUserByEmailRequest, GetAuthUserByEmailResponse>, callback: grpc_1.sendUnaryData<GetAuthUserByEmailResponse>): void;
        abstract GetAddresses(call: grpc_1.ServerUnaryCall<GetAddressesRequest, GetAddressesResponse>, callback: grpc_1.sendUnaryData<GetAddressesResponse>): void;
        abstract UpsertAddress(call: grpc_1.ServerUnaryCall<UpsertAddressRequest, UpsertAddressResponse>, callback: grpc_1.sendUnaryData<UpsertAddressResponse>): void;
        abstract DeleteAddress(call: grpc_1.ServerUnaryCall<DeleteAddressRequest, DeleteAddressResponse>, callback: grpc_1.sendUnaryData<DeleteAddressResponse>): void;
        abstract UpdateAuthUser(call: grpc_1.ServerUnaryCall<UpdateAuthUserRequest, UpdateAuthUserResponse>, callback: grpc_1.sendUnaryData<UpdateAuthUserResponse>): void;
        abstract StartPasswordChange(call: grpc_1.ServerUnaryCall<StartPasswordChangeRequest, StartPasswordChangeResponse>, callback: grpc_1.sendUnaryData<StartPasswordChangeResponse>): void;
        abstract ConfirmPasswordChange(call: grpc_1.ServerUnaryCall<ConfirmPasswordChangeRequest, ConfirmPasswordChangeResponse>, callback: grpc_1.sendUnaryData<ConfirmPasswordChangeResponse>): void;
        abstract VerifyPasswordChange(call: grpc_1.ServerUnaryCall<VerifyPasswordChangeRequest, VerifyPasswordChangeResponse>, callback: grpc_1.sendUnaryData<VerifyPasswordChangeResponse>): void;
        abstract StartEmailChange(call: grpc_1.ServerUnaryCall<StartEmailChangeRequest, StartEmailChangeResponse>, callback: grpc_1.sendUnaryData<StartEmailChangeResponse>): void;
        abstract VerifyEmailChange(call: grpc_1.ServerUnaryCall<VerifyEmailChangeRequest, VerifyEmailChangeResponse>, callback: grpc_1.sendUnaryData<VerifyEmailChangeResponse>): void;
        abstract ChangeProfile(call: grpc_1.ServerUnaryCall<ChangeUserProfileRequest, ChangeUserProfileResponse>, callback: grpc_1.sendUnaryData<ChangeUserProfileResponse>): void;
        abstract DeleteUser(call: grpc_1.ServerUnaryCall<DeleteUserRequest, DeleteUserResponse>, callback: grpc_1.sendUnaryData<DeleteUserResponse>): void;
        abstract DeleteUserAdmin(call: grpc_1.ServerUnaryCall<DeleteUserAdminRequest, DeleteUserAdminResponse>, callback: grpc_1.sendUnaryData<DeleteUserAdminResponse>): void;
        abstract MigrateUser(call: grpc_1.ServerUnaryCall<MigrateUserRequest, MigrateUserResponse>, callback: grpc_1.sendUnaryData<MigrateUserResponse>): void;
        abstract GetUserMenu(call: grpc_1.ServerUnaryCall<GetUserMenuRequest, GetUserMenuResponse>, callback: grpc_1.sendUnaryData<GetUserMenuResponse>): void;
        abstract GetUserPermissions(call: grpc_1.ServerUnaryCall<GetUserPermissionsRequest, GetUserPermissionsResponse>, callback: grpc_1.sendUnaryData<GetUserPermissionsResponse>): void;
        abstract GetRoles(call: grpc_1.ServerUnaryCall<GetRolesRequest, GetRolesResponse>, callback: grpc_1.sendUnaryData<GetRolesResponse>): void;
        abstract UpdateRoles(call: grpc_1.ServerUnaryCall<UpdateRolesRequest, UpdateRolesResponse>, callback: grpc_1.sendUnaryData<UpdateRolesResponse>): void;
    }
    export class AuthServiceClient {
        private _address: string;
        private _client: grpc_web_1.GrpcWebClientBase;
        constructor(address: string, credentials?: Object, options?: grpc_web_1.GrpcWebClientBaseOptions) {
            if (!options)
                options = {};
            options.format = options.format || "text";
            this._address = address;
            this._client = new grpc_web_1.GrpcWebClientBase(options);
        }
        private static Login = new grpc_web_1.MethodDescriptor<LoginRequest, LoginResponse>("/auth.v1.AuthService/Login", grpc_web_1.MethodType.UNARY, LoginRequest, LoginResponse, (message: LoginRequest) => message.serialize(), LoginResponse.deserialize);
        Login(message: LoginRequest, metadata: grpc_web_1.Metadata | null) {
            return this._client.thenableCall<LoginRequest, LoginResponse>(this._address + "/auth.v1.AuthService/Login", message, metadata || {}, AuthServiceClient.Login);
        }
        private static RefreshToken = new grpc_web_1.MethodDescriptor<RefreshTokenRequest, RefreshTokenResponse>("/auth.v1.AuthService/RefreshToken", grpc_web_1.MethodType.UNARY, RefreshTokenRequest, RefreshTokenResponse, (message: RefreshTokenRequest) => message.serialize(), RefreshTokenResponse.deserialize);
        RefreshToken(message: RefreshTokenRequest, metadata: grpc_web_1.Metadata | null) {
            return this._client.thenableCall<RefreshTokenRequest, RefreshTokenResponse>(this._address + "/auth.v1.AuthService/RefreshToken", message, metadata || {}, AuthServiceClient.RefreshToken);
        }
        private static ForgotMyPassword = new grpc_web_1.MethodDescriptor<ForgotMyPasswordRequest, ForgotMyPasswordResponse>("/auth.v1.AuthService/ForgotMyPassword", grpc_web_1.MethodType.UNARY, ForgotMyPasswordRequest, ForgotMyPasswordResponse, (message: ForgotMyPasswordRequest) => message.serialize(), ForgotMyPasswordResponse.deserialize);
        ForgotMyPassword(message: ForgotMyPasswordRequest, metadata: grpc_web_1.Metadata | null) {
            return this._client.thenableCall<ForgotMyPasswordRequest, ForgotMyPasswordResponse>(this._address + "/auth.v1.AuthService/ForgotMyPassword", message, metadata || {}, AuthServiceClient.ForgotMyPassword);
        }
        private static ResetMyPassword = new grpc_web_1.MethodDescriptor<ResetMyPasswordRequest, ResetMyPasswordResponse>("/auth.v1.AuthService/ResetMyPassword", grpc_web_1.MethodType.UNARY, ResetMyPasswordRequest, ResetMyPasswordResponse, (message: ResetMyPasswordRequest) => message.serialize(), ResetMyPasswordResponse.deserialize);
        ResetMyPassword(message: ResetMyPasswordRequest, metadata: grpc_web_1.Metadata | null) {
            return this._client.thenableCall<ResetMyPasswordRequest, ResetMyPasswordResponse>(this._address + "/auth.v1.AuthService/ResetMyPassword", message, metadata || {}, AuthServiceClient.ResetMyPassword);
        }
        private static Logout = new grpc_web_1.MethodDescriptor<LogoutRequest, LogoutResponse>("/auth.v1.AuthService/Logout", grpc_web_1.MethodType.UNARY, LogoutRequest, LogoutResponse, (message: LogoutRequest) => message.serialize(), LogoutResponse.deserialize);
        Logout(message: LogoutRequest, metadata: grpc_web_1.Metadata | null) {
            return this._client.thenableCall<LogoutRequest, LogoutResponse>(this._address + "/auth.v1.AuthService/Logout", message, metadata || {}, AuthServiceClient.Logout);
        }
        private static LoginOAuth = new grpc_web_1.MethodDescriptor<LoginOAuthRequest, LoginOAuthResponse>("/auth.v1.AuthService/LoginOAuth", grpc_web_1.MethodType.UNARY, LoginOAuthRequest, LoginOAuthResponse, (message: LoginOAuthRequest) => message.serialize(), LoginOAuthResponse.deserialize);
        LoginOAuth(message: LoginOAuthRequest, metadata: grpc_web_1.Metadata | null) {
            return this._client.thenableCall<LoginOAuthRequest, LoginOAuthResponse>(this._address + "/auth.v1.AuthService/LoginOAuth", message, metadata || {}, AuthServiceClient.LoginOAuth);
        }
        private static ValidateCodeOAuth = new grpc_web_1.MethodDescriptor<ValidateCodeOAuthRequest, ValidateCodeOAuthResponse>("/auth.v1.AuthService/ValidateCodeOAuth", grpc_web_1.MethodType.UNARY, ValidateCodeOAuthRequest, ValidateCodeOAuthResponse, (message: ValidateCodeOAuthRequest) => message.serialize(), ValidateCodeOAuthResponse.deserialize);
        ValidateCodeOAuth(message: ValidateCodeOAuthRequest, metadata: grpc_web_1.Metadata | null) {
            return this._client.thenableCall<ValidateCodeOAuthRequest, ValidateCodeOAuthResponse>(this._address + "/auth.v1.AuthService/ValidateCodeOAuth", message, metadata || {}, AuthServiceClient.ValidateCodeOAuth);
        }
        private static ValidateMFA = new grpc_web_1.MethodDescriptor<ValidateMFARequest, ValidateMFAResponse>("/auth.v1.AuthService/ValidateMFA", grpc_web_1.MethodType.UNARY, ValidateMFARequest, ValidateMFAResponse, (message: ValidateMFARequest) => message.serialize(), ValidateMFAResponse.deserialize);
        ValidateMFA(message: ValidateMFARequest, metadata: grpc_web_1.Metadata | null) {
            return this._client.thenableCall<ValidateMFARequest, ValidateMFAResponse>(this._address + "/auth.v1.AuthService/ValidateMFA", message, metadata || {}, AuthServiceClient.ValidateMFA);
        }
        private static ResendValidationCodeChallenge = new grpc_web_1.MethodDescriptor<ResendValidationCodeChallengeRequest, ResendValidationCodeChallengeResponse>("/auth.v1.AuthService/ResendValidationCodeChallenge", grpc_web_1.MethodType.UNARY, ResendValidationCodeChallengeRequest, ResendValidationCodeChallengeResponse, (message: ResendValidationCodeChallengeRequest) => message.serialize(), ResendValidationCodeChallengeResponse.deserialize);
        ResendValidationCodeChallenge(message: ResendValidationCodeChallengeRequest, metadata: grpc_web_1.Metadata | null) {
            return this._client.thenableCall<ResendValidationCodeChallengeRequest, ResendValidationCodeChallengeResponse>(this._address + "/auth.v1.AuthService/ResendValidationCodeChallenge", message, metadata || {}, AuthServiceClient.ResendValidationCodeChallenge);
        }
        private static SignUp = new grpc_web_1.MethodDescriptor<SignUpRequest, SignUpResponse>("/auth.v1.AuthService/SignUp", grpc_web_1.MethodType.UNARY, SignUpRequest, SignUpResponse, (message: SignUpRequest) => message.serialize(), SignUpResponse.deserialize);
        SignUp(message: SignUpRequest, metadata: grpc_web_1.Metadata | null) {
            return this._client.thenableCall<SignUpRequest, SignUpResponse>(this._address + "/auth.v1.AuthService/SignUp", message, metadata || {}, AuthServiceClient.SignUp);
        }
        private static CheckToken = new grpc_web_1.MethodDescriptor<CheckTokenRequest, CheckTokenResponse>("/auth.v1.AuthService/CheckToken", grpc_web_1.MethodType.UNARY, CheckTokenRequest, CheckTokenResponse, (message: CheckTokenRequest) => message.serialize(), CheckTokenResponse.deserialize);
        CheckToken(message: CheckTokenRequest, metadata: grpc_web_1.Metadata | null) {
            return this._client.thenableCall<CheckTokenRequest, CheckTokenResponse>(this._address + "/auth.v1.AuthService/CheckToken", message, metadata || {}, AuthServiceClient.CheckToken);
        }
        private static LoginOTP = new grpc_web_1.MethodDescriptor<LoginOTPRequest, LoginOTPResponse>("/auth.v1.AuthService/LoginOTP", grpc_web_1.MethodType.UNARY, LoginOTPRequest, LoginOTPResponse, (message: LoginOTPRequest) => message.serialize(), LoginOTPResponse.deserialize);
        LoginOTP(message: LoginOTPRequest, metadata: grpc_web_1.Metadata | null) {
            return this._client.thenableCall<LoginOTPRequest, LoginOTPResponse>(this._address + "/auth.v1.AuthService/LoginOTP", message, metadata || {}, AuthServiceClient.LoginOTP);
        }
        private static ListUsers = new grpc_web_1.MethodDescriptor<ListUsersRequest, ListUsersResponse>("/auth.v1.AuthService/ListUsers", grpc_web_1.MethodType.UNARY, ListUsersRequest, ListUsersResponse, (message: ListUsersRequest) => message.serialize(), ListUsersResponse.deserialize);
        ListUsers(message: ListUsersRequest, metadata: grpc_web_1.Metadata | null) {
            return this._client.thenableCall<ListUsersRequest, ListUsersResponse>(this._address + "/auth.v1.AuthService/ListUsers", message, metadata || {}, AuthServiceClient.ListUsers);
        }
        private static ValidateLoginOTP = new grpc_web_1.MethodDescriptor<ValidateLoginOTPRequest, ValidateLoginOTPResponse>("/auth.v1.AuthService/ValidateLoginOTP", grpc_web_1.MethodType.UNARY, ValidateLoginOTPRequest, ValidateLoginOTPResponse, (message: ValidateLoginOTPRequest) => message.serialize(), ValidateLoginOTPResponse.deserialize);
        ValidateLoginOTP(message: ValidateLoginOTPRequest, metadata: grpc_web_1.Metadata | null) {
            return this._client.thenableCall<ValidateLoginOTPRequest, ValidateLoginOTPResponse>(this._address + "/auth.v1.AuthService/ValidateLoginOTP", message, metadata || {}, AuthServiceClient.ValidateLoginOTP);
        }
        private static GetAuthUser = new grpc_web_1.MethodDescriptor<GetAuthUserRequest, GetAuthUserResponse>("/auth.v1.AuthService/GetAuthUser", grpc_web_1.MethodType.UNARY, GetAuthUserRequest, GetAuthUserResponse, (message: GetAuthUserRequest) => message.serialize(), GetAuthUserResponse.deserialize);
        GetAuthUser(message: GetAuthUserRequest, metadata: grpc_web_1.Metadata | null) {
            return this._client.thenableCall<GetAuthUserRequest, GetAuthUserResponse>(this._address + "/auth.v1.AuthService/GetAuthUser", message, metadata || {}, AuthServiceClient.GetAuthUser);
        }
        private static GetAuthUserByEmail = new grpc_web_1.MethodDescriptor<GetAuthUserByEmailRequest, GetAuthUserByEmailResponse>("/auth.v1.AuthService/GetAuthUserByEmail", grpc_web_1.MethodType.UNARY, GetAuthUserByEmailRequest, GetAuthUserByEmailResponse, (message: GetAuthUserByEmailRequest) => message.serialize(), GetAuthUserByEmailResponse.deserialize);
        GetAuthUserByEmail(message: GetAuthUserByEmailRequest, metadata: grpc_web_1.Metadata | null) {
            return this._client.thenableCall<GetAuthUserByEmailRequest, GetAuthUserByEmailResponse>(this._address + "/auth.v1.AuthService/GetAuthUserByEmail", message, metadata || {}, AuthServiceClient.GetAuthUserByEmail);
        }
        private static GetAddresses = new grpc_web_1.MethodDescriptor<GetAddressesRequest, GetAddressesResponse>("/auth.v1.AuthService/GetAddresses", grpc_web_1.MethodType.UNARY, GetAddressesRequest, GetAddressesResponse, (message: GetAddressesRequest) => message.serialize(), GetAddressesResponse.deserialize);
        GetAddresses(message: GetAddressesRequest, metadata: grpc_web_1.Metadata | null) {
            return this._client.thenableCall<GetAddressesRequest, GetAddressesResponse>(this._address + "/auth.v1.AuthService/GetAddresses", message, metadata || {}, AuthServiceClient.GetAddresses);
        }
        private static UpsertAddress = new grpc_web_1.MethodDescriptor<UpsertAddressRequest, UpsertAddressResponse>("/auth.v1.AuthService/UpsertAddress", grpc_web_1.MethodType.UNARY, UpsertAddressRequest, UpsertAddressResponse, (message: UpsertAddressRequest) => message.serialize(), UpsertAddressResponse.deserialize);
        UpsertAddress(message: UpsertAddressRequest, metadata: grpc_web_1.Metadata | null) {
            return this._client.thenableCall<UpsertAddressRequest, UpsertAddressResponse>(this._address + "/auth.v1.AuthService/UpsertAddress", message, metadata || {}, AuthServiceClient.UpsertAddress);
        }
        private static DeleteAddress = new grpc_web_1.MethodDescriptor<DeleteAddressRequest, DeleteAddressResponse>("/auth.v1.AuthService/DeleteAddress", grpc_web_1.MethodType.UNARY, DeleteAddressRequest, DeleteAddressResponse, (message: DeleteAddressRequest) => message.serialize(), DeleteAddressResponse.deserialize);
        DeleteAddress(message: DeleteAddressRequest, metadata: grpc_web_1.Metadata | null) {
            return this._client.thenableCall<DeleteAddressRequest, DeleteAddressResponse>(this._address + "/auth.v1.AuthService/DeleteAddress", message, metadata || {}, AuthServiceClient.DeleteAddress);
        }
        private static UpdateAuthUser = new grpc_web_1.MethodDescriptor<UpdateAuthUserRequest, UpdateAuthUserResponse>("/auth.v1.AuthService/UpdateAuthUser", grpc_web_1.MethodType.UNARY, UpdateAuthUserRequest, UpdateAuthUserResponse, (message: UpdateAuthUserRequest) => message.serialize(), UpdateAuthUserResponse.deserialize);
        UpdateAuthUser(message: UpdateAuthUserRequest, metadata: grpc_web_1.Metadata | null) {
            return this._client.thenableCall<UpdateAuthUserRequest, UpdateAuthUserResponse>(this._address + "/auth.v1.AuthService/UpdateAuthUser", message, metadata || {}, AuthServiceClient.UpdateAuthUser);
        }
        private static StartPasswordChange = new grpc_web_1.MethodDescriptor<StartPasswordChangeRequest, StartPasswordChangeResponse>("/auth.v1.AuthService/StartPasswordChange", grpc_web_1.MethodType.UNARY, StartPasswordChangeRequest, StartPasswordChangeResponse, (message: StartPasswordChangeRequest) => message.serialize(), StartPasswordChangeResponse.deserialize);
        StartPasswordChange(message: StartPasswordChangeRequest, metadata: grpc_web_1.Metadata | null) {
            return this._client.thenableCall<StartPasswordChangeRequest, StartPasswordChangeResponse>(this._address + "/auth.v1.AuthService/StartPasswordChange", message, metadata || {}, AuthServiceClient.StartPasswordChange);
        }
        private static ConfirmPasswordChange = new grpc_web_1.MethodDescriptor<ConfirmPasswordChangeRequest, ConfirmPasswordChangeResponse>("/auth.v1.AuthService/ConfirmPasswordChange", grpc_web_1.MethodType.UNARY, ConfirmPasswordChangeRequest, ConfirmPasswordChangeResponse, (message: ConfirmPasswordChangeRequest) => message.serialize(), ConfirmPasswordChangeResponse.deserialize);
        ConfirmPasswordChange(message: ConfirmPasswordChangeRequest, metadata: grpc_web_1.Metadata | null) {
            return this._client.thenableCall<ConfirmPasswordChangeRequest, ConfirmPasswordChangeResponse>(this._address + "/auth.v1.AuthService/ConfirmPasswordChange", message, metadata || {}, AuthServiceClient.ConfirmPasswordChange);
        }
        private static VerifyPasswordChange = new grpc_web_1.MethodDescriptor<VerifyPasswordChangeRequest, VerifyPasswordChangeResponse>("/auth.v1.AuthService/VerifyPasswordChange", grpc_web_1.MethodType.UNARY, VerifyPasswordChangeRequest, VerifyPasswordChangeResponse, (message: VerifyPasswordChangeRequest) => message.serialize(), VerifyPasswordChangeResponse.deserialize);
        VerifyPasswordChange(message: VerifyPasswordChangeRequest, metadata: grpc_web_1.Metadata | null) {
            return this._client.thenableCall<VerifyPasswordChangeRequest, VerifyPasswordChangeResponse>(this._address + "/auth.v1.AuthService/VerifyPasswordChange", message, metadata || {}, AuthServiceClient.VerifyPasswordChange);
        }
        private static StartEmailChange = new grpc_web_1.MethodDescriptor<StartEmailChangeRequest, StartEmailChangeResponse>("/auth.v1.AuthService/StartEmailChange", grpc_web_1.MethodType.UNARY, StartEmailChangeRequest, StartEmailChangeResponse, (message: StartEmailChangeRequest) => message.serialize(), StartEmailChangeResponse.deserialize);
        StartEmailChange(message: StartEmailChangeRequest, metadata: grpc_web_1.Metadata | null) {
            return this._client.thenableCall<StartEmailChangeRequest, StartEmailChangeResponse>(this._address + "/auth.v1.AuthService/StartEmailChange", message, metadata || {}, AuthServiceClient.StartEmailChange);
        }
        private static VerifyEmailChange = new grpc_web_1.MethodDescriptor<VerifyEmailChangeRequest, VerifyEmailChangeResponse>("/auth.v1.AuthService/VerifyEmailChange", grpc_web_1.MethodType.UNARY, VerifyEmailChangeRequest, VerifyEmailChangeResponse, (message: VerifyEmailChangeRequest) => message.serialize(), VerifyEmailChangeResponse.deserialize);
        VerifyEmailChange(message: VerifyEmailChangeRequest, metadata: grpc_web_1.Metadata | null) {
            return this._client.thenableCall<VerifyEmailChangeRequest, VerifyEmailChangeResponse>(this._address + "/auth.v1.AuthService/VerifyEmailChange", message, metadata || {}, AuthServiceClient.VerifyEmailChange);
        }
        private static ChangeProfile = new grpc_web_1.MethodDescriptor<ChangeUserProfileRequest, ChangeUserProfileResponse>("/auth.v1.AuthService/ChangeProfile", grpc_web_1.MethodType.UNARY, ChangeUserProfileRequest, ChangeUserProfileResponse, (message: ChangeUserProfileRequest) => message.serialize(), ChangeUserProfileResponse.deserialize);
        ChangeProfile(message: ChangeUserProfileRequest, metadata: grpc_web_1.Metadata | null) {
            return this._client.thenableCall<ChangeUserProfileRequest, ChangeUserProfileResponse>(this._address + "/auth.v1.AuthService/ChangeProfile", message, metadata || {}, AuthServiceClient.ChangeProfile);
        }
        private static DeleteUser = new grpc_web_1.MethodDescriptor<DeleteUserRequest, DeleteUserResponse>("/auth.v1.AuthService/DeleteUser", grpc_web_1.MethodType.UNARY, DeleteUserRequest, DeleteUserResponse, (message: DeleteUserRequest) => message.serialize(), DeleteUserResponse.deserialize);
        DeleteUser(message: DeleteUserRequest, metadata: grpc_web_1.Metadata | null) {
            return this._client.thenableCall<DeleteUserRequest, DeleteUserResponse>(this._address + "/auth.v1.AuthService/DeleteUser", message, metadata || {}, AuthServiceClient.DeleteUser);
        }
        private static DeleteUserAdmin = new grpc_web_1.MethodDescriptor<DeleteUserAdminRequest, DeleteUserAdminResponse>("/auth.v1.AuthService/DeleteUserAdmin", grpc_web_1.MethodType.UNARY, DeleteUserAdminRequest, DeleteUserAdminResponse, (message: DeleteUserAdminRequest) => message.serialize(), DeleteUserAdminResponse.deserialize);
        DeleteUserAdmin(message: DeleteUserAdminRequest, metadata: grpc_web_1.Metadata | null) {
            return this._client.thenableCall<DeleteUserAdminRequest, DeleteUserAdminResponse>(this._address + "/auth.v1.AuthService/DeleteUserAdmin", message, metadata || {}, AuthServiceClient.DeleteUserAdmin);
        }
        private static MigrateUser = new grpc_web_1.MethodDescriptor<MigrateUserRequest, MigrateUserResponse>("/auth.v1.AuthService/MigrateUser", grpc_web_1.MethodType.UNARY, MigrateUserRequest, MigrateUserResponse, (message: MigrateUserRequest) => message.serialize(), MigrateUserResponse.deserialize);
        MigrateUser(message: MigrateUserRequest, metadata: grpc_web_1.Metadata | null) {
            return this._client.thenableCall<MigrateUserRequest, MigrateUserResponse>(this._address + "/auth.v1.AuthService/MigrateUser", message, metadata || {}, AuthServiceClient.MigrateUser);
        }
        private static GetUserMenu = new grpc_web_1.MethodDescriptor<GetUserMenuRequest, GetUserMenuResponse>("/auth.v1.AuthService/GetUserMenu", grpc_web_1.MethodType.UNARY, GetUserMenuRequest, GetUserMenuResponse, (message: GetUserMenuRequest) => message.serialize(), GetUserMenuResponse.deserialize);
        GetUserMenu(message: GetUserMenuRequest, metadata: grpc_web_1.Metadata | null) {
            return this._client.thenableCall<GetUserMenuRequest, GetUserMenuResponse>(this._address + "/auth.v1.AuthService/GetUserMenu", message, metadata || {}, AuthServiceClient.GetUserMenu);
        }
        private static GetUserPermissions = new grpc_web_1.MethodDescriptor<GetUserPermissionsRequest, GetUserPermissionsResponse>("/auth.v1.AuthService/GetUserPermissions", grpc_web_1.MethodType.UNARY, GetUserPermissionsRequest, GetUserPermissionsResponse, (message: GetUserPermissionsRequest) => message.serialize(), GetUserPermissionsResponse.deserialize);
        GetUserPermissions(message: GetUserPermissionsRequest, metadata: grpc_web_1.Metadata | null) {
            return this._client.thenableCall<GetUserPermissionsRequest, GetUserPermissionsResponse>(this._address + "/auth.v1.AuthService/GetUserPermissions", message, metadata || {}, AuthServiceClient.GetUserPermissions);
        }
        private static GetRoles = new grpc_web_1.MethodDescriptor<GetRolesRequest, GetRolesResponse>("/auth.v1.AuthService/GetRoles", grpc_web_1.MethodType.UNARY, GetRolesRequest, GetRolesResponse, (message: GetRolesRequest) => message.serialize(), GetRolesResponse.deserialize);
        GetRoles(message: GetRolesRequest, metadata: grpc_web_1.Metadata | null) {
            return this._client.thenableCall<GetRolesRequest, GetRolesResponse>(this._address + "/auth.v1.AuthService/GetRoles", message, metadata || {}, AuthServiceClient.GetRoles);
        }
        private static UpdateRoles = new grpc_web_1.MethodDescriptor<UpdateRolesRequest, UpdateRolesResponse>("/auth.v1.AuthService/UpdateRoles", grpc_web_1.MethodType.UNARY, UpdateRolesRequest, UpdateRolesResponse, (message: UpdateRolesRequest) => message.serialize(), UpdateRolesResponse.deserialize);
        UpdateRoles(message: UpdateRolesRequest, metadata: grpc_web_1.Metadata | null) {
            return this._client.thenableCall<UpdateRolesRequest, UpdateRolesResponse>(this._address + "/auth.v1.AuthService/UpdateRoles", message, metadata || {}, AuthServiceClient.UpdateRoles);
        }
    }
}
